/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 87);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06544404_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__(135);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06544404_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTeachers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getParentProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSchedule; });
/* unused harmony export getJustify */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getClassmates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getObservations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAssistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCourses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getExams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateFamilyProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setLogeo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getRolExamenes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cfg_core__ = __webpack_require__(14);




var login = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(username, password) {
    var user, response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            user = { username: username, password: password };
            _context.prev = 1;
            _context.next = 4;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/auth', {
              method: 'post',
              headers: { 'Content-Type': 'application/json' },
              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(user)
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            res = _context.sent;
            return _context.abrupt('return', res);

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](1);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context.t0.message);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 11]]);
  }));

  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getTeachers = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/teachers/' + id, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return response.json();

          case 6:
            res = _context2.sent;
            return _context2.abrupt('return', res);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context2.t0);

          case 13:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 10]]);
  }));

  return function getTeachers(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var getChildren = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(idFamilyGuy) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/family/children/' + idFamilyGuy, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context3.sent;
            _context3.next = 6;
            return response.json();

          case 6:
            res = _context3.sent;
            return _context3.abrupt('return', res);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context3.t0);

          case 13:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 10]]);
  }));

  return function getChildren(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var getProfile = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/profile/' + user, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return response.json();

          case 6:
            res = _context4.sent;
            return _context4.abrupt('return', res);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context4.t0);

          case 13:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[0, 10]]);
  }));

  return function getProfile(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

var getSchedule = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/schedule/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context5.sent;
            _context5.next = 6;
            return response.json();

          case 6:
            res = _context5.sent;
            return _context5.abrupt('return', res);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context5.t0);

          case 13:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this, [[0, 10]]);
  }));

  return function getSchedule(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

var getJustify = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(idStudentSchool, date) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/justify/' + idStudentSchool + '/' + date, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context6.sent;
            _context6.next = 6;
            return response.json();

          case 6:
            res = _context6.sent;
            return _context6.abrupt('return', res);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context6.t0);

          case 13:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this, [[0, 10]]);
  }));

  return function getJustify(_x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}();

var getClassmates = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/classmates/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context7.sent;
            _context7.next = 6;
            return response.json();

          case 6:
            res = _context7.sent;
            return _context7.abrupt('return', res);

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context7.t0);

          case 13:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this, [[0, 10]]);
  }));

  return function getClassmates(_x9) {
    return _ref7.apply(this, arguments);
  };
}();

var getObservations = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/observations/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 3:
            response = _context8.sent;
            _context8.next = 6;
            return response.json();

          case 6:
            res = _context8.sent;
            return _context8.abrupt('return', res);

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8['catch'](0);

            console.log('Error al realizar la petici\xF3n fetch: ' + _context8.t0);

          case 13:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this, [[0, 10]]);
  }));

  return function getObservations(_x10) {
    return _ref8.apply(this, arguments);
  };
}();

var getAssistance = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/assistance/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context9.sent;
            _context9.next = 5;
            return response.json();

          case 5:
            res = _context9.sent;
            return _context9.abrupt('return', res);

          case 7:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function getAssistance(_x11) {
    return _ref9.apply(this, arguments);
  };
}();

var getParents = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/parents/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context10.sent;
            _context10.next = 5;
            return response.json();

          case 5:
            res = _context10.sent;
            return _context10.abrupt('return', res);

          case 7:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function getParents(_x12) {
    return _ref10.apply(this, arguments);
  };
}();

var getCourses = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/courses/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context11.sent;
            _context11.next = 5;
            return response.json();

          case 5:
            res = _context11.sent;
            return _context11.abrupt('return', res);

          case 7:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function getCourses(_x13) {
    return _ref11.apply(this, arguments);
  };
}();

var getExams = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/exams/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context12.sent;
            _context12.next = 5;
            return response.json();

          case 5:
            res = _context12.sent;

            console.log(res);
            return _context12.abrupt('return', res);

          case 8:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function getExams(_x14) {
    return _ref12.apply(this, arguments);
  };
}();

var getParentProfile = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(idParent) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/family/profile/' + idParent, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context13.sent;
            _context13.next = 5;
            return response.json();

          case 5:
            res = _context13.sent;
            return _context13.abrupt('return', res);

          case 7:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function getParentProfile(_x15) {
    return _ref13.apply(this, arguments);
  };
}();

var getPayment = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/payment/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context14.sent;
            _context14.next = 5;
            return response.json();

          case 5:
            res = _context14.sent;
            return _context14.abrupt('return', res);

          case 7:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function getPayment(_x16) {
    return _ref14.apply(this, arguments);
  };
}();

var getEvent = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(idStudentSchool) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/events/' + idStudentSchool, {
              method: 'get',
              headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) }
            });

          case 2:
            response = _context15.sent;
            _context15.next = 5;
            return response.json();

          case 5:
            res = _context15.sent;
            return _context15.abrupt('return', res);

          case 7:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function getEvent(_x17) {
    return _ref15.apply(this, arguments);
  };
}();

var updateFamilyProfile = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(idFamily, nombre, apellidos, dni, telefono, email, direccion) {
    var family, response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            family = { nombre: nombre, apellidos: apellidos, dni: dni, telefono: telefono, email: email, direccion: direccion };

            console.log('famidFamilyily', idFamily);
            _context16.next = 4;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/parents/' + idFamily, {
              method: 'put',
              headers: {
                'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]),
                'Content-Type': 'application/json'
              },
              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(family)
            });

          case 4:
            response = _context16.sent;
            _context16.next = 7;
            return response.json();

          case 7:
            res = _context16.sent;
            return _context16.abrupt('return', res);

          case 9:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function updateFamilyProfile(_x18, _x19, _x20, _x21, _x22, _x23, _x24) {
    return _ref16.apply(this, arguments);
  };
}();

var setLogeo = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(idClient, type) {
    var response, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/intranet/' + idClient + '/' + type, {
              method: 'get',
              headers: {
                'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */])
              }
            });

          case 2:
            response = _context17.sent;
            _context17.next = 5;
            return response.json();

          case 5:
            res = _context17.sent;
            return _context17.abrupt('return', res);

          case 7:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function setLogeo(_x25, _x26) {
    return _ref17.apply(this, arguments);
  };
}();

var getRolExamenes = function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(idAlumno) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/student/rolexams/' + idAlumno, { method: 'get', headers: { 'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]) } });

          case 2:
            response = _context18.sent;
            _context18.next = 5;
            return response.json();

          case 5:
            return _context18.abrupt('return', _context18.sent);

          case 6:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, this);
  }));

  return function getRolExamenes(_x27) {
    return _ref18.apply(this, arguments);
  };
}();



function updateImage(image) {
  fetch(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["a" /* host */] + '/family/image', {
    method: 'post',
    headers: {
      'authorization': localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */])
    },
    body: image
  });
}



/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(94);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(97);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(43)('wks');
var uid = __webpack_require__(44);
var Symbol = __webpack_require__(6).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc9a29be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(143);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc9a29be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(41);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(40)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return host; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return token; });
var host = 'https://intranet.cima.com.pe:8443/api/school';
// const host = 'http://localhost:3000/api/school';
//const host = 'http://192.168.70.13:3000/api/school';
var token = '186792bf11c51e92ed5eba02424312ac';



/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(9);
var ctx = __webpack_require__(21);
var hide = __webpack_require__(12);
var has = __webpack_require__(23);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(102);
var toPrimitive = __webpack_require__(103);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_colegio.svg?8a24ce7e3a9041eda92ddea6eb07114e";

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
function formatDate(year, month, day) {
  var date = '',
      myMonth = '';
  switch (month) {
    case '01':
      {
        myMonth = 'enero';break;
      }
    case '02':
      {
        myMonth = 'febrero';break;
      }
    case '03':
      {
        myMonth = 'marzo';break;
      }
    case '04':
      {
        myMonth = 'abril';break;
      }
    case '05':
      {
        myMonth = 'mayo';break;
      }
    case '06':
      {
        myMonth = 'junio';break;
      }
    case '07':
      {
        myMonth = 'julio';break;
      }
    case '08':
      {
        myMonth = 'agosto';break;
      }
    case '09':
      {
        myMonth = 'septiembre';break;
      }
    case '10':
      {
        myMonth = 'octubre';break;
      }
    case '11':
      {
        myMonth = 'noviembre';break;
      }
    case '12':
      {
        myMonth = 'diciembre';break;
      }
  }
  date = day + ' de ' + myMonth;
  if (year && year != '') {
    date += ' del ' + year;
  }
  return date;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(22);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72041b36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__ = __webpack_require__(153);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72041b36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3d3240_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Tab_vue__ = __webpack_require__(154);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3d3240_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.16';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28), __webpack_require__(88).setImmediate))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(6).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(110);
var defined = __webpack_require__(30);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(43)('keys');
var uid = __webpack_require__(44);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(23);
var TAG = __webpack_require__(8)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(22);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(133);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cfg_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Spinner__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_6__global_Spinner__["a" /* default */] },
  data: function data() {
    return {
      user: null,
      error: false,
      password: null,
      viewSpinner: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, myToken, type, idUser, report, _idUser, _report, profile;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.user && _this.password)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["o" /* login */])(_this.user, _this.password);

              case 3:
                res = _context.sent;

                if (!res.success) {
                  _context.next = 31;
                  break;
                }

                myToken = res.token;
                type = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(myToken).type;
                idUser = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(myToken).login;

                _this.showSpinner();

                localStorage.setItem(__WEBPACK_IMPORTED_MODULE_4__cfg_core__["b" /* token */], myToken);

                if (!(type === 'student')) {
                  _context.next = 19;
                  break;
                }

                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["k" /* getProfile */])(idUser);

              case 13:
                report = _context.sent;

                console.log('profile', report);
                localStorage.setItem('cima-estudiante', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(report.data));
                _this.$router.replace('/Dashboard', function () {
                  _this.user = '';
                  _this.password = '';
                });
                _context.next = 29;
                break;

              case 19:
                _idUser = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(myToken).id;
                _context.next = 22;
                return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["b" /* getChildren */])(_idUser);

              case 22:
                _report = _context.sent;
                _context.next = 25;
                return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["h" /* getParentProfile */])(_idUser);

              case 25:
                profile = _context.sent;

                localStorage.setItem('cima-children', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_report.data));
                localStorage.setItem('cima-parent-profile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(profile.data));
                _this.$router.replace('/Familyguy', function () {
                  _this.user = '';
                  _this.password = '';
                });

              case 29:
                _context.next = 32;
                break;

              case 31:
                _this.error = res.message;

              case 32:
                _context.next = 35;
                break;

              case 34:
                _this.error = 'Debe ingresar usuario y contraseña';

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showSpinner: function showSpinner() {
      this.viewSpinner = true;
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(31);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(104);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(18);
var $iterCreate = __webpack_require__(105);
var setToStringTag = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(113);
var ITERATOR = __webpack_require__(8)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(29);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var global = __webpack_require__(6);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(31) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(6).document;
module.exports = document && document.documentElement;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(24);
var TAG = __webpack_require__(8)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(11);
var aFunction = __webpack_require__(22);
var SPECIES = __webpack_require__(8)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(21);
var invoke = __webpack_require__(125);
var html = __webpack_require__(46);
var cel = __webpack_require__(32);
var global = __webpack_require__(6);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(24)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(36);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['size']
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navigation__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Children__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Navigation: __WEBPACK_IMPORTED_MODULE_2__Navigation__["a" /* default */], Children: __WEBPACK_IMPORTED_MODULE_3__Children__["a" /* default */] },
  data: function data() {
    return {
      children: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var idClient, type, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.children = localStorage.getItem('cima-children') != null;
              idClient = void 0, type = 0;

              if (localStorage.getItem('cima-parent-profile')) {
                idClient = JSON.parse(localStorage.getItem('cima-parent-profile')).id;
                type = 1;
              } else if (localStorage.getItem('cima-estudiante')) {
                idClient = JSON.parse(localStorage.getItem('cima-estudiante')).idalumnocolegio;
                type = 2;
              }

              if (!(type != 0)) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["p" /* setLogeo */])(idClient, type);

            case 6:
              res = _context.sent;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    viewNavigation: function viewNavigation() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$emit('showNavigation');
    },
    showChildren: function showChildren() {
      localStorage.removeItem('cima-estudiante-asistencia');
      localStorage.removeItem('cima-estudiante-classmates');
      localStorage.removeItem('cima-estudiante-cursos');
      localStorage.removeItem('cima-reporte-simulacros');
      localStorage.removeItem('cima-estudiante-observations');
      localStorage.removeItem('cima-estudiante-parents');
      localStorage.removeItem('cima-estudiante-horario');
      localStorage.removeItem('cima-estudiante-profesores');
      localStorage.removeItem('cima-estudiante-events');
      localStorage.removeItem('cima-estudiante-rol-examenes');
      localStorage.removeItem('cima-estudiante-payment');
      this.$router.push("/Familyguy");
    },
    reload: function reload() {
      var path = this.$router.history.current.path;
      localStorage.removeItem('cima-estudiante-asistencia');
      localStorage.removeItem('cima-estudiante-classmates');
      localStorage.removeItem('cima-estudiante-cursos');
      localStorage.removeItem('cima-reporte-simulacros');
      localStorage.removeItem('cima-estudiante-observations');
      localStorage.removeItem('cima-estudiante-parents');
      localStorage.removeItem('cima-estudiante-horario');
      localStorage.removeItem('cima-estudiante-profesores');
      localStorage.removeItem('cima-estudiante-events');
      localStorage.removeItem('cima-estudiante-rol-examenes');
      localStorage.removeItem('cima-estudiante-payment');
      this.$router.go(path);
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cfg_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(7);


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__global_Spinner__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_2__global_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      name: null,
      image: null,
      navList: null,
      nivel: null,
      showModal: false
    };
  },
  created: function created() {
    var _this = this;

    // Listen for the showNavigation event
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$on('showNavigation', function () {
      _this.navList.classList.toggle('is-show');
    });
  },
  mounted: function mounted() {
    this.getData();
    this.render();
  },

  methods: (_methods = {
    getData: function getData() {
      var report = JSON.parse(localStorage.getItem('cima-estudiante'));
      var idPerson = report.idpersona;
      this.image = 'https://intranet.cima.com.pe/v4cima/vista/fotosalumno/' + idPerson + '.jpg';
      this.name = report.nombre + ' ' + report.apellido;
      this.navList = document.getElementById('navList');
      this.nivel = report.idnivel;
    },
    render: function render() {
      var _this2 = this;

      //  Breakpoint
      var MediumBp = matchMedia('(min-width: 1170px)');
      var changeSize = function changeSize(mql) {
        if (mql.matches) {
          _this2.navList.classList.add('is-show');
        } else {
          _this2.navList.classList.remove('is-show');
        }
      };

      MediumBp.addListener(changeSize);
      changeSize(MediumBp);
    },
    detectedImages: function detectedImages() {
      this.image = 'dist/user.png';
    },
    logout: function logout() {
      this.showModal = true;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'logout', function logout() {
    this.showModal = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'cancelLogout', function cancelLogout() {
    this.showModal = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'sendLogout', function sendLogout() {
    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__cfg_core__["b" /* token */]);
    localStorage.removeItem('cima-estudiante');
    localStorage.removeItem('cima-children');
    localStorage.removeItem('idTurn');
    localStorage.removeItem('cima-estudiante-asistencia');
    localStorage.removeItem('cima-estudiante-classmates');
    localStorage.removeItem('cima-estudiante-cursos');
    localStorage.removeItem('cima-reporte-simulacros');
    localStorage.removeItem('cima-estudiante-observations');
    localStorage.removeItem('cima-estudiante-parents');
    localStorage.removeItem('cima-estudiante-horario');
    localStorage.removeItem('cima-estudiante-profesores');
    localStorage.removeItem('cima-parent-profile');
    localStorage.removeItem('cima-estudiante-events');
    localStorage.removeItem('cima-estudiante-rol-examenes');
    localStorage.removeItem('cima-estudiante-payment');
    this.$router.replace('/');
  }), _methods)
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',

  props: {
    active: Boolean,
    alert: {
      type: Boolean,
      default: false
    }
  },

  created: function created() {
    this.onEsc();
  },
  data: function data() {
    return {
      isVisible: false
    };
  },


  methods: {
    close: function close() {
      this.$emit('update:active', false);
    },
    onEsc: function onEsc() {
      var _this = this;

      document.body.addEventListener("keyup", function (e) {
        if (e.keyCode === 27) {
          _this.close();
        }
      });
    }
  },

  computed: {
    status: function status() {
      this.isVisible = this.active;
      return this.isVisible;
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_Menu__ = __webpack_require__(146);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Menu: __WEBPACK_IMPORTED_MODULE_1__global_Menu__["a" /* default */]
  },
  data: function data() {
    return {
      children: []
    };
  },
  mounted: function mounted() {
    var alumn = JSON.parse(localStorage.getItem('cima-estudiante'));
    var children = JSON.parse(localStorage.getItem('cima-children'));
    var index = -1;
    children.map(function (el) {
      if (el.idpersona == alumn.idpersona) {
        index = children.indexOf(el);
      }
    });
    children.splice(index, 1);
    this.children = children;
  },

  methods: {
    changeChildren: function changeChildren(data) {
      // let path = this.$router.history.current.path;
      localStorage.removeItem('cima-estudiante-asistencia');
      localStorage.removeItem('cima-estudiante-classmates');
      localStorage.removeItem('cima-estudiante-cursos');
      localStorage.removeItem('cima-reporte-simulacros');
      localStorage.removeItem('cima-estudiante-observations');
      localStorage.removeItem('cima-estudiante-parents');
      localStorage.removeItem('cima-estudiante-horario');
      localStorage.removeItem('cima-estudiante-profesores');
      localStorage.removeItem('cima-estudiante-events');
      localStorage.removeItem('cima-estudiante-rol-examenes');
      localStorage.removeItem('cima-estudiante-payment');
      localStorage.setItem('cima-estudiante', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      this.$router.replace('/Dashboard');
      location.reload();
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Menu",
  data: function data() {
    return {
      isVisible: false,
      children: []
    };
  },
  mounted: function mounted() {
    this.children = JSON.parse(localStorage.getItem('cima-children'));
  },

  methods: {
    outside: function outside() {
      this.isVisible = false;
    },
    inside: function inside() {
      console.log("clicked inside!");
    }
  },
  directives: {
    "click-outside": {
      bind: function bind(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          var compName = vNode.context.name;
          var warn = "[Vue-click-outside:] provided expression '" + binding.expression + "' is not a function, but has to be";
          if (compName) {
            warn += "Found in component '" + compName + "'";
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        var bubble = binding.modifiers.bubble;
        var handler = function handler(e) {
          if (bubble || !el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function unbind(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_Spinner__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_0__global_Spinner__["a" /* default */] },
  data: function data() {
    return {
      report: null,
      image: null
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      this.report = JSON.parse(localStorage.getItem('cima-estudiante'));
      this.image = 'https://intranet.cima.com.pe/v4cima/vista/fotosalumno/' + this.report.idpersona + '.jpg';
      localStorage.setItem('idTurn', this.report.idturno);
    },
    detectedImages: function detectedImages() {
      this.image = 'dist/user.png';
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Tabs__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Tab__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_fetchFunctions__ = __webpack_require__(3);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_5__global_Spinner__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_3__global_Tabs__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_4__global_Tab__["a" /* default */]
  },
  data: function data() {
    return {
      report: null,
      nota: 18
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-observations')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_6__functions_fetchFunctions__["g" /* getObservations */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                localStorage.setItem('cima-estudiante-observations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem('cima-estudiante-observations'));

              case 11:
                _this2.report = res;
                _this2.report.map(function (el) {
                  el.observaciones.map(function (obs) {
                    _this2.nota += parseInt(obs.puntos);
                    obs.reportadopor = obs.reportadopor.replace('<b>', '');
                    obs.reportadopor = obs.reportadopor.replace('</b>', '');
                  });
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    isTrue: function isTrue(el) {
      if (el == 0) {
        return "true";
      }
    },
    rename: function rename(el) {
      return el + "\xB0 BIMESTRE";
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tabs: []
    };
  },
  created: function created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab: function selectTab(_selectTab) {
      this.tabs.forEach(function (el) {
        el.isActive = el.name == _selectTab.name;
      });
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: { required: true },
    selected: { default: false }
  },

  data: function data() {
    return {
      isActive: false
    };
  },
  mounted: function mounted() {
    this.isActive = this.selected;
  },


  computed: {
    // href() {
    //   return '#' + this.name.toLowerCase().replace(/ /g , '-');
    // }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__ = __webpack_require__(3);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_3__global_Spinner__["a" /* default */] },
  data: function data() {
    return {
      report: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-profesores')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__["n" /* getTeachers */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                localStorage.setItem('cima-estudiante-profesores', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem('cima-estudiante-profesores'));

              case 11:
                _this2.report = res;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getText: function getText(el) {
      var text = '';
      el.map(function (t) {
        text += t.asignatura + ', ';
      });
      return text.substring(0, text.length - 2);
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Spinner__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_4__global_Spinner__["a" /* default */] },
  data: function data() {
    return {
      report: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-classmates')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__["c" /* getClassmates */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                localStorage.setItem('cima-estudiante-classmates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem('cima-estudiante-classmates'));

              case 11:

                _this2.report = res;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }

});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Calendar__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_Report__ = __webpack_require__(67);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Assistance',
  data: function data() {
    return {
      dataStudent: null,
      report: null,
      idTurn: null,
      turn: null,
      justify: null,
      test: null,
      showModalJustify: true,
      showModal: false,
      activeNotification: true
    };
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__global_Modal__["a" /* default */],
    Report: __WEBPACK_IMPORTED_MODULE_8__global_Report__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_6__global_Spinner__["a" /* default */],
    Calendar: __WEBPACK_IMPORTED_MODULE_7__global_Calendar__["a" /* default */]
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$on('viewJustify', function (data) {
      _this.justify = data;
      _this.showModal = data.showModal;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getData();

            case 2:
              _this2.checkTurn();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },


  methods: {
    getData: function getData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-asistencia')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__["a" /* getAssistance */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                _this3.report = res.data;
                localStorage.setItem('cima-estudiante-asistencia', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.report));
                _context2.next = 11;
                break;

              case 10:
                _this3.report = JSON.parse(localStorage.getItem('cima-estudiante-asistencia'));

              case 11:

                _this3.idTurn = localStorage.getItem('idTurn');

                _this3.report.reverse();

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    checkTurn: function checkTurn() {
      if (this.idTurn == 1) {
        this.turn = true;
      } else {
        this.turn = false;
      }
    },
    checkMorning: function checkMorning() {
      this.turn = true;
      this.activeNotification = true;
    },
    checkAfternoon: function checkAfternoon() {
      this.turn = false;
      this.activeNotification = false;
    },
    viewReport: function viewReport() {
      // this.showModalJustify = false;
      __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$emit('showReport');
      this.getDataStudent();
    },
    getDataStudent: function getDataStudent() {
      this.dataStudent = JSON.parse(localStorage.getItem('cima-estudiante'));
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cfg_core__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Calendar',

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* default */]
  },

  props: ['data', 'idTurn', 'turn', 'showModalJustify', 'activeNotification'],

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('sendJustification', function (data) {});
  },
  data: function data() {
    return {
      report: null
    };
  },


  methods: {
    colorState: function colorState(day) {
      var classColor = void 0;

      if (day.dia != 'auxiliar') {
        if (this.idTurn == 1) {
          // Turno mañana
          // this.activeNotification = true;
          if (this.turn) {
            if (day.estado_am == '[F]' && day.am == '') {
              classColor = 'absence';
            } else if (day.estado_am == '[T]' && day.am != '') {
              classColor = 'delay';
            } else if (day.estado_am == '' && day.am != '') {
              classColor = 'arrive';
            } else if (day.estado_am == '[J]' && day.am == '') {
              classColor = 'justify';
            }
            // si viene en turno tarde
          } else {
            // this.activeNotification = false;
            if (!this.turn) {
              if (day.estado_pm == '' && day.pm == '[F]') {
                classColor = '';
              } else if (day.estado_pm == '' && day.pm != '[F]') {
                classColor = 'arrive';
              }
            }
          }
        } else if (this.idTurn == 2) {
          if (!this.turn) {
            // codigo para turno tarde
          } else {
            if (this.turn) {}
          }
        }
      }

      if (day.nro_dia == 0) {
        classColor = '';
      }

      return classColor;
    },
    getDay: function getDay(day) {
      if (day == 'auxiliar') {
        return '';
      } else {
        return day;
      }
    },
    viewHour: function viewHour(day) {
      var hour = void 0;
      if (this.idTurn == 1) {
        if (this.turn) {
          if (day.am != '') {
            hour = day.am;
          } else {
            hour = '-';
          }
        } else {
          if (day.pm != '[F]') {
            hour = day.pm;
          } else {
            hour = '-';
          }
        }
      } else {
        if (!this.turn) {
          if (day.am != '[F]') {
            hour = day.am;
          } else {
            hour = '';
          }
        } else {
          if (day.pm != '') {
            hour = day.pm;
          } else {
            hour = '';
          }
        }
      }

      return hour;
    },
    viewJustify: function viewJustify(day, month) {
      if (day.dia != undefined && day.dia != 0 && day.justificacion != null && day.estado_am != undefined && this.showModalJustify == true && day.nro_dia) {
        if (this.turn) {
          var send = {
            report: day.justificacion,
            month: month,
            day: day.dia,
            showModal: true
          };
          __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('viewJustify', send);
        }
      }
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Notification',
  props: ['active']
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27feaf66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__(165);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27feaf66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import the EventBus.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Report',
  data: function data() {
    return {
      isVisible: false
    };
  },
  created: function created() {
    var _this = this;

    // Listen for the showReport event
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('showReport', function () {
      return _this.isVisible = true;
    });
  },
  mounted: function mounted() {
    this.eventKey();
  },


  methods: {
    hidenModal: function hidenModal() {
      this.isVisible = false;
    },
    eventKey: function eventKey() {
      var _this2 = this;

      document.body.addEventListener("keyup", function (e) {
        if (e.keyCode === 27) {
          _this2.hidenModal();
        }
      });
    },
    print: function print(idReport) {
      var report = document.getElementById(idReport);
      var style = document.styleSheets;

      var rules = [];
      var styleString = '';

      for (var i = 0; i < style.length; i++) {
        rules.push(style[i].cssRules);
        for (var j = 0; j < rules[i].length; j++) {
          styleString += rules[i][j].cssText;
        }
      }

      var print = "<!DOCTYPE html>" + "<html lang='en'>" + "<head>" + "<style>" + styleString + "</style>" + "<meta charset='UTF-8'>" + "<meta name='viewport' content='width=device-width, initial-scale=1.0'>" + "<title>Reporte</title>" + "<style> button {display: none}</style>" + "</head>" + "<body onload='window.print();window.close()' class='container'>";

      print += report.outerHTML + "</body>" + "</html>";

      var printWindow = window.open("", "_blank");
      printWindow.document.write(print);
      printWindow.document.close();
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cropperjs__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Spinner__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__global_Spinner__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_5__global_Modal__["a" /* default */],
    VueCropper: __WEBPACK_IMPORTED_MODULE_4_vue_cropperjs___default.a
  },
  data: function data() {
    return {
      report: null,
      isEditing: null,
      dataEdit: false,
      photoEdit: false,
      imgId: null,
      imgEl: null,
      imgSrc: "",
      cropImg: "",
      type: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem("cima-estudiante-parents")) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem("cima-estudiante"));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__["i" /* getParents */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                localStorage.setItem("cima-estudiante-parents", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem("cima-estudiante-parents"));

              case 11:
                _this2.report = res;
                _this2.type = localStorage.getItem('cima-parent-profile') ? 0 : 1;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    detectedImages: function detectedImages(el) {
      var i = this.report.indexOf(el);
      if (this.report[i] != undefined) {
        this.report[i].url_imagen = "dist/user.png";
      }
    },
    edit: function edit(data) {
      this.dataEdit = true;
      this.isEditing = data;
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                res = void 0;
                data = _this3.isEditing;
                _context3.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__["q" /* updateFamilyProfile */])(data.idperson, data.nombre, data.apellidos, data.dni, data.telefono, data.email, data.direccion);

              case 4:
                res = _context3.sent;

                _this3.dataEdit = false;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setImage: function setImage(el) {
      var _this4 = this;

      var avatar = document.getElementById("avatar" + el),
          input = document.getElementById("upload-image" + el);

      this.imgId = el;

      input.addEventListener('change', function (e) {
        _this4.photoEdit = true;
        _this4.imgEl = avatar;

        var file = e.target.files[0];
        if (!file.type.includes("image/")) {
          // alert('Please select an image file');
          return;
        }
        if (typeof FileReader === "function") {
          var reader = new FileReader();
          reader.onload = function (event) {
            _this4.imgSrc = event.target.result;
            _this4.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
        } else {
          alert("Sorry, FileReader API not supported");
        }
      });
    },
    cropDestroy: function cropDestroy() {
      this.$refs.cropper.destroy();
      this.photoEdit = false;
    },
    cropReset: function cropReset() {
      this.$refs.cropper.reset();
    },
    cropImage: function cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    saveImage: function saveImage() {
      var _this5 = this;

      this.cropImg = this.$refs.cropper.getCroppedCanvas({
        width: 150,
        height: 200,
        fillColor: '#fff'
      });
      this.imgEl.src = this.cropImg.toDataURL();
      this.cropImg.toBlob(function (blob) {
        var formData = new FormData();
        // console.log('blob', blob);
        formData.append('photo', blob, _this5.imgId + ".jpg");
        Object(__WEBPACK_IMPORTED_MODULE_3__functions_fetchFunctions__["r" /* updateImage */])(formData);
      });
      this.$refs.cropper.destroy();
      this.photoEdit = false;
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(172)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__ = __webpack_require__(3);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_3__global_Spinner__["a" /* default */] },
  data: function data() {
    return {
      report: null,
      heigth_horas: 0,
      width_dias: 0,
      errors: null,
      alumno: null,
      id: [],
      colors: ["EF9A9A", "D7CCC8", "B2EBF2", "FFF9C4", "E0E0E0", "78909C", "A5D6A7", "C5CAE9", "FFCC80", "E1BEE7", "F0F4C3", "C8E6C9", "FFCCBC", "F48FB1", "F8BBD0", "FDD835", "FFCDD2", "E3F2FD", "FFE0B2", "FFEBEE"]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, horas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                _this2.alumno = JSON.parse(localStorage.getItem("cima-estudiante"));

                if (localStorage.getItem("cima-estudiante-horario")) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__["m" /* getSchedule */])(_this2.alumno.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data ? res.data : res;
                if (res.data) localStorage.setItem("cima-estudiante-horario", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem("cima-estudiante-horario"));

              case 11:
                _this2.report = res;
                horas = [];

                if (!res.err) {
                  _this2.report[0].cursos.map(function (curso) {
                    curso.horas.map(function (hora) {
                      horas.push(hora);
                    });
                  });
                  _this2.report.horas = horas;
                  _this2.heigth_horas = 100 / _this2.report.horas.length;
                  _this2.width_dias = 100 / _this2.report.length;
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    print: function print(idReport) {
      var report = document.getElementById(idReport);
      var style = document.styleSheets;

      var rules = [];
      var styleString = "";

      for (var i = 0; i < style.length; i++) {
        rules.push(style[i].cssRules);
        for (var j = 0; j < rules[i].length; j++) {
          styleString += rules[i][j].cssText;
        }
      }

      var print = "<!DOCTYPE html>" + "<html lang='en'>" + "<head>" + "<style>" + styleString + "</style>" + "<meta charset='UTF-8'>" + "<meta name='viewport' content='width=device-width, initial-scale=1.0'>" + "<title>Reporte</title>" + "<style> button {display: none}</style>" + "</head>" + "<body onload='window.print();window.close()' class='container'>";

      print += report.outerHTML + "</body>" + "</html>";

      var printWindow = window.open("", "_blank");
      printWindow.document.write(print);
      printWindow.document.close();
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cfg_core__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__global_Modal__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_2__global_Spinner__["a" /* default */]
  },
  data: function data() {
    return {
      report: null,
      profile: null,
      image: null,
      showModal: false
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    getData: function getData() {
      this.report = JSON.parse(localStorage.getItem('cima-children'));
      this.profile = JSON.parse(localStorage.getItem('cima-parent-profile'));
      this.image = 'https://intranet.cima.com.pe/v4cima/vista/fotospadres/' + this.profile.id + '.jpg';
      this.report.map(function (el) {
        el.url_imagen = 'https://intranet.cima.com.pe/v4cima/vista/fotosalumno/' + el.idpersona + '.jpg';
      });
    },
    setChild: function setChild(index) {
      var child = this.report[index];
      localStorage.setItem('cima-estudiante', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(child));
      this.$router.push("/Dashboard");
    },
    detectedImages: function detectedImages() {
      this.image = 'dist/user.png';
    },
    logout: function logout() {
      this.showModal = true;
    },
    cancelLogout: function cancelLogout() {
      this.showModal = false;
    },
    sendLogout: function sendLogout() {
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]);
      localStorage.removeItem('cima-estudiante');
      localStorage.removeItem('cima-children');
      localStorage.removeItem('idTurn');
      localStorage.removeItem('cima-estudiante-asistencia');
      localStorage.removeItem('cima-estudiante-classmates');
      localStorage.removeItem('cima-estudiante-cursos');
      localStorage.removeItem('cima-reporte-simulacros');
      localStorage.removeItem('cima-estudiante-observations');
      localStorage.removeItem('cima-estudiante-parents');
      localStorage.removeItem('cima-estudiante-horario');
      localStorage.removeItem('cima-estudiante-profesores');
      localStorage.removeItem('cima-parent-profile');
      localStorage.removeItem('cima-estudiante-events');
      this.$router.replace('/');
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_formatDate__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Tabs__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_Tab__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_Report__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Course__ = __webpack_require__(181);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__global_Spinner__["a" /* default */],
    Course: __WEBPACK_IMPORTED_MODULE_11__Course__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_9__global_Modal__["a" /* default */],
    Report: __WEBPACK_IMPORTED_MODULE_10__global_Report__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_7__global_Tabs__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_8__global_Tab__["a" /* default */]
  },
  data: function data() {
    return {
      report: null,
      detailExam: null,
      showModal: false,
      reportPrint: null,
      dataStudent: null,
      section: null,
      weightCourses: null,
      weightCourse: null
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$on("viewDetailExam", function (data) {
      _this.detailExam = data;
      var grupo = {
        grupo: "CÁLCULO DEL PROMEDIO",
        isCalc: true,
        notas: [],
        total: 0
      };

      var auxWeight = _this.weightCourses;
      auxWeight.map(function (el) {
        if (el.idareacurricular == data.idCourse) {
          _this.weightCourse = el.pesos;
        }
      });

      _this.weightCourse.map(function (el) {
        el.nota = -1;
        el.puntos = -1;
      });

      var i = 0;
      var total = 0;

      _this.detailExam.groups.map(function (el) {
        if (el.isCalc) {
          i = 1;
        } else {
          _this.weightCourse.map(function (data) {
            if (data.grupo_evaluacion == el.grupo) {
              data.nota = el.promedio;
              data.puntos = Math.round(parseFloat(el.peso) / 100.0 * parseFloat(el.promedio) * 100) / 100;
            }
          });

          grupo.notas = _this.weightCourse;
          total += el.isnull ? 0 : parseFloat(el.peso) / 100.0 * parseFloat(el.promedio);
        }
      });
      total = Math.round(total * 100) / 100;
      grupo.total = total;
      if (i != 1) {
        _this.detailExam.groups.push(grupo);
      }
      _this.showModal = true;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getData();

            case 2:
              _this2.resetDetailExam;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                console.log("qwqwq");
                data = JSON.parse(localStorage.getItem("cima-estudiante"));

                console.log(data.idalumnocolegio);

                if (localStorage.getItem("cima-estudiante-cursos")) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__["d" /* getCourses */])(data.idalumnocolegio);

              case 7:
                res = _context2.sent;

                res = res.data;
                console.log("marz 23", res);
                localStorage.setItem("cima-estudiante-cursos", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 15;
                break;

              case 13:
                res = JSON.parse(localStorage.getItem("cima-estudiante-cursos"));
                console.log("sss");

              case 15:
                _this3.report = res;
                _this3.printReport();
                _this3.weightCourses = _this3.report[0].pesos;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    isTrue: function isTrue(el) {
      if (el == 0) {
        return "true";
      }
    },
    rename: function rename(el) {
      return el + "\xB0 BIMESTRE";
    },
    format: function format(el) {
      var dates = el.split("-");
      var date = Object(__WEBPACK_IMPORTED_MODULE_5__functions_formatDate__["a" /* formatDate */])(dates[0], dates[1], dates[2]);
      return date;
    },
    viewReport: function viewReport() {
      this.dataStudent = JSON.parse(localStorage.getItem("cima-estudiante"));
      // this.showModalJustify = false;
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit("showReport");
    },
    printReport: function printReport() {
      var _this4 = this;

      if (this.report[0].examenes == null) return;
      this.reportPrint = this.report[0].examenes;
      var areas = [];
      var cursos = [];
      var notas = [];
      this.reportPrint.map(function (el) {
        el.cursos.map(function (curso) {
          var area = curso.area;
          if (!areas.includes(area)) {
            areas.push(area);
          }
        });
      });
      areas.map(function (area) {
        var mc = [];
        _this4.reportPrint.map(function (el) {
          var bimestre = el.bimestre;
          el.cursos.map(function (curso) {
            if (area == curso.area && !mc.includes(curso.curso)) {
              mc.push(curso.curso);
            }
          });
        });
        cursos.push(mc);
      });
      cursos.map(function (curso) {
        curso.map(function (el) {
          var nt = [];
          var prom = 0;
          var cont = 0;
          _this4.reportPrint.map(function (ec) {
            var bimestre = ec.bimestre;
            ec.cursos.map(function (cur) {
              if (el == cur.curso) {
                prom += cur.promedio;
                cont++;
                nt.push({
                  nota: Math.round(cur.promedio) < 10 ? "0" + Math.round(cur.promedio) : Math.round(cur.promedio),
                  bimestre: bimestre,
                  minima: cur.notaminima
                });
              }
            });
          });
          var promedio = parseFloat(prom) / parseFloat(cont);
          promedio = Math.round(promedio) < 10 ? "0" + Math.round(promedio) : Math.round(promedio);
          notas.push({
            curso: el,
            notas: nt,
            promedio: promedio
          });
        });
      });
      cursos.map(function (curso) {
        var prom = 0;
        var cont = 0;
        var cu = [];
        var min = notas[0].notas[0].minima;
        notas.map(function (nota) {
          if (curso.includes(nota.curso)) {
            cu.push(nota);
          }
        });
        var index = cursos.indexOf(curso);
        var area = areas[index];
        cu.map(function (el) {
          prom += parseInt(el.promedio);
          cont++;
        });
        var p = parseFloat(prom) / parseFloat(cont);
        areas[index] = {
          area: area,
          cursos: cu,
          promedio: Math.round(p) < 10 ? "0" + Math.round(p) : Math.round(p),
          minima: min
        };
      });
      this.reportPrint = areas;
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Course',
  props: ['data'],
  methods: {
    viewDetailExam: function viewDetailExam(detail) {
      var send = {
        course: detail.curso,
        idCourse: detail.idareacurricular,
        mean: detail.promedio,
        minimumNote: detail.notaminima,
        groups: detail.grupos
      };
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('viewDetailExam', send);
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Tabs__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Tab__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Exams__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Exam__ = __webpack_require__(79);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_5__global_Spinner__["a" /* default */],
    Exams: __WEBPACK_IMPORTED_MODULE_9__Exams__["a" /* default */],
    Exam: __WEBPACK_IMPORTED_MODULE_10__Exam__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_8__global_Modal__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_6__global_Tabs__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_7__global_Tab__["a" /* default */]
  },
  data: function data() {
    return {
      report: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-reporte-simulacros')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__functions_fetchFunctions__["f" /* getExams */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                if (res != 1) {
                  res = _this2.formatData(res);
                  localStorage.setItem('cima-reporte-simulacros', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                }
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem('cima-reporte-simulacros'));

              case 11:

                _this2.report = res;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    isTrue: function isTrue(el) {
      if (el == 0) {
        return 'true';
      }
    },
    change: function change() {
      this.$router.push('/Dashboard/Exams');
    },
    formatData: function formatData(res) {
      res.map(function (item) {
        item.examenes.map(function (exam) {
          var mispreguntas = [];
          var asignaturas = exam.asignaturas;
          exam.asignaturas = [];
          asignaturas.map(function (asignatura) {
            asignatura.id = asignatura.preguntas[0].numero_pregunta;
          });
          asignaturas.sort(function (a, b) {
            return a.id - b.id;
          });
          asignaturas.map(function (asignatura) {
            delete asignatura.id;
            mispreguntas = mispreguntas.concat(asignatura.preguntas);
          });
          exam.asignaturas = asignaturas;
          exam.preguntas = mispreguntas;
        });
      });
      return res;
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_formatDate__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data', 'id', 'idMod'],
  mounted: function mounted() {
    this.data.map(function (el) {
      var dates = el.fecha.split('-');
      el.fecha = Object(__WEBPACK_IMPORTED_MODULE_0__functions_formatDate__["a" /* formatDate */])(dates[0], dates[1], dates[2]);
    });
  },

  methods: {
    link: function link(id, idExam) {
      return '/Dashboard/Exam?mod=' + id + '&exam=' + idExam + '&idmod=' + this.idMod;
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exam_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438ce50e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Exam_vue__ = __webpack_require__(187);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438ce50e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Exam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_Modal__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Spinner__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__global_Spinner__["a" /* default */], Modal: __WEBPACK_IMPORTED_MODULE_1__global_Modal__["a" /* default */] },
  name: 'Exam',
  props: ['modalidad', 'examen', 'idmodalidad'],
  data: function data() {
    return {
      report: null,
      showModal: false,
      keyExam: null
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    goBack: function goBack() {},
    getData: function getData() {
      this.report = JSON.parse(localStorage.getItem('cima-reporte-simulacros'))[this.modalidad].examenes[this.examen];
    },
    viewKey: function viewKey(data) {
      this.keyExam = data;
      this.showModal = true;
    },
    correctKey: function correctKey(el) {
      if (el == null) {
        return '-';
      } else {
        return '' + el;
      }
    },
    colorKey: function colorKey(rpt, rpta) {
      if (rpt == rpta) {
        return 'green';
      } else {
        return 'red';
      }
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Tabs__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Tab__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_formatDate__ = __webpack_require__(20);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__global_Spinner__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_5__global_Tab__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_4__global_Tabs__["a" /* default */]
  },
  data: function data() {
    return {
      report: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, _data, data, total;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-payment')) {
                  _context2.next = 11;
                  break;
                }

                _data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_6__functions_fetchFunctions__["j" /* getPayment */])(_data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                console.log(res);
                res = res.data;
                localStorage.setItem('cima-estudiante-payment', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 12;
                break;

              case 11:
                res = JSON.parse(localStorage.getItem('cima-estudiante-payment'));

              case 12:
                _this2.report = res;
                data = JSON.parse(localStorage.getItem('cima-estudiante'));

                console.log(data);
                total = 0;
                // this.report[0].pagos.map(el=>{
                //   if(el.matricula==1){
                //     total += parseInt(el.montopagado);
                //   }
                // })

                _this2.report[0].pagos.map(function (el) {
                  if (el.matricula == 1) {
                    total += parseInt(el.montopagado);
                    el.montopagado = total;
                    if (el.monto <= total) {
                      el.estado = "CANCELADO";
                    }
                  }
                });

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    colorState: function colorState(el) {
      var classColor = void 0;
      if (el == 'CANCELADO') {
        classColor = 'green';
      } else if (el == 'DEUDA') {
        classColor = 'red';
      }
      return classColor;
    },
    format: function format(el) {
      var dates = el.split("-");
      var date = Object(__WEBPACK_IMPORTED_MODULE_7__functions_formatDate__["a" /* formatDate */])('', dates[1], dates[2]);
      return date;
    },
    isTrue: function isTrue(el) {
      if (el == 0) {
        return "true";
      }
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_formatDate__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Spinner__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_CountDown__ = __webpack_require__(192);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CountDown: __WEBPACK_IMPORTED_MODULE_7__global_CountDown__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_6__global_Spinner__["a" /* default */]
  },
  data: function data() {
    return {
      report: null,
      status: null
    };
  },
  created: function created() {
    var _this = this;

    // Listen countdown
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$on('listenCountdown', function (data) {
      return _this.status = data;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-events')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["e" /* getEvent */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                localStorage.setItem('cima-estudiante-events', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem('cima-estudiante-events'));

              case 11:
                _this3.report = res;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    format: function format(el) {
      var dates = el.split("-");
      var date = Object(__WEBPACK_IMPORTED_MODULE_4__functions_formatDate__["a" /* formatDate */])(dates[0], dates[1], dates[2]);
      return date;
    },
    getClassStatus: function getClassStatus(status) {
      var classStatus = void 0;
      if (status == 1 && this.status == 1) {
        classStatus = 'onload';
      } else if (status == 0) {
        classStatus = 'complete';
      } else if (this.status == 0 && status != 0) {
        classStatus = '';
      }
      return classStatus;
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["date", "hour"],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__Spinner__["a" /* default */]
  },
  name: "CountDown",
  data: function data() {
    return {
      report: null,
      deadline: null,
      now: null,
      remainTime: null,
      endTime: null,
      finalMessage: null,
      status: null,
      dateCount: null,
      hourCount: null

    };
  },
  mounted: function mounted() {
    this.getDeadline();
    this.ready();
  },

  methods: {
    getDeadline: function getDeadline() {
      this.dateCount = this.date;
      this.hourCount = this.hour;
      this.deadline = new Date(this.dateCount + 'T' + this.hourCount);
      // this.deadline = new Date("2018-06-11T08:58:00");
    },
    ready: function ready() {
      var _this = this;

      var timerUpdate = setInterval(function () {
        _this.now = new Date();
        _this.remainTime = (new Date(_this.deadline) - _this.now + 1000) / 1000;
        __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('listenCountdown', _this.status = 0);
        if (_this.remainTime <= 1) {
          _this.finalMessage = '¡El evento ya inició!';
          __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('listenCountdown', _this.status = 1);
          if (_this.remainTime <= -10) {
            clearInterval(timerUpdate);
            __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('listenCountdown', _this.status = 2);
            _this.finalMessage = 'El evento termino.';
          }
        }
      }, 1000);
    },
    getClassStatus: function getClassStatus() {
      var classStatus = void 0;
      if (this.status == 0) {
        classStatus = '';
      } else if (this.status == 1) {
        classStatus = 'blue-100';
      } else if (this.status == 2) {
        classStatus = 'red';
      }
      return classStatus;
    }
  },
  computed: {
    seconds: function seconds() {
      return ('0' + Math.floor(this.remainTime % 60)).slice(-2);
    },
    minutes: function minutes() {
      return ('0' + Math.floor(this.remainTime / 60 % 60)).slice(-2);
    },
    hours: function hours() {
      return ('0' + Math.floor(this.remainTime / 3600 % 24)).slice(-2);
    },
    days: function days() {
      return Math.floor(this.remainTime / (3600 * 24));
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_formatDate__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Spinner__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__global_Spinner__["a" /* default */]
  },
  data: function data() {
    return {
      report: null,
      status: null,
      bimestre: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = void 0;

                if (localStorage.getItem('cima-estudiante-rol-examenes')) {
                  _context2.next = 10;
                  break;
                }

                data = JSON.parse(localStorage.getItem('cima-estudiante'));
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__functions_fetchFunctions__["l" /* getRolExamenes */])(data.idalumnocolegio);

              case 5:
                res = _context2.sent;

                res = res.data;
                localStorage.setItem('cima-estudiante-rol-examenes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                _context2.next = 11;
                break;

              case 10:
                res = JSON.parse(localStorage.getItem('cima-estudiante-rol-examenes'));

              case 11:
                _this2.report = res;

                if (!_this2.report) {
                  _context2.next = 24;
                  break;
                }

                _context2.t0 = _this2.report[0].bimestre;
                _context2.next = _context2.t0 === 1 ? 16 : _context2.t0 === 2 ? 18 : _context2.t0 === 3 ? 20 : _context2.t0 === 4 ? 22 : 24;
                break;

              case 16:
                _this2.bimestre = 'I';return _context2.abrupt('break', 24);

              case 18:
                _this2.bimestre = 'II';return _context2.abrupt('break', 24);

              case 20:
                _this2.bimestre = 'III';return _context2.abrupt('break', 24);

              case 22:
                _this2.bimestre = 'IV';return _context2.abrupt('break', 24);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    format: function format(el) {
      var dates = el.split("-");
      var date = Object(__WEBPACK_IMPORTED_MODULE_4__functions_formatDate__["a" /* formatDate */])(dates[0], dates[1], dates[2]);
      return date;
    },
    getClassStatus: function getClassStatus(status) {
      var classStatus = void 0;
      if (status == 1 && this.status == 1) {
        classStatus = 'onload';
      } else if (status == 0) {
        classStatus = 'complete';
      } else if (this.status == 0 && status != 0) {
        classStatus = '';
      }
      return classStatus;
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,LhAAAIgPAAABAAIAAAAAAAIABQkAAAAAAAABAJABAAAAAExQAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAIGFndAAAAAAAAAAAAAAAAAAAAAAAABIAYwBpAG0AYQAtAHAAcgBlAHUAAAAIAHAAcgBlAHUAAAAWAFYAZQByAHMAaQBvAG4AIAAxAC4AMAAAABIAYwBpAG0AYQAtAHAAcgBlAHUAAAAAAAABAAAADQCAAAMAUEZGVE16xjkqAAAPbAAAABxHREVGAD8ABgAAD0wAAAAgT1MvMk/7XLQAAAFYAAAAVmNtYXAeaixZAAAB3AAAAWhnYXNw//8AAwAAD0QAAAAIZ2x5ZveIIkYAAANsAAAJlGhlYWQPoddXAAAA3AAAADZoaGVhBCoCBQAAARQAAAAkaG10eAbfAW0AAAGwAAAALGxvY2EWDhOkAAADRAAAACZtYXhwAGMAgQAAATgAAAAgbmFtZW/1R+0AAA0AAAABlXBvc3QcHdCSAAAOmAAAAKsAAQAAAAEAAHRnYSBfDzz1AAsCAAAAAADXREstAAAAANdESy0AAAAAAfsCAAAAAAgAAgAAAAAAAAABAAACAAAAAC4CAAAAAAAB+wABAAAAAAAAAAAAAAAAAAAABAABAAAAEgB+AA8AAAAAAAIAAAABAAEAAABAAAAAAAAAAAECAAGQAAUACAFMAWYAAABHAUwBZgAAAPUAGQCEAAACAAUJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAQABhAG8B4P/gAC4CAAAAAAAAAQAAAAAAAAIAAAAAAAAAAgAAAAIAAEAAAAASACUAIABVAEAAIABAACUAUAAAAAYAIAAlAAAAAwAAAAMAAAAcAAEAAAAAAGIAAwABAAAAHAAEAEYAAAAGAAQAAQACAAAAb///AAAAAABh//8AAAAAAAEAAAAEAAAADAAKAAMABAAFAAYABwAIAAkACwANAA4ADwAQABEAAAEGAAABAAAAAAAAAAECAAAAAgAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAoDBAUGBwgJCw0ODxARAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFACqAVQBzAJQAmoClALYAwoDlgPABAQELgRSBMoAAAABAEAAQAHAAcAACgAAJScHMxUzNTMVMzUBwMDAMGBgYODg4KCAgKAABQAAAAAB2wIAABkAHQAxAEUAbQAAJQcGIyIvASY1ND8BNjMyHwE3NjMyHwEWFRQFIREhNzU0JyYrASIHBh0BFBcWOwEyNzY3NTQnJisBIgcGHQEUFxY7ATI3NjcRFAcGIyEiJjURNDY7ATU0NzY7ATIXFh0BMzU0NjsBMhYdATMyFxYBdJIEAwIEUgMDDQIEAwQ+fwQDAgQNA/6uAZL+bm0CAgUSBQICAgQDEgMEAtwDAgQTBQEDAwIEEwIEA20KDQ3+bg8WFg8kDg0TEhMNDm4aExMTGiUNDQrtkwICUwEFBQEOAgI/fwICDgEFBckBJDdSAwQCAgQDUgMEAgIEA1IEAwICAwRSBAMCAgMW/pMQCgsWDwFtDxYbEw4NDQ4TGxsUGhoUGwsKAAAADwASAAAB7gIAAAMABwALAA8AEwAXABsAHwAjADcAOwA/AEMAVwB9AAA3MzUjFzM1IyczNSMXMzUjJzM1IxMzNSMnMzUjEzM1IyczNSMnNTQnJisBIgcGHQEUFxY7ATI3NhczNSMnMzUjFzM1Izc1NCcmKwEiBwYdARQXFjsBMjc2NxEUBiMhIiY1ETQ2OwE1NDc2OwEyFh0BMzU0NjsBMhcWHQEzMhY3UlJkXFxkUlJkXFxkUlLSXFxuXFzcUlJuXFxkAwIFEgQCAwMDAxIEAwPSUlJuXFxuUlIJAwIEEgUCAwMDBBIDAwNuFg/+bg8WFg8kDg0TEhQabhoUEhMNDiQPFiVSUlISXFxcElL+3FKAUv7cUhJcm1IEAwICAwRSBAIDAwLzXBJSUlI3UgQDAgIDBFIEAgMDAhb+kw8WFg8BbQ8WGxMODRoUGxsUGg0OExsWAAUAJQAAAdsCAAAGABwAMABEAFYAAAEWFyM1FhcHMxEUBwYjISInJjURNDc2OwEVFBcWFzU0JyYrASIHBh0BFBcWOwEyNzY9ATQnJisBIgcGHQEUFxY7ATI3Nj0BNCYrASIGHQEUFxY7ATI3NgHIAgaHCAITmwgIC/6ACwgICAgL5QgIOQMEAsoCBAMDBALKAgQDAwIEygQCAwMEAsoCBAMGA8oDBgMDA8oDAwMBeAIIhwYCpP7SDAcICAcMAcoMBwibDQcI0hIEAwICAwQSBAMCAgNNEgQDAgIDBBIEAwICA00SBAYGBBIFAQMDAQAAAAYAIAAgAeAB4AATACEANABCAEoAYAAANzU0NyMiDgEdARQWHwEVMzUiLgE1MjcyNTc2NTQmIgYUFgUjFxUUBg8BFTM1Mj4BPQE0LgEnFxYzFjMyNjQmIgYVFAYyNjQmIgYUFzQuASsBIg4BHQEUFh8BFTM1Mj4BNYAERAQKEhAICGAEChIMCwECFhwoHBwBVEQEEAgIYAQKEgIQaAEBAQoNFBwcKBxkKBwcKByQAhAOgAQKEhAICIAEChLAoAcJAhAOcA4QAQGggAIQzgYBAQ4aFBwcKBwQEKAOEAEBgKACEA5wBAoSGAEBBhwoHBwUGhYcKBwcKEwEChICEA5wDhABAaCgAhAOAAEAVQAAAasB7AALAAATBycRBREnNxcVMzW+XA0BFtEtzhYB7EQD/pVAAWsxIyqq0QAAAAAFAEAAQAHAAcAAAwAHAAsADwATAAATESERAyERIQEzNSMlIRUhNSEVIUABgCD+wAFA/uDAwAEA/wABAP8AAQABwP6AAYD+oAFA/wAgQCBgIAAAAAAHACAAIAHgAcAAFwAbAB8AIwAnACsALwAAASM1IRUjIgYdARQWOwEVITUzMjY9ATQmAyM1MzUjNTMXIzUzBTMVIxUzFSMVMxUjAago/wAoFyEiFigBACgWIiFP4ODg4DAREf8AwMDAwMDAAYBAQBwbexsjcHAfF4MaHf6wsKAwcBCQECAQIBAAAQBAAEABwAHAAB4AACUnNzY0JyYiDwEnJiIGFB8BBwYUFxYyPwEXFjI3NjQBtoODCgoLHQuDgwodFguCggsLCxwLg4MLHQsKfYODCxwLCwuCggsWHAuDgwoeCwoKg4MKCgsdAAYAJQAAAdsCAAAYAB8AKQA7AE8AYwAAARYXFhURFAcGIyEiJyY1ETQ3NjMhMhcWFwcVMyYvASYTESMiJyY9ASMRNzQ2OwEyFh0BFAcGKwEiJyY1FzIXFh0BFAcGKwEiJyY9ATQ3NjMXMhcWHQEUBwYrASInJj0BNDc2MwHICAYFCAgL/oALCAgICAsBAAwNEAYmbAMEWQNldwsICNxJBgPKAwYDAwPKAwMD0wQCAwMEAsoCBAMDAgTKAgQDAwQCygIEAwMEAgGTCA0LDv62DAcICAcMAcoMBwgGBwYUawkCWgP+TwEkCAcNdv5K9gQGBgQSBQEDAwEFLgIDBBIEAwICAwQSBAMCSQIDBBIEAwICAwQSBAMCAAABAFAAdwGwAYkAGQAAEwcGFRQfARYyNzYvATMyNjQmKwE3NjQnJiK9ZAkJZAkaCRMTMdkNEhIN2TEJCQkaAYBpCQ4NCWoJCRcXMhMaEzIKGgoJAAAGAAAAAAHgAgAABgANACEAJQApAC0AADcVMzUjBx8BMzc1IxUzNzU0KwEiHQEjNTQrASIdASMRIREnMxUjJTMVIwEhESGGPS1CDJxFY61oQRBAEKAQQBBAAeCAICD/ACAgAWD+YAGg+KjhEjCfsS80xDAQEDAwEBAw/kABwCBAQED+gAFAAAAAAQAGADgB+wHEABYAAAE2FREhIiY/ATYfARY3Mj8BNh8BFj8BAfMI/hIFBAR2CwkmCAMGA1EICzkLCXYBxAsN/nYIBZMMCyIEAQV6Dw01Cw3CAAAAAwAgACAB4AHgAAMADQAQAAA3JzcXNycmIg8BFzc2NAEHN6Nb+1o7MAkaCi1bLQr+YCB1SFv6WmUwCAotWy0KGv72dSAAAAAAAgAlACUB2wHbACoAUwAAJRUGBwYjIicmJwcGIicmPQE0NjsBMhcWFA8BFhcWMzI3Njc2NzY7ATIXFjcVFAYrASInJjQ/ASYjIgcGBwYHBisBIicmPQE2NzYzMhcWFzc2MhcWAdQSOzhQKicnHiUHDAcFCgiACAUFBScVGRgdJiEgFgQLAgY3BQICBwoIgAgFBQUoKjomISAWBAsCBjkFAgISOzlQKicpHSUHDAcF0gJLMS8PEB0lBQUFCIAICgUHDAcnEwoKEhIhCRkGAgTigAgKBQcMBycnEhIhCRkGAgQDAksxLw8RHCUFBQUAAAAAAAAMAJYAAQAAAAAAAQAJABQAAQAAAAAAAgAEACgAAQAAAAAAAwAlAHkAAQAAAAAABAAJALMAAQAAAAAABQALANUAAQAAAAAABgAJAPUAAwABBAkAAQASAAAAAwABBAkAAgAIAB4AAwABBAkAAwBKAC0AAwABBAkABAASAJ8AAwABBAkABQAWAL0AAwABBAkABgASAOEAYwBpAG0AYQAtAHAAcgBlAHUAAGNpbWEtcHJldQAAcAByAGUAdQAAcHJldQAARgBvAG4AdABGAG8AcgBnAGUAIAAyAC4AMAAgADoAIABjAGkAbQBhAC0AcAByAGUAdQAgADoAIAAxADEALQA2AC0AMgAwADEAOAAARm9udEZvcmdlIDIuMCA6IGNpbWEtcHJldSA6IDExLTYtMjAxOAAAYwBpAG0AYQAtAHAAcgBlAHUAAGNpbWEtcHJldQAAVgBlAHIAcwBpAG8AbgAgADEALgAwAABWZXJzaW9uIDEuMAAAYwBpAG0AYQAtAHAAcgBlAHUAAGNpbWEtcHJldQAAAAAAAgAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAASAAAAAQACAQIBAwEEAQUBBgEHAQgBCQEKAQsBDAENAQ4BDwEQBGhvbWUKY2FsZW5kYXItMQZob3JhcnkEZmlsZQR0ZWFtBGJvb2sFbm90ZXMHcHJpbnRlcgVjbG9zZQlmaWxlLXRleHQFYXJyb3cFZXZlbnQHcGF5bWVudARlZGl0B3JlZnJlc2gAAAAAAf//AAIAAQAAAA4AAAAYAAAAAAACAAEAAwARAAEABAAAAAIAAAAAAAEAAAAAzD2izwAAAADXREstAAAAANdESy0="

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cfg_core__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__(197);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* routes */] });

//Navigations Guards
router.beforeEach(function (to, from, next) {
  var currentUser = false;
  var myToken = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__cfg_core__["b" /* token */]); //replace token name
  var reqAuth = void 0,
      isFamilyGuy = void 0,
      isStudent = void 0,
      type = void 0;

  if (myToken != null) {
    currentUser = true;
    type = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(myToken).type; //get type user 
  }

  reqAuth = to.meta.reqAuth;
  isFamilyGuy = to.meta.isFamilyGuy;
  isStudent = to.meta.isStudent;

  if (reqAuth) {
    if (!currentUser) {
      next('/');
    } //replace view login
    else {
        if (isFamilyGuy) {
          if (type === 'familyGuy') {
            next();
          } else {
            next('/Dashboard');
          } //replace view student
        } else if (isStudent) {
          if (type === 'student') {
            next();
          } else {
            next('/Familyguy');
          } //replace view family guy
        } else {
          next();
        }
      }
  } else if (currentUser) {
    if (type === 'familyGuy') {
      next('/Familyguy');
    } //replace view family guy
    if (type === 'student') {
      next('/Dashboard');
    } //replace view student
  } else {
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(89);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(90)))

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dashboard__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Profile__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Observations__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Teachers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Classmates__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Assistance__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Parents__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Regulation__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Schedule__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Familyguy__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CoursesExams__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ModalityExams__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Exam__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Payment__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Events__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_RolExams__ = __webpack_require__(195);


















var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Login__["a" /* default */]
}, {
  path: '/Dashboard',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Dashboard__["a" /* default */],
  meta: { reqAuth: true },
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Profile__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Observations',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Observations__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Teachers',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Teachers__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Classmates',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Classmates__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Assistance',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Assistance__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Parents',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Parents__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Regulation',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Regulation__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Schedule__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'CoursesExams',
    component: __WEBPACK_IMPORTED_MODULE_11__components_CoursesExams__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'ModalityExams',
    component: __WEBPACK_IMPORTED_MODULE_12__components_ModalityExams__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Exam',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Exam__["a" /* default */],
    props: function props(route) {
      return { modalidad: route.query.mod, examen: route.query.exam, idmodalidad: route.query.idmod };
    },
    meta: { reqAuth: true }
  }, {
    path: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Payment__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'Events',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Events__["a" /* default */],
    meta: { reqAuth: true }
  }, {
    path: 'RolExams',
    component: __WEBPACK_IMPORTED_MODULE_16__components_RolExams__["a" /* default */],
    meta: { reqAuth: true }
  }]
}, {
  path: '/Familyguy',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Familyguy__["a" /* default */],
  meta: { reqAuth: true }
}];

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31be7f6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(136);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31be7f6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(95);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
__webpack_require__(100);
__webpack_require__(115);
__webpack_require__(119);
__webpack_require__(131);
__webpack_require__(132);
module.exports = __webpack_require__(9).Promise;


/***/ }),
/* 99 */
/***/ (function(module, exports) {



/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(101)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(39)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(29);
var defined = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(40)(function () {
  return Object.defineProperty(__webpack_require__(32)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(106);
var descriptor = __webpack_require__(41);
var setToStringTag = __webpack_require__(35);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(12)(IteratorPrototype, __webpack_require__(8)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(11);
var dPs = __webpack_require__(107);
var enumBugKeys = __webpack_require__(45);
var IE_PROTO = __webpack_require__(34)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(32)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(46).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(11);
var getKeys = __webpack_require__(108);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(109);
var enumBugKeys = __webpack_require__(45);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(23);
var toIObject = __webpack_require__(33);
var arrayIndexOf = __webpack_require__(111)(false);
var IE_PROTO = __webpack_require__(34)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(24);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(112);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(29);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(23);
var toObject = __webpack_require__(114);
var IE_PROTO = __webpack_require__(34)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
var global = __webpack_require__(6);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(18);
var TO_STRING_TAG = __webpack_require__(8)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(117);
var step = __webpack_require__(118);
var Iterators = __webpack_require__(18);
var toIObject = __webpack_require__(33);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(39)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(31);
var global = __webpack_require__(6);
var ctx = __webpack_require__(21);
var classof = __webpack_require__(47);
var $export = __webpack_require__(15);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(22);
var anInstance = __webpack_require__(120);
var forOf = __webpack_require__(121);
var speciesConstructor = __webpack_require__(48);
var task = __webpack_require__(49).set;
var microtask = __webpack_require__(126)();
var newPromiseCapabilityModule = __webpack_require__(36);
var perform = __webpack_require__(50);
var userAgent = __webpack_require__(127);
var promiseResolve = __webpack_require__(51);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(8)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(128)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(35)($Promise, PROMISE);
__webpack_require__(129)(PROMISE);
Wrapper = __webpack_require__(9)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(130)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(21);
var call = __webpack_require__(122);
var isArrayIter = __webpack_require__(123);
var anObject = __webpack_require__(11);
var toLength = __webpack_require__(42);
var getIterFn = __webpack_require__(124);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(18);
var ITERATOR = __webpack_require__(8)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(47);
var ITERATOR = __webpack_require__(8)('iterator');
var Iterators = __webpack_require__(18);
module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var macrotask = __webpack_require__(49).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(24)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(12);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var core = __webpack_require__(9);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(13);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(8)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(15);
var core = __webpack_require__(9);
var global = __webpack_require__(6);
var speciesConstructor = __webpack_require__(48);
var promiseResolve = __webpack_require__(51);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(36);
var perform = __webpack_require__(50);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(134);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"loader",class:_vm.size},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"3","stroke-miterlimit":"10"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-content--login"},[_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"slide-fade","appear":"appear"}},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(19),"alt":"Colegio CIMA"}})]),_c('transition',{attrs:{"name":"slide-fade-top","mode":"in-out"}},[(_vm.error)?[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('article',{staticClass:"message-error"},[_c('h1',{staticClass:"font-size-large m-t m-b"},[_vm._v(_vm._s(_vm.error))])])])])]:_vm._e()],2),_c('div',{staticClass:"login"},[_c('h1',{staticClass:"login__title text--center font-size-xx-large"},[_vm._v("Iniciar sesión")]),_c('form',{staticClass:"row main-center",on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"input-field col-xs-12"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Usuario")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user),expression:"user"}],staticClass:"input-field__input",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value}}})]),_c('div',{staticClass:"input-field col-xs-12"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Contraseña")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input-field__input",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_c('div',{staticClass:"col-xs"},[_c('button',{staticClass:"btn--primary",attrs:{"type":"submit"}},[(!_vm.viewSpinner)?[_vm._v("Ingresar")]:[_c('spinner')]],2)])])])],1)])],1),_c('div',{staticClass:"login__bg"},[_c('svg',{staticClass:"line-curve",attrs:{"viewBox":"0 0 1400 600"}},[_c('defs',[_c('path',{staticClass:"line-curve light-blue",attrs:{"d":"M-76.02 -295.6L-216.65 873.15L1720.85 910.65C2414.6 410.65 2329.19 233.57 1464.6 379.4C600.02 525.23 111.82 429.4 0 91.9L-76.02 -295.6Z","id":"bN1OX2GEd"}}),_vm._v(" "),_c('path',{staticClass:"line-curve blue",attrs:{"d":"M-185.4 -192.48L-269.77 813.77L1764.6 898.15C2668.77 441.9 2622.94 283.85 1627.1 424.01C631.27 564.17 83.35 449.3 -16.65 79.4L-185.4 -192.48Z","id":"e4a2QFBd0"}}),_vm._v(" "),_c('path',{staticClass:"line-curve magenta",attrs:{"d":"M-185.4 0L-157.27 771.91L1564.6 848.02C1966.69 653.52 1843.77 573.81 1195.85 608.89C547.94 643.96 142.03 474.2 -21.87 99.6L-185.4 0Z","id":"b5ps9i6az"}})]),_vm._v(" "),_c('g',[_c('g',[_c('g',[_c('use',{attrs:{"xlink:href":"#bN1OX2GEd","opacity":"1","fill":"#00357B","fill-opacity":"1"}})]),_vm._v(" "),_c('g',[_c('use',{attrs:{"xlink:href":"#e4a2QFBd0","opacity":"1","fill":"#29c300","fill-opacity":"1"}})]),_vm._v(" "),_c('g',[_c('use',{attrs:{"xlink:href":"#b5ps9i6az","opacity":"1","fill":"#00178f","fill-opacity":"1"}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d6e4e5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(149);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d6e4e5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f578064_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(144);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f578064_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(140);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(141), __esModule: true };

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(142);
var $Object = __webpack_require__(9).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(15);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.active)?[_c('div',{staticClass:"modal",class:_vm.alert? 'alert':''},[_c('div',{staticClass:"modal__close",on:{"click":function($event){_vm.close()}}},[_c('span',{staticClass:"icon-close"})]),_c('div',{staticClass:"modal__header"},[_c('div',{staticClass:"modal__title"},[_vm._t("title",[_vm._v("Title Modal")])],2)]),_c('div',{staticClass:"modal__body"},[_c('div',{staticClass:"modal__content"},[_vm._t("body",[_vm._v("Body Modal..")])],2)])]),_c('div',{staticClass:"overlay__modal",on:{"click":function($event){_vm.close()}}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"navigation",attrs:{"id":"navList"}},[(_vm.image)?[_c('div',{staticClass:"navigation__user-profile"},[_c('div',{staticClass:"navigation__wrapper-image"},[_c('img',{staticClass:"navigation__user-image shadow-1",class:_vm.image == 'dist/user.png' ? 't-0':'qwerty',attrs:{"src":_vm.image},on:{"error":function($event){_vm.detectedImages()}}})]),_c('strong',{staticClass:"navigation__user-name text--center"},[_vm._v(_vm._s(_vm.name))]),_c('button',{staticClass:"btn--danger is-active navigation__btn",on:{"click":function($event){_vm.logout()}}},[_vm._v("Cerrar Sesión")])])]:[_c('spinner')],_c('ul',{staticClass:"row"},[_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard","exact":"exact"}},[_c('span',{staticClass:"icon-home"}),_c('span',[_vm._v("Inicio")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Parents","exact":"exact"}},[_c('span',{staticClass:"icon-home"}),_c('span',[_vm._v("Información de apoderados")])])],1),(_vm.nivel!=11)?_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/CoursesExams","exact":"exact"}},[_c('span',{staticClass:"icon-file"}),_c('span',[_vm._v("Cursos y notas")])])],1):_vm._e(),(_vm.nivel!=8 && _vm.nivel!=11)?_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/ModalityExams","exact":"exact"}},[_c('span',{staticClass:"icon-file"}),_c('span',[_vm._v("Simulacros")])])],1):_vm._e(),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Assistance","exact":"exact"}},[_c('span',{staticClass:"icon-calendar-1"}),_c('span',[_vm._v("Asistencia")])])],1),(_vm.nivel!=11)?_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Schedule","exact":"exact"}},[_c('span',{staticClass:"icon-horary"}),_c('span',[_vm._v("Horario")])])],1):_vm._e(),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Observations","exact":"exact"}},[_c('span',{staticClass:"icon-notes"}),_c('span',[_vm._v("Anecdotario")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Payment","exact":"exact"}},[_c('span',{staticClass:"icon-payment"}),_c('span',[_vm._v("Historial de pagos")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Events","exact":"exact"}},[_c('span',{staticClass:"icon-event"}),_c('span',[_vm._v("Eventos")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/RolExams","exact":"exact"}},[_c('span',{staticClass:"icon-event"}),_c('span',[_vm._v("Rol de Exámenes")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Teachers","exact":"exact"}},[_c('span',{staticClass:"icon-team"}),_c('span',[_vm._v("Profesores")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Classmates","exact":"exact"}},[_c('span',{staticClass:"icon-team"}),_c('span',[_vm._v("Directorio de alumnos")])])],1),_c('li',{staticClass:"navigation__item col-xs-12"},[_c('router-link',{staticClass:"navigation__link",attrs:{"active-class":"is-active","to":"/Dashboard/Regulation","exact":"exact"}},[_c('span',{staticClass:"icon-book"}),_c('span',[_vm._v("Documentos Int.")])])],1)])],2),_c('modal',{staticClass:"mx-90",attrs:{"active":_vm.showModal,"alert":true},on:{"update:active":function($event){_vm.showModal=$event}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12 col-s"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v("Alerta!")])])])]),_c('template',{slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-large text-center"},[_vm._v("¿Desea cerrar sesión?")])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row m-b"},[_c('div',{staticClass:"col-xs m-auto"},[_c('button',{staticClass:"btn--default",on:{"click":function($event){_vm.cancelLogout()}}},[_vm._v("CANCELAR")])]),_c('div',{staticClass:"col-xs m-auto"},[_c('button',{staticClass:"btn--danger",on:{"click":function($event){_vm.sendLogout()}}},[_vm._v("ACEPTAR")])])])])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Children_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e54befa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Children_vue__ = __webpack_require__(148);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Children_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e54befa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Children_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3641d446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(147);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3641d446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu__wrapper"},[(_vm.children.length>1)?_c('button',{staticClass:"btn--warning is-active",on:{"click":function($event){_vm.isVisible = true}}},[_vm._t("button")],2):_vm._e(),(_vm.isVisible)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.outside),expression:"outside"}],staticClass:"menu",on:{"click":_vm.inside}},[_vm._t("body")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Menu',[_c('span',{attrs:{"slot":"button"},slot:"button"},[_vm._v("Cambiar")]),_c('template',{slot:"body"},[_c('div',{staticClass:"row"},[_vm._l((_vm.children),function(data,index){return [_c('div',{staticClass:"col-xs-6 m-b"},[_c('div',{staticClass:"row main-center u-hover",on:{"click":function($event){_vm.changeChildren(data)}}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"profile__wrapper-image x-small"},[_c('img',{staticClass:"profile__user-image",attrs:{"src":data.url_imagen,"alt":""}})]),_c('div',{staticClass:"profile__description"},[_c('strong',{staticClass:"font-size-regular"},[_vm._v(_vm._s(data.nombre))])])])])])]})],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"main-header"},[_c('div',{staticClass:"main-header__content container"},[_c('button',{staticClass:"btn--burger",on:{"click":function($event){_vm.viewNavigation()}}},[_c('div',{staticClass:"icon-burger"})]),_c('img',{staticClass:"main-header__logo",attrs:{"src":__webpack_require__(19),"alt":"Colegio CIMA"}}),(_vm.children)?[_c('Children')]:_vm._e()],2)]),_c('main',{staticClass:"main-content"},[_c('navigation'),_c('div',{staticClass:"wrapper"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn--floating shadow-2",on:{"click":function($event){_vm.reload()}}},[_c('i',{staticClass:"icon-refresh"})])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56a7771f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(151);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56a7771f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"band"}),_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.report)?[_c('div',{staticClass:"profile"},[_c('div',{staticClass:"profile__wrapper-image"},[_c('img',{staticClass:"profile__user-image",class:_vm.image == 'dist/user.png'? 'parent':'',attrs:{"src":_vm.image},on:{"error":function($event){_vm.detectedImages()}}})]),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(_vm.report.nombre)+" "+_vm._s(_vm.report.apellido))])]),_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"font-size-regular"},[_vm._v("DNI: "+_vm._s(_vm.report.dni))])])]),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-6"},[_c('strong',[_vm._v("Código Carné")]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.report.idalumnocolegio))])]),_c('div',{staticClass:"col-xs-6"},[_c('strong',[_vm._v("Código Banco")]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.report.codigobanco))])])]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Turno")]),_c('p',[_vm._v(_vm._s(_vm.report.turno))])]),_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Aula - Pabellón")]),_c('p',[_vm._v(_vm._s(_vm.report.aula)+" - "+_vm._s(_vm.report.pabellon))])])]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Grado - Sección")]),_c('p',[_vm._v(_vm._s(_vm.report.grado)+" - "+_vm._s(_vm.report.seccion))])]),_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Nivel")]),_c('p',[_vm._v(_vm._s(_vm.report.nivel))])])]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('small',[_vm._v("Dirección")]),_c('p',[_vm._v(_vm._s(_vm.report.direccion.toUpperCase()))])])])])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Observations_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40cb6252_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Observations_vue__ = __webpack_require__(155);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Observations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40cb6252_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Observations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs__wrapper",class:_vm.fixed? 'fixed':''},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs__list"},_vm._l((_vm.tabs),function(tab){return _c('button',{staticClass:"tab btn",class:{ 'is-active': tab.isActive },on:{"click":function($event){_vm.selectTab(tab)}}},[_vm._v(_vm._s(tab.name))])}))])]),_c('div',{staticClass:"tab__detail"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[(_vm.report == 1)?[_vm._m(1)]:[_c('div',{staticClass:"col-xs-12"},[_c('tabs',{staticClass:"row"},[_vm._l((_vm.report),function(data,index){return [_c('tab',{attrs:{"name":_vm.rename(data.bimestre),"selected":_vm.isTrue(index)}},[_c('div',{staticClass:"col-xs-12 m-t"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs"},[_c('div',{staticClass:"sticker m-b",class:data.conducta >= 10.5? 'green':'red'},[_vm._v("PROMEDIO DE CONDUCTA: "+_vm._s(data.conducta))])])]),_c('div',{staticClass:"row"},[_vm._l((data.observaciones),function(observations){return [_c('div',{staticClass:"col-xs-12 col-s-6 col-m-4 col-l-3 d-f"},[_c('div',{staticClass:"card m-b"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 m-b-2"},[_c('small',{staticClass:"font-size-regular"},[_vm._v("Fecha:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(observations.fecha))])]),_c('div',{staticClass:"col-xs-12 m-b-2"},[_c('small',{staticClass:"font-size-regular"},[_vm._v("Concepto:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(observations.observacion))])]),_c('div',{staticClass:"col-xs-12 m-b-2"},[_c('strong',{staticClass:"sticker",class:observations.puntos >= 0? 'green':'red'},[_vm._v("Puntos: "+_vm._s(observations.puntos))])]),_c('div',{staticClass:"col-xs-12 m-b-2"},[_c('small',{staticClass:"font-size-regular"},[_vm._v("Reportado por:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(observations.reportadopor))])])])])])]})],2)])])]})],2)],1)]],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row cross-center m-b"},[_c('div',{staticClass:"col-xs-12 col-s"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Observaciones del alumno")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 m-a"},[_c('article',{staticClass:"card"},[_c('h1',{staticClass:"title2"},[_vm._v("No tiene observaciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Teachers_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92e5a736_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Teachers_vue__ = __webpack_require__(157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Teachers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92e5a736_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Teachers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_vm._l((_vm.report),function(teacher){return [_c('div',{staticClass:"col-xs-12 col-s-6 col-m-4 d-f"},[_c('div',{staticClass:"profile m-b"},[_c('div',{staticClass:"profile__wrapper-image"},[_c('img',{staticClass:"profile__user-image",attrs:{"src":'https://intranet.cima.com.pe/v4cima/vista/fotos/prf'+teacher.idprofesor+'.jpg',"alt":""}})]),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(teacher.nombre))])]),_c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"font-size-regular"},[_vm._v(_vm._s(teacher.telefonosms))])]),_c('div',{staticClass:"col-xs-12"},[_c('small',{staticClass:"font-size-small"},[_vm._v(_vm._s(_vm.getText(teacher.asignaturas))+" ")])])])])])]})],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Lista de profesores")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classmates_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_943bb62e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Classmates_vue__ = __webpack_require__(159);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classmates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_943bb62e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Classmates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_vm._l((_vm.report),function(data){return [_c('div',{staticClass:"col-xs-12 col-s-6 col-m-4 d-f"},[_c('div',{staticClass:"profile m-b"},[_c('div',{staticClass:"profile__wrapper-image"},[_c('img',{staticClass:"profile__user-image",attrs:{"src":data.url_imagen,"alt":""}})]),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(data.apellido)+" "+_vm._s(data.nombre))])]),_c('div',{staticClass:"col-xs-12"},[_c('small',{staticClass:"font-size-small"},[_vm._v("Cel."),_vm._l((data.telefonoper),function(tel,index){return [((index+1) % 2 == 0)?_c('small',{staticClass:"font-size-regular"},[_vm._v("-")]):_vm._e(),_c('strong',{staticClass:"font-size-regular"},[_vm._v(_vm._s(tel))])]})],2)]),_c('div',{staticClass:"col-xs-12"},[_c('small',{staticClass:"font-size-small"},[_vm._v("Dir. "+_vm._s(data.direccion))])])])])])]})],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Directorio de alumnos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assistance_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b1f3bec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Assistance_vue__ = __webpack_require__(166);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assistance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b1f3bec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Assistance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104e4b01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(164);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104e4b01_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ff1f5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(163);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ff1f5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.active)?[_c('div',{staticClass:"notification"},[_vm._t("icon")],2)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"calendar"},[_c('header',{staticClass:"calendar__header"},[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(_vm.data.mes))]),_vm._m(0),_c('div',{staticClass:"calendar__body"},[_vm._l((_vm.data.asistencia),function(day){return [_c('div',{staticClass:"calendar__day"},[(day.justificacion)?[_c('notification',{attrs:{"active":_vm.activeNotification}},[_c('template',{slot:"icon"},[_c('span',{staticClass:"icon-notes"})])],2)]:_vm._e(),_c('small',{staticClass:"calendar__day-number",class:_vm.colorState(day),domProps:{"textContent":_vm._s(_vm.getDay(day.dia))},on:{"click":function($event){_vm.viewJustify(day, _vm.data.mes)}}}),_c('small',{staticClass:"font-size-small"},[_vm._v(_vm._s(_vm.viewHour(day)))])],2)]})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__header-days"},[_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("LUN.")])]),_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("MAR.")])]),_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("MIÉ.")])]),_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("JUE.")])]),_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("VIE.")])]),_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("SÁB.")])]),_c('div',{staticClass:"calendar__header-day"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("DOM.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isVisible)?[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__close",on:{"click":function($event){_vm.hidenModal()}}},[_c('span',{staticClass:"icon-close"})]),_c('div',{staticClass:"modal__header"},[_c('div',{staticClass:"modal__title"},[_c('h1',{staticClass:"title font-size-xx-large"},[_vm._t("title",[_vm._v("Title Modal")])],2)]),_c('div',{staticClass:"modal__print"},[_c('button',{staticClass:"btn--warning is-active",on:{"click":function($event){_vm.print('print')}}},[_c('span',{staticClass:"icon-printer"}),_c('span',[_vm._v("Imprimir")])])])]),_c('div',{staticClass:"modal__body"},[_c('div',{staticClass:"modal__content"},[_vm._t("body")],2)])]),_c('div',{staticClass:"overlay__modal",on:{"click":function($event){_vm.hidenModal()}}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.report)?[_vm._m(1),_c('div',{staticClass:"d-f m-b"},[_c('button',{staticClass:"btn--default",class:_vm.turn? "is-active" : "",on:{"click":function($event){_vm.checkMorning()}}},[_vm._v("Mañana")]),_c('button',{staticClass:"btn--default",class:_vm.turn? "" : "is-active",on:{"click":function($event){_vm.checkAfternoon()}}},[_vm._v("Tarde")]),_c('button',{staticClass:"btn--warning is-active",on:{"click":function($event){_vm.viewReport()}}},[_c('span',{staticClass:"icon-file-text"}),_c('span',[_vm._v("Reporte")])])]),_c('div',{staticClass:"row"},[_vm._l((_vm.report),function(month){return [_c('div',{staticClass:"col-xs-12 col-xm-6 col-xl-4 d-f"},[_c('calendar',{attrs:{"data":month,"idTurn":_vm.idTurn,"turn":_vm.turn,"showModalJustify":_vm.showModalJustify,"activeNotification":_vm.activeNotification}})],1)]})],2)]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)])]),_c('modal',{attrs:{"active":_vm.showModal},on:{"update:active":function($event){_vm.showModal=$event}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v("Justificación")])])])]),_c('template',{slot:"body"},[(_vm.justify)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-xm-4"},[_c('div',{staticClass:"card m-b"},[(_vm.justify.report == null)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v("NO TIENE JUSTIFICACIÓN")])])])]:[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 m-b-2"},[_c('small',{staticClass:"font-size-regular"},[_vm._v("Fecha:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(_vm.justify.day)+" de "+_vm._s(_vm.justify.month))])]),_c('div',{staticClass:"col-xs-12 m-b-2"},[_c('small',{staticClass:"font-size-regular"},[_vm._v("Descripción:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(_vm.justify.report))])])])]],2)])])]:[_c('spinner')]],2)],2),_c('report',[_c('template',{slot:"title"},[_vm._v("Reporte de asistencia")]),_c('template',{slot:"body"},[_c('div',{staticClass:"d-f m-b"},[_c('button',{staticClass:"btn--default",class:_vm.turn? "is-active" : "",on:{"click":function($event){_vm.checkMorning()}}},[_vm._v("Mañana")]),_c('button',{staticClass:"btn--default",class:_vm.turn? "" : "is-active",on:{"click":function($event){_vm.checkAfternoon()}}},[_vm._v("Tarde")])]),_c('div',{staticClass:"row",attrs:{"id":"print"}},[_c('div',{staticClass:"print__header col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"p-r"},[_c('img',{staticClass:"print__img",attrs:{"src":__webpack_require__(19)}})])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12"},[(_vm.dataStudent)?[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(_vm.dataStudent.nombre)+" "+_vm._s(_vm.dataStudent.apellido))]),_c('h2',{staticClass:"font-size-small"},[_vm._v(_vm._s(_vm.dataStudent.nivel)+" - "+_vm._s(_vm.dataStudent.grado)+" "+_vm._s(_vm.dataStudent.seccion))])]:[_c('spinner')]],2)])])])]),_vm._l((_vm.report),function(month,index){return [_c('div',{staticClass:"col-xs-12 col-l-6 d-f print__section"},[_c('calendar',{attrs:{"data":month,"idTurn":_vm.idTurn,"turn":_vm.turn}})],1),((index+1)%4 == 0 && _vm.report.length>(index+1))?[_c('div',{staticClass:"print__header col-xs-12",class:(index+1)%4 == 0? 'print__m-t print__show':''},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"p-r"},[_c('img',{staticClass:"print__img",attrs:{"src":__webpack_require__(19)}})])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12"},[(_vm.dataStudent)?[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(_vm.dataStudent.nombre)+" "+_vm._s(_vm.dataStudent.apellido))]),_c('h2',{staticClass:"font-size-small"},[_vm._v(_vm._s(_vm.dataStudent.nivel)+" - "+_vm._s(_vm.dataStudent.grado)+" "+_vm._s(_vm.dataStudent.seccion))])]:[_c('spinner')]],2)])])])])]:_vm._e()]}),_c('div',{staticClass:"col-xs-12 print__show"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card__title"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v("Leyenda")])]),_c('div',{staticClass:"card__body"},[_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--absence"}),_c('span',[_vm._v("Inasistencia")])]),_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--delay"}),_c('span',[_vm._v("Tardanza")])]),_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--arrive"}),_c('span',[_vm._v("Asistencia")])])])])])])])],2)])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Tu asistencia")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__title"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v("Leyenda")])]),_c('div',{staticClass:"card__body"},[_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--absence"}),_c('span',[_vm._v("Inasistencia")])]),_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--delay"}),_c('span',[_vm._v("Tardanza")])]),_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--arrive"}),_c('span',[_vm._v("Asistencia")])]),_c('div',{staticClass:"legend__label"},[_c('i',{staticClass:"circle--justify"}),_c('span',[_vm._v("Justificación")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Parents_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffdda00a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Parents_vue__ = __webpack_require__(173);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Parents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffdda00a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Parents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

var _cropperjs = __webpack_require__(169);

var _cropperjs2 = _interopRequireDefault(_cropperjs);

__webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CropperComponent = _vue2.default.extend({
    render: function render(h) {
        return h('div', { style: this.containerStyle }, [h('img', {
            ref: 'img',
            attrs: {
                src: this.src,
                alt: this.alt || 'image',
                style: 'max-width: 100%'
            },
            style: this.imgStyle
        })]);
    },

    props: {
        'containerStyle': Object,
        'src': {
            type: String,
            default: ''
        },
        'alt': String,
        'imgStyle': Object,

        'viewMode': Number,
        'dragMode': String,
        'aspectRatio': Number,
        'data': Object,
        'preview': String,
        'responsive': {
            type: Boolean,
            default: true
        },
        'restore': {
            type: Boolean,
            default: true
        },
        'checkCrossOrigin': {
            type: Boolean,
            default: true
        },
        'checkOrientation': {
            type: Boolean,
            default: true
        },
        'modal': {
            type: Boolean,
            default: true
        },
        'guides': {
            type: Boolean,
            default: true
        },
        'center': {
            type: Boolean,
            default: true
        },
        'highlight': {
            type: Boolean,
            default: true
        },
        'background': {
            type: Boolean,
            default: true
        },
        'autoCrop': {
            type: Boolean,
            default: true
        },
        'autoCropArea': Number,
        'movable': {
            type: Boolean,
            default: true
        },
        'rotatable': {
            type: Boolean,
            default: true
        },
        'scalable': {
            type: Boolean,
            default: true
        },
        'zoomable': {
            type: Boolean,
            default: true
        },
        'zoomOnTouch': {
            type: Boolean,
            default: true
        },
        'zoomOnWheel': {
            type: Boolean,
            default: true
        },
        'wheelZoomRatio': Number,
        'cropBoxMovable': {
            type: Boolean,
            default: true
        },
        'cropBoxResizable': {
            type: Boolean,
            default: true
        },
        'toggleDragModeOnDblclick': {
            type: Boolean,
            default: true
        },

        'minCanvasWidth': Number,
        'minCanvasHeight': Number,
        'minCropBoxWidth': Number,
        'minCropBoxHeight': Number,
        'minContainerWidth': Number,
        'minContainerHeight': Number,

        'ready': Function,
        'cropstart': Function,
        'cropmove': Function,
        'cropend': Function,
        'crop': Function,
        'zoom': Function
    },
    mounted: function mounted() {
        var _$options$props = this.$options.props,
            containerStyle = _$options$props.containerStyle,
            src = _$options$props.src,
            alt = _$options$props.alt,
            imgStyle = _$options$props.imgStyle,
            data = _objectWithoutProperties(_$options$props, ['containerStyle', 'src', 'alt', 'imgStyle']);

        var props = {};

        for (var key in data) {
            if (this[key] !== undefined) {
                props[key] = this[key];
            }
        }

        this.cropper = new _cropperjs2.default(this.$refs.img, props);
    },

    methods: {
        reset: function reset() {
            return this.cropper.reset();
        },
        clear: function clear() {
            return this.cropper.clear();
        },
        initCrop: function initCrop() {
            return this.cropper.crop();
        },
        replace: function replace(url) {
            var onlyColorChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.cropper.replace(url, onlyColorChanged);
        },
        enable: function enable() {
            return this.cropper.enable();
        },
        disable: function disable() {
            return this.cropper.disable();
        },
        destroy: function destroy() {
            return this.cropper.destroy();
        },
        move: function move(offsetX, offsetY) {
            return this.cropper.move(offsetX, offsetY);
        },
        moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

            return this.cropper.moveTo(x, y);
        },
        relativeZoom: function relativeZoom(ratio, _originalEvent) {
            return this.cropper.zoom(ratio, _originalEvent);
        },
        zoomTo: function zoomTo(ratio, _originalEvent) {
            return this.cropper.zoomTo(ratio, _originalEvent);
        },
        rotate: function rotate(degree) {
            return this.cropper.rotate(degree);
        },
        rotateTo: function rotateTo(degree) {
            return this.cropper.rotateTo(degree);
        },
        scaleX: function scaleX(_scaleX) {
            return this.cropper.scaleX(_scaleX);
        },
        scaleY: function scaleY(_scaleY) {
            return this.cropper.scaleY(_scaleY);
        },
        scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;

            return this.cropper.scale(scaleX, scaleY);
        },
        getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.cropper.getData(rounded);
        },
        setData: function setData(data) {
            return this.cropper.setData(data);
        },
        getContainerData: function getContainerData() {
            return this.cropper.getContainerData();
        },
        getImageData: function getImageData() {
            return this.cropper.getImageData();
        },
        getCanvasData: function getCanvasData() {
            return this.cropper.getCanvasData();
        },
        setCanvasData: function setCanvasData(data) {
            return this.cropper.setCanvasData(data);
        },
        getCropBoxData: function getCropBoxData() {
            return this.cropper.getCropBoxData();
        },
        setCropBoxData: function setCropBoxData(data) {
            return this.cropper.setCropBoxData(data);
        },
        getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.cropper.getCroppedCanvas(options);
        },
        setAspectRatio: function setAspectRatio(aspectRatio) {
            return this.cropper.setAspectRatio(aspectRatio);
        },
        setDragMode: function setDragMode(mode) {
            return this.cropper.setDragMode(mode);
        }
    }
});

var VueCropper = _vue2.default.component('vue-cropper', CropperComponent);

exports.default = VueCropper;

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
 * Cropper.js v1.4.0
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-06-01T15:18:18.692Z
 */

var IN_BROWSER = typeof window !== 'undefined';
var WINDOW = IN_BROWSER ? window : {};
var NAMESPACE = 'cropper';

// Actions
var ACTION_ALL = 'all';
var ACTION_CROP = 'crop';
var ACTION_MOVE = 'move';
var ACTION_ZOOM = 'zoom';
var ACTION_EAST = 'e';
var ACTION_WEST = 'w';
var ACTION_SOUTH = 's';
var ACTION_NORTH = 'n';
var ACTION_NORTH_EAST = 'ne';
var ACTION_NORTH_WEST = 'nw';
var ACTION_SOUTH_EAST = 'se';
var ACTION_SOUTH_WEST = 'sw';

// Classes
var CLASS_CROP = NAMESPACE + '-crop';
var CLASS_DISABLED = NAMESPACE + '-disabled';
var CLASS_HIDDEN = NAMESPACE + '-hidden';
var CLASS_HIDE = NAMESPACE + '-hide';
var CLASS_INVISIBLE = NAMESPACE + '-invisible';
var CLASS_MODAL = NAMESPACE + '-modal';
var CLASS_MOVE = NAMESPACE + '-move';

// Data keys
var DATA_ACTION = NAMESPACE + 'Action';
var DATA_PREVIEW = NAMESPACE + 'Preview';

// Drag modes
var DRAG_MODE_CROP = 'crop';
var DRAG_MODE_MOVE = 'move';
var DRAG_MODE_NONE = 'none';

// Events
var EVENT_CROP = 'crop';
var EVENT_CROP_END = 'cropend';
var EVENT_CROP_MOVE = 'cropmove';
var EVENT_CROP_START = 'cropstart';
var EVENT_DBLCLICK = 'dblclick';
var EVENT_POINTER_DOWN = WINDOW.PointerEvent ? 'pointerdown' : 'touchstart mousedown';
var EVENT_POINTER_MOVE = WINDOW.PointerEvent ? 'pointermove' : 'touchmove mousemove';
var EVENT_POINTER_UP = WINDOW.PointerEvent ? 'pointerup pointercancel' : 'touchend touchcancel mouseup';
var EVENT_READY = 'ready';
var EVENT_RESIZE = 'resize';
var EVENT_WHEEL = 'wheel mousewheel DOMMouseScroll';
var EVENT_ZOOM = 'zoom';

// RegExps
var REGEXP_ACTIONS = /^(?:e|w|s|n|se|sw|ne|nw|all|crop|move|zoom)$/;
var REGEXP_DATA_URL = /^data:/;
var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
var REGEXP_TAG_NAME = /^(?:img|canvas)$/i;

var DEFAULTS = {
  // Define the view mode of the cropper
  viewMode: 0, // 0, 1, 2, 3

  // Define the dragging mode of the cropper
  dragMode: DRAG_MODE_CROP, // 'crop', 'move' or 'none'

  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,

  // Define the aspect ratio of the crop box
  aspectRatio: NaN,

  // An object with the previous cropping result data
  data: null,

  // A selector for adding extra containers to preview
  preview: '',

  // Re-render the cropper when resize the window
  responsive: true,

  // Restore the cropped area after resize the window
  restore: true,

  // Check if the current image is a cross-origin image
  checkCrossOrigin: true,

  // Check the current image's Exif Orientation information
  checkOrientation: true,

  // Show the black modal
  modal: true,

  // Show the dashed lines for guiding
  guides: true,

  // Show the center indicator for guiding
  center: true,

  // Show the white modal to highlight the crop box
  highlight: true,

  // Show the grid background
  background: true,

  // Enable to crop the image automatically when initialize
  autoCrop: true,

  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,

  // Enable to move the image
  movable: true,

  // Enable to rotate the image
  rotatable: true,

  // Enable to scale the image
  scalable: true,

  // Enable to zoom the image
  zoomable: true,

  // Enable to zoom the image by dragging touch
  zoomOnTouch: true,

  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: true,

  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,

  // Enable to move the crop box
  cropBoxMovable: true,

  // Enable to resize the crop box
  cropBoxResizable: true,

  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: true,

  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: 200,
  minContainerHeight: 100,

  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
};

var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Check if the given value is not a number.
 */
var isNaN = Number.isNaN || WINDOW.isNaN;

/**
 * Check if the given value is a number.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a number, else `false`.
 */
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}

/**
 * Check if the given value is undefined.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
 */
function isUndefined(value) {
  return typeof value === 'undefined';
}

/**
 * Check if the given value is an object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is an object, else `false`.
 */
function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Check if the given value is a plain object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
 */

function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }

  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;


    return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
  } catch (e) {
    return false;
  }
}

/**
 * Check if the given value is a function.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a function, else `false`.
 */
function isFunction(value) {
  return typeof value === 'function';
}

/**
 * Iterate the given data.
 * @param {*} data - The data to iterate.
 * @param {Function} callback - The process function for each element.
 * @returns {*} The original data.
 */
function forEach(data, callback) {
  if (data && isFunction(callback)) {
    if (Array.isArray(data) || isNumber(data.length) /* array-like */) {
        var length = data.length;

        var i = void 0;

        for (i = 0; i < length; i += 1) {
          if (callback.call(data, data[i], i, data) === false) {
            break;
          }
        }
      } else if (isObject(data)) {
      Object.keys(data).forEach(function (key) {
        callback.call(data, data[key], key, data);
      });
    }
  }

  return data;
}

/**
 * Extend the given object.
 * @param {*} obj - The object to be extended.
 * @param {*} args - The rest objects which will be merged to the first object.
 * @returns {Object} The extended object.
 */
var assign = Object.assign || function assign(obj) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (isObject(obj) && args.length > 0) {
    args.forEach(function (arg) {
      if (isObject(arg)) {
        Object.keys(arg).forEach(function (key) {
          obj[key] = arg[key];
        });
      }
    });
  }

  return obj;
};

var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/i;

/**
 * Normalize decimal number.
 * Check out {@link http://0.30000000000000004.com/}
 * @param {number} value - The value to normalize.
 * @param {number} [times=100000000000] - The times for normalizing.
 * @returns {number} Returns the normalized number.
 */
function normalizeDecimalNumber(value) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;

  return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
}

var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;

/**
 * Apply styles to the given element.
 * @param {Element} element - The target element.
 * @param {Object} styles - The styles for applying.
 */
function setStyle(element, styles) {
  var style = element.style;


  forEach(styles, function (value, property) {
    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
      value += 'px';
    }

    style[property] = value;
  });
}

/**
 * Check if the given element has a special class.
 * @param {Element} element - The element to check.
 * @param {string} value - The class to search.
 * @returns {boolean} Returns `true` if the special class was found.
 */
function hasClass(element, value) {
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}

/**
 * Add classes to the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be added.
 */
function addClass(element, value) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      addClass(elem, value);
    });
    return;
  }

  if (element.classList) {
    element.classList.add(value);
    return;
  }

  var className = element.className.trim();

  if (!className) {
    element.className = value;
  } else if (className.indexOf(value) < 0) {
    element.className = className + ' ' + value;
  }
}

/**
 * Remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be removed.
 */
function removeClass(element, value) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      removeClass(elem, value);
    });
    return;
  }

  if (element.classList) {
    element.classList.remove(value);
    return;
  }

  if (element.className.indexOf(value) >= 0) {
    element.className = element.className.replace(value, '');
  }
}

/**
 * Add or remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be toggled.
 * @param {boolean} added - Add only.
 */
function toggleClass(element, value, added) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      toggleClass(elem, value, added);
    });
    return;
  }

  // IE10-11 doesn't support the second parameter of `classList.toggle`
  if (added) {
    addClass(element, value);
  } else {
    removeClass(element, value);
  }
}

var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;

/**
 * Transform the given string from camelCase to kebab-case
 * @param {string} value - The value to transform.
 * @returns {string} The transformed value.
 */
function hyphenate(value) {
  return value.replace(REGEXP_HYPHENATE, '$1-$2').toLowerCase();
}

/**
 * Get data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to get.
 * @returns {string} The data value.
 */
function getData(element, name) {
  if (isObject(element[name])) {
    return element[name];
  } else if (element.dataset) {
    return element.dataset[name];
  }

  return element.getAttribute('data-' + hyphenate(name));
}

/**
 * Set data to the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to set.
 * @param {string} data - The data value.
 */
function setData(element, name, data) {
  if (isObject(data)) {
    element[name] = data;
  } else if (element.dataset) {
    element.dataset[name] = data;
  } else {
    element.setAttribute('data-' + hyphenate(name), data);
  }
}

/**
 * Remove data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to remove.
 */
function removeData(element, name) {
  if (isObject(element[name])) {
    try {
      delete element[name];
    } catch (e) {
      element[name] = undefined;
    }
  } else if (element.dataset) {
    // #128 Safari not allows to delete dataset property
    try {
      delete element.dataset[name];
    } catch (e) {
      element.dataset[name] = undefined;
    }
  } else {
    element.removeAttribute('data-' + hyphenate(name));
  }
}

var REGEXP_SPACES = /\s\s*/;
var onceSupported = function () {
  var supported = false;

  if (IN_BROWSER) {
    var once = false;
    var listener = function listener() {};
    var options = Object.defineProperty({}, 'once', {
      get: function get$$1() {
        supported = true;
        return once;
      },


      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function set$$1(value) {
        once = value;
      }
    });

    WINDOW.addEventListener('test', listener, options);
    WINDOW.removeEventListener('test', listener, options);
  }

  return supported;
}();

/**
 * Remove event listener from the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */
function removeListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var handler = listener;

  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (!onceSupported) {
      var listeners = element.listeners;


      if (listeners && listeners[event] && listeners[event][listener]) {
        handler = listeners[event][listener];
        delete listeners[event][listener];

        if (Object.keys(listeners[event]).length === 0) {
          delete listeners[event];
        }

        if (Object.keys(listeners).length === 0) {
          delete element.listeners;
        }
      }
    }

    element.removeEventListener(event, handler, options);
  });
}

/**
 * Add event listener to the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */
function addListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _handler = listener;

  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners,
          listeners = _element$listeners === undefined ? {} : _element$listeners;


      _handler = function handler() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        delete listeners[event][listener];
        element.removeEventListener(event, _handler, options);
        listener.apply(element, args);
      };

      if (!listeners[event]) {
        listeners[event] = {};
      }

      if (listeners[event][listener]) {
        element.removeEventListener(event, listeners[event][listener], options);
      }

      listeners[event][listener] = _handler;
      element.listeners = listeners;
    }

    element.addEventListener(event, _handler, options);
  });
}

/**
 * Dispatch event on the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Object} data - The additional event data.
 * @returns {boolean} Indicate if the event is default prevented or not.
 */
function dispatchEvent(element, type, data) {
  var event = void 0;

  // Event and CustomEvent on IE9-11 are global objects, not constructors
  if (isFunction(Event) && isFunction(CustomEvent)) {
    event = new CustomEvent(type, {
      detail: data,
      bubbles: true,
      cancelable: true
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(type, true, true, data);
  }

  return element.dispatchEvent(event);
}

/**
 * Get the offset base on the document.
 * @param {Element} element - The target element.
 * @returns {Object} The offset data.
 */
function getOffset(element) {
  var box = element.getBoundingClientRect();

  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}

var location = WINDOW.location;

var REGEXP_ORIGINS = /^(https?:)\/\/([^:/?#]+):?(\d*)/i;

/**
 * Check if the given URL is a cross origin URL.
 * @param {string} url - The target URL.
 * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
 */
function isCrossOriginURL(url) {
  var parts = url.match(REGEXP_ORIGINS);

  return parts && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
}

/**
 * Add timestamp to the given URL.
 * @param {string} url - The target URL.
 * @returns {string} The result URL.
 */
function addTimestamp(url) {
  var timestamp = 'timestamp=' + new Date().getTime();

  return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
}

/**
 * Get transforms base on the given object.
 * @param {Object} obj - The target object.
 * @returns {string} A string contains transform values.
 */
function getTransforms(_ref) {
  var rotate = _ref.rotate,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      translateX = _ref.translateX,
      translateY = _ref.translateY;

  var values = [];

  if (isNumber(translateX) && translateX !== 0) {
    values.push('translateX(' + translateX + 'px)');
  }

  if (isNumber(translateY) && translateY !== 0) {
    values.push('translateY(' + translateY + 'px)');
  }

  // Rotate should come first before scale to match orientation transform
  if (isNumber(rotate) && rotate !== 0) {
    values.push('rotate(' + rotate + 'deg)');
  }

  if (isNumber(scaleX) && scaleX !== 1) {
    values.push('scaleX(' + scaleX + ')');
  }

  if (isNumber(scaleY) && scaleY !== 1) {
    values.push('scaleY(' + scaleY + ')');
  }

  var transform = values.length ? values.join(' ') : 'none';

  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform: transform
  };
}

/**
 * Get the max ratio of a group of pointers.
 * @param {string} pointers - The target pointers.
 * @returns {number} The result ratio.
 */
function getMaxZoomRatio(pointers) {
  var pointers2 = assign({}, pointers);
  var ratios = [];

  forEach(pointers, function (pointer, pointerId) {
    delete pointers2[pointerId];

    forEach(pointers2, function (pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;

      ratios.push(ratio);
    });
  });

  ratios.sort(function (a, b) {
    return Math.abs(a) < Math.abs(b);
  });

  return ratios[0];
}

/**
 * Get a pointer from an event object.
 * @param {Object} event - The target event object.
 * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
 * @returns {Object} The result pointer contains start and/or end point coordinates.
 */
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX,
      pageY = _ref2.pageY;

  var end = {
    endX: pageX,
    endY: pageY
  };

  return endOnly ? end : assign({
    startX: pageX,
    startY: pageY
  }, end);
}

/**
 * Get the center point coordinate of a group of pointers.
 * @param {Object} pointers - The target pointers.
 * @returns {Object} The center point coordinate.
 */
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count = 0;

  forEach(pointers, function (_ref3) {
    var startX = _ref3.startX,
        startY = _ref3.startY;

    pageX += startX;
    pageY += startY;
    count += 1;
  });

  pageX /= count;
  pageY /= count;

  return {
    pageX: pageX,
    pageY: pageY
  };
}

/**
 * Check if the given value is a finite number.
 */
var isFinite = Number.isFinite || WINDOW.isFinite;

/**
 * Get the max sizes in a rectangle under the given aspect ratio.
 * @param {Object} data - The original sizes.
 * @param {string} [type='contain'] - The adjust type.
 * @returns {Object} The result sizes.
 */
function getAdjustedSizes(_ref4) // or 'cover'
{
  var aspectRatio = _ref4.aspectRatio,
      height = _ref4.height,
      width = _ref4.width;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';

  var isValidNumber = function isValidNumber(value) {
    return isFinite(value) && value > 0;
  };

  if (isValidNumber(width) && isValidNumber(height)) {
    var adjustedWidth = height * aspectRatio;

    if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
      height = width / aspectRatio;
    } else {
      width = height * aspectRatio;
    }
  } else if (isValidNumber(width)) {
    height = width / aspectRatio;
  } else if (isValidNumber(height)) {
    width = height * aspectRatio;
  }

  return {
    width: width,
    height: height
  };
}

/**
 * Get the new sizes of a rectangle after rotated.
 * @param {Object} data - The original sizes.
 * @returns {Object} The result sizes.
 */
function getRotatedSizes(_ref5) {
  var width = _ref5.width,
      height = _ref5.height,
      degree = _ref5.degree;

  degree = Math.abs(degree) % 180;

  if (degree === 90) {
    return {
      width: height,
      height: width
    };
  }

  var arc = degree % 90 * Math.PI / 180;
  var sinArc = Math.sin(arc);
  var cosArc = Math.cos(arc);
  var newWidth = width * cosArc + height * sinArc;
  var newHeight = width * sinArc + height * cosArc;

  return degree > 90 ? {
    width: newHeight,
    height: newWidth
  } : {
    width: newWidth,
    height: newHeight
  };
}

/**
 * Get a canvas which drew the given image.
 * @param {HTMLImageElement} image - The image for drawing.
 * @param {Object} imageData - The image data.
 * @param {Object} canvasData - The canvas data.
 * @param {Object} options - The options.
 * @returns {HTMLCanvasElement} The result canvas.
 */
function getSourceCanvas(image, _ref6, _ref7, _ref8) {
  var imageAspectRatio = _ref6.aspectRatio,
      imageNaturalWidth = _ref6.naturalWidth,
      imageNaturalHeight = _ref6.naturalHeight,
      _ref6$rotate = _ref6.rotate,
      rotate = _ref6$rotate === undefined ? 0 : _ref6$rotate,
      _ref6$scaleX = _ref6.scaleX,
      scaleX = _ref6$scaleX === undefined ? 1 : _ref6$scaleX,
      _ref6$scaleY = _ref6.scaleY,
      scaleY = _ref6$scaleY === undefined ? 1 : _ref6$scaleY;
  var aspectRatio = _ref7.aspectRatio,
      naturalWidth = _ref7.naturalWidth,
      naturalHeight = _ref7.naturalHeight;
  var _ref8$fillColor = _ref8.fillColor,
      fillColor = _ref8$fillColor === undefined ? 'transparent' : _ref8$fillColor,
      _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
      imageSmoothingEnabled = _ref8$imageSmoothingE === undefined ? true : _ref8$imageSmoothingE,
      _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
      imageSmoothingQuality = _ref8$imageSmoothingQ === undefined ? 'low' : _ref8$imageSmoothingQ,
      _ref8$maxWidth = _ref8.maxWidth,
      maxWidth = _ref8$maxWidth === undefined ? Infinity : _ref8$maxWidth,
      _ref8$maxHeight = _ref8.maxHeight,
      maxHeight = _ref8$maxHeight === undefined ? Infinity : _ref8$maxHeight,
      _ref8$minWidth = _ref8.minWidth,
      minWidth = _ref8$minWidth === undefined ? 0 : _ref8$minWidth,
      _ref8$minHeight = _ref8.minHeight,
      minHeight = _ref8$minHeight === undefined ? 0 : _ref8$minHeight;

  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  var maxSizes = getAdjustedSizes({
    aspectRatio: aspectRatio,
    width: maxWidth,
    height: maxHeight
  });
  var minSizes = getAdjustedSizes({
    aspectRatio: aspectRatio,
    width: minWidth,
    height: minHeight
  }, 'cover');
  var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
  var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));

  // Note: should always use image's natural sizes for drawing as
  // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
  var destMaxSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: maxWidth,
    height: maxHeight
  });
  var destMinSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: minWidth,
    height: minHeight
  }, 'cover');
  var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
  var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
  var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];

  canvas.width = normalizeDecimalNumber(width);
  canvas.height = normalizeDecimalNumber(height);
  context.fillStyle = fillColor;
  context.fillRect(0, 0, width, height);
  context.save();
  context.translate(width / 2, height / 2);
  context.rotate(rotate * Math.PI / 180);
  context.scale(scaleX, scaleY);
  context.imageSmoothingEnabled = imageSmoothingEnabled;
  context.imageSmoothingQuality = imageSmoothingQuality;
  context.drawImage.apply(context, [image].concat(toConsumableArray(params.map(function (param) {
    return Math.floor(normalizeDecimalNumber(param));
  }))));
  context.restore();
  return canvas;
}

var fromCharCode = String.fromCharCode;

/**
 * Get string from char code in data view.
 * @param {DataView} dataView - The data view for read.
 * @param {number} start - The start index.
 * @param {number} length - The read length.
 * @returns {string} The read result.
 */

function getStringFromCharCode(dataView, start, length) {
  var str = '';
  var i = void 0;

  length += start;

  for (i = start; i < length; i += 1) {
    str += fromCharCode(dataView.getUint8(i));
  }

  return str;
}

var REGEXP_DATA_URL_HEAD = /^data:.*,/;

/**
 * Transform Data URL to array buffer.
 * @param {string} dataURL - The Data URL to transform.
 * @returns {ArrayBuffer} The result array buffer.
 */
function dataURLToArrayBuffer(dataURL) {
  var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
  var binary = atob(base64);
  var arrayBuffer = new ArrayBuffer(binary.length);
  var uint8 = new Uint8Array(arrayBuffer);

  forEach(uint8, function (value, i) {
    uint8[i] = binary.charCodeAt(i);
  });

  return arrayBuffer;
}

/**
 * Transform array buffer to Data URL.
 * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
 * @param {string} mimeType - The mime type of the Data URL.
 * @returns {string} The result Data URL.
 */
function arrayBufferToDataURL(arrayBuffer, mimeType) {
  var uint8 = new Uint8Array(arrayBuffer);
  var data = '';

  // TypedArray.prototype.forEach is not supported in some browsers.
  forEach(uint8, function (value) {
    data += fromCharCode(value);
  });

  return 'data:' + mimeType + ';base64,' + btoa(data);
}

/**
 * Get orientation value from given array buffer.
 * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
 * @returns {number} The read orientation value.
 */
function getOrientation(arrayBuffer) {
  var dataView = new DataView(arrayBuffer);
  var orientation = void 0;
  var littleEndian = void 0;
  var app1Start = void 0;
  var ifdStart = void 0;

  // Only handle JPEG image (start by 0xFFD8)
  if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
    var length = dataView.byteLength;
    var offset = 2;

    while (offset < length) {
      if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
        app1Start = offset;
        break;
      }

      offset += 1;
    }
  }

  if (app1Start) {
    var exifIDCode = app1Start + 4;
    var tiffOffset = app1Start + 10;

    if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
      var endianness = dataView.getUint16(tiffOffset);

      littleEndian = endianness === 0x4949;

      if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

            if (firstIFDOffset >= 0x00000008) {
              ifdStart = tiffOffset + firstIFDOffset;
            }
          }
        }
    }
  }

  if (ifdStart) {
    var _length = dataView.getUint16(ifdStart, littleEndian);
    var _offset = void 0;
    var i = void 0;

    for (i = 0; i < _length; i += 1) {
      _offset = ifdStart + i * 12 + 2;

      if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */) {
          // 8 is the offset of the current tag's value
          _offset += 8;

          // Get the original orientation value
          orientation = dataView.getUint16(_offset, littleEndian);

          // Override the orientation with its default value
          dataView.setUint16(_offset, 1, littleEndian);
          break;
        }
    }
  }

  return orientation;
}

/**
 * Parse Exif Orientation value.
 * @param {number} orientation - The orientation to parse.
 * @returns {Object} The parsed result.
 */
function parseOrientation(orientation) {
  var rotate = 0;
  var scaleX = 1;
  var scaleY = 1;

  switch (orientation) {
    // Flip horizontal
    case 2:
      scaleX = -1;
      break;

    // Rotate left 180°
    case 3:
      rotate = -180;
      break;

    // Flip vertical
    case 4:
      scaleY = -1;
      break;

    // Flip vertical and rotate right 90°
    case 5:
      rotate = 90;
      scaleY = -1;
      break;

    // Rotate right 90°
    case 6:
      rotate = 90;
      break;

    // Flip horizontal and rotate right 90°
    case 7:
      rotate = 90;
      scaleX = -1;
      break;

    // Rotate left 90°
    case 8:
      rotate = -90;
      break;

    default:
  }

  return {
    rotate: rotate,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var render = {
  render: function render() {
    this.initContainer();
    this.initCanvas();
    this.initCropBox();
    this.renderCanvas();

    if (this.cropped) {
      this.renderCropBox();
    }
  },
  initContainer: function initContainer() {
    var element = this.element,
        options = this.options,
        container = this.container,
        cropper = this.cropper;


    addClass(cropper, CLASS_HIDDEN);
    removeClass(element, CLASS_HIDDEN);

    var containerData = {
      width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
      height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
    };

    this.containerData = containerData;

    setStyle(cropper, {
      width: containerData.width,
      height: containerData.height
    });

    addClass(element, CLASS_HIDDEN);
    removeClass(cropper, CLASS_HIDDEN);
  },


  // Canvas (image wrapper)
  initCanvas: function initCanvas() {
    var containerData = this.containerData,
        imageData = this.imageData;
    var viewMode = this.options.viewMode;

    var rotated = Math.abs(imageData.rotate) % 180 === 90;
    var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
    var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
    var aspectRatio = naturalWidth / naturalHeight;
    var canvasWidth = containerData.width;
    var canvasHeight = containerData.height;

    if (containerData.height * aspectRatio > containerData.width) {
      if (viewMode === 3) {
        canvasWidth = containerData.height * aspectRatio;
      } else {
        canvasHeight = containerData.width / aspectRatio;
      }
    } else if (viewMode === 3) {
      canvasHeight = containerData.width / aspectRatio;
    } else {
      canvasWidth = containerData.height * aspectRatio;
    }

    var canvasData = {
      aspectRatio: aspectRatio,
      naturalWidth: naturalWidth,
      naturalHeight: naturalHeight,
      width: canvasWidth,
      height: canvasHeight
    };

    canvasData.left = (containerData.width - canvasWidth) / 2;
    canvasData.top = (containerData.height - canvasHeight) / 2;
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;

    this.canvasData = canvasData;
    this.limited = viewMode === 1 || viewMode === 2;
    this.limitCanvas(true, true);
    this.initialImageData = assign({}, imageData);
    this.initialCanvasData = assign({}, canvasData);
  },
  limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
    var options = this.options,
        containerData = this.containerData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData;
    var viewMode = options.viewMode;
    var aspectRatio = canvasData.aspectRatio;

    var cropped = this.cropped && cropBoxData;

    if (sizeLimited) {
      var minCanvasWidth = Number(options.minCanvasWidth) || 0;
      var minCanvasHeight = Number(options.minCanvasHeight) || 0;

      if (viewMode > 1) {
        minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
        minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

        if (viewMode === 3) {
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      } else if (viewMode > 0) {
        if (minCanvasWidth) {
          minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
        } else if (minCanvasHeight) {
          minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
        } else if (cropped) {
          minCanvasWidth = cropBoxData.width;
          minCanvasHeight = cropBoxData.height;

          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      }

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: minCanvasWidth,
        height: minCanvasHeight
      });

      minCanvasWidth = _getAdjustedSizes.width;
      minCanvasHeight = _getAdjustedSizes.height;


      canvasData.minWidth = minCanvasWidth;
      canvasData.minHeight = minCanvasHeight;
      canvasData.maxWidth = Infinity;
      canvasData.maxHeight = Infinity;
    }

    if (positionLimited) {
      if (viewMode) {
        var newCanvasLeft = containerData.width - canvasData.width;
        var newCanvasTop = containerData.height - canvasData.height;

        canvasData.minLeft = Math.min(0, newCanvasLeft);
        canvasData.minTop = Math.min(0, newCanvasTop);
        canvasData.maxLeft = Math.max(0, newCanvasLeft);
        canvasData.maxTop = Math.max(0, newCanvasTop);

        if (cropped && this.limited) {
          canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
          canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
          canvasData.maxLeft = cropBoxData.left;
          canvasData.maxTop = cropBoxData.top;

          if (viewMode === 2) {
            if (canvasData.width >= containerData.width) {
              canvasData.minLeft = Math.min(0, newCanvasLeft);
              canvasData.maxLeft = Math.max(0, newCanvasLeft);
            }

            if (canvasData.height >= containerData.height) {
              canvasData.minTop = Math.min(0, newCanvasTop);
              canvasData.maxTop = Math.max(0, newCanvasTop);
            }
          }
        }
      } else {
        canvasData.minLeft = -canvasData.width;
        canvasData.minTop = -canvasData.height;
        canvasData.maxLeft = containerData.width;
        canvasData.maxTop = containerData.height;
      }
    }
  },
  renderCanvas: function renderCanvas(changed, transformed) {
    var canvasData = this.canvasData,
        imageData = this.imageData;


    if (transformed) {
      var _getRotatedSizes = getRotatedSizes({
        width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
        height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
        degree: imageData.rotate || 0
      }),
          naturalWidth = _getRotatedSizes.width,
          naturalHeight = _getRotatedSizes.height;

      var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
      var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);

      canvasData.left -= (width - canvasData.width) / 2;
      canvasData.top -= (height - canvasData.height) / 2;
      canvasData.width = width;
      canvasData.height = height;
      canvasData.aspectRatio = naturalWidth / naturalHeight;
      canvasData.naturalWidth = naturalWidth;
      canvasData.naturalHeight = naturalHeight;
      this.limitCanvas(true, false);
    }

    if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
      canvasData.left = canvasData.oldLeft;
    }

    if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
      canvasData.top = canvasData.oldTop;
    }

    canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
    canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);

    this.limitCanvas(false, true);

    canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
    canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;

    setStyle(this.canvas, assign({
      width: canvasData.width,
      height: canvasData.height
    }, getTransforms({
      translateX: canvasData.left,
      translateY: canvasData.top
    })));

    this.renderImage(changed);

    if (this.cropped && this.limited) {
      this.limitCropBox(true, true);
    }
  },
  renderImage: function renderImage(changed) {
    var canvasData = this.canvasData,
        imageData = this.imageData;

    var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
    var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);

    assign(imageData, {
      width: width,
      height: height,
      left: (canvasData.width - width) / 2,
      top: (canvasData.height - height) / 2
    });
    setStyle(this.image, assign({
      width: imageData.width,
      height: imageData.height
    }, getTransforms(assign({
      translateX: imageData.left,
      translateY: imageData.top
    }, imageData))));

    if (changed) {
      this.output();
    }
  },
  initCropBox: function initCropBox() {
    var options = this.options,
        canvasData = this.canvasData;

    var aspectRatio = options.aspectRatio || options.initialAspectRatio;
    var autoCropArea = Number(options.autoCropArea) || 0.8;
    var cropBoxData = {
      width: canvasData.width,
      height: canvasData.height
    };

    if (aspectRatio) {
      if (canvasData.height * aspectRatio > canvasData.width) {
        cropBoxData.height = cropBoxData.width / aspectRatio;
      } else {
        cropBoxData.width = cropBoxData.height * aspectRatio;
      }
    }

    this.cropBoxData = cropBoxData;
    this.limitCropBox(true, true);

    // Initialize auto crop area
    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);

    // The width/height of auto crop area must large than "minWidth/Height"
    cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
    cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
    cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
    cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;

    this.initialCropBoxData = assign({}, cropBoxData);
  },
  limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
    var options = this.options,
        containerData = this.containerData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData,
        limited = this.limited;
    var aspectRatio = options.aspectRatio;


    if (sizeLimited) {
      var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
      var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
      var maxCropBoxWidth = Math.min(containerData.width, limited ? canvasData.width : containerData.width);
      var maxCropBoxHeight = Math.min(containerData.height, limited ? canvasData.height : containerData.height);

      // The min/maxCropBoxWidth/Height must be less than container's width/height
      minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
      minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

      if (aspectRatio) {
        if (minCropBoxWidth && minCropBoxHeight) {
          if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }
        } else if (minCropBoxWidth) {
          minCropBoxHeight = minCropBoxWidth / aspectRatio;
        } else if (minCropBoxHeight) {
          minCropBoxWidth = minCropBoxHeight * aspectRatio;
        }

        if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
          maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
        } else {
          maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
        }
      }

      // The minWidth/Height must be less than maxWidth/Height
      cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
      cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
      cropBoxData.maxWidth = maxCropBoxWidth;
      cropBoxData.maxHeight = maxCropBoxHeight;
    }

    if (positionLimited) {
      if (limited) {
        cropBoxData.minLeft = Math.max(0, canvasData.left);
        cropBoxData.minTop = Math.max(0, canvasData.top);
        cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
        cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
      } else {
        cropBoxData.minLeft = 0;
        cropBoxData.minTop = 0;
        cropBoxData.maxLeft = containerData.width - cropBoxData.width;
        cropBoxData.maxTop = containerData.height - cropBoxData.height;
      }
    }
  },
  renderCropBox: function renderCropBox() {
    var options = this.options,
        containerData = this.containerData,
        cropBoxData = this.cropBoxData;


    if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
      cropBoxData.left = cropBoxData.oldLeft;
    }

    if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
      cropBoxData.top = cropBoxData.oldTop;
    }

    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);

    this.limitCropBox(false, true);

    cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
    cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;

    if (options.movable && options.cropBoxMovable) {
      // Turn to move the canvas when the crop box is equal to the container
      setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
    }

    setStyle(this.cropBox, assign({
      width: cropBoxData.width,
      height: cropBoxData.height
    }, getTransforms({
      translateX: cropBoxData.left,
      translateY: cropBoxData.top
    })));

    if (this.cropped && this.limited) {
      this.limitCanvas(true, true);
    }

    if (!this.disabled) {
      this.output();
    }
  },
  output: function output() {
    this.preview();
    dispatchEvent(this.element, EVENT_CROP, this.getData());
  }
};

var preview = {
  initPreview: function initPreview() {
    var crossOrigin = this.crossOrigin;
    var preview = this.options.preview;

    var url = crossOrigin ? this.crossOriginUrl : this.url;
    var image = document.createElement('img');

    if (crossOrigin) {
      image.crossOrigin = crossOrigin;
    }

    image.src = url;
    this.viewBox.appendChild(image);
    this.viewBoxImage = image;

    if (!preview) {
      return;
    }

    var previews = preview;

    if (typeof preview === 'string') {
      previews = this.element.ownerDocument.querySelectorAll(preview);
    } else if (preview.querySelector) {
      previews = [preview];
    }

    this.previews = previews;

    forEach(previews, function (el) {
      var img = document.createElement('img');

      // Save the original size for recover
      setData(el, DATA_PREVIEW, {
        width: el.offsetWidth,
        height: el.offsetHeight,
        html: el.innerHTML
      });

      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }

      img.src = url;

      /**
       * Override img element styles
       * Add `display:block` to avoid margin top issue
       * Add `height:auto` to override `height` attribute on IE8
       * (Occur only when margin-top <= -height)
       */
      img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';

      el.innerHTML = '';
      el.appendChild(img);
    });
  },
  resetPreview: function resetPreview() {
    forEach(this.previews, function (element) {
      var data = getData(element, DATA_PREVIEW);

      setStyle(element, {
        width: data.width,
        height: data.height
      });

      element.innerHTML = data.html;
      removeData(element, DATA_PREVIEW);
    });
  },
  preview: function preview() {
    var imageData = this.imageData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData;
    var cropBoxWidth = cropBoxData.width,
        cropBoxHeight = cropBoxData.height;
    var width = imageData.width,
        height = imageData.height;

    var left = cropBoxData.left - canvasData.left - imageData.left;
    var top = cropBoxData.top - canvasData.top - imageData.top;

    if (!this.cropped || this.disabled) {
      return;
    }

    setStyle(this.viewBoxImage, assign({
      width: width,
      height: height
    }, getTransforms(assign({
      translateX: -left,
      translateY: -top
    }, imageData))));

    forEach(this.previews, function (element) {
      var data = getData(element, DATA_PREVIEW);
      var originalWidth = data.width;
      var originalHeight = data.height;
      var newWidth = originalWidth;
      var newHeight = originalHeight;
      var ratio = 1;

      if (cropBoxWidth) {
        ratio = originalWidth / cropBoxWidth;
        newHeight = cropBoxHeight * ratio;
      }

      if (cropBoxHeight && newHeight > originalHeight) {
        ratio = originalHeight / cropBoxHeight;
        newWidth = cropBoxWidth * ratio;
        newHeight = originalHeight;
      }

      setStyle(element, {
        width: newWidth,
        height: newHeight
      });

      setStyle(element.getElementsByTagName('img')[0], assign({
        width: width * ratio,
        height: height * ratio
      }, getTransforms(assign({
        translateX: -left * ratio,
        translateY: -top * ratio
      }, imageData))));
    });
  }
};

var events = {
  bind: function bind() {
    var element = this.element,
        options = this.options,
        cropper = this.cropper;


    if (isFunction(options.cropstart)) {
      addListener(element, EVENT_CROP_START, options.cropstart);
    }

    if (isFunction(options.cropmove)) {
      addListener(element, EVENT_CROP_MOVE, options.cropmove);
    }

    if (isFunction(options.cropend)) {
      addListener(element, EVENT_CROP_END, options.cropend);
    }

    if (isFunction(options.crop)) {
      addListener(element, EVENT_CROP, options.crop);
    }

    if (isFunction(options.zoom)) {
      addListener(element, EVENT_ZOOM, options.zoom);
    }

    addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

    if (options.zoomable && options.zoomOnWheel) {
      addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this));
    }

    if (options.toggleDragModeOnDblclick) {
      addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }

    addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
    addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

    if (options.responsive) {
      addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
    }
  },
  unbind: function unbind() {
    var element = this.element,
        options = this.options,
        cropper = this.cropper;


    if (isFunction(options.cropstart)) {
      removeListener(element, EVENT_CROP_START, options.cropstart);
    }

    if (isFunction(options.cropmove)) {
      removeListener(element, EVENT_CROP_MOVE, options.cropmove);
    }

    if (isFunction(options.cropend)) {
      removeListener(element, EVENT_CROP_END, options.cropend);
    }

    if (isFunction(options.crop)) {
      removeListener(element, EVENT_CROP, options.crop);
    }

    if (isFunction(options.zoom)) {
      removeListener(element, EVENT_ZOOM, options.zoom);
    }

    removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

    if (options.zoomable && options.zoomOnWheel) {
      removeListener(cropper, EVENT_WHEEL, this.onWheel);
    }

    if (options.toggleDragModeOnDblclick) {
      removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
    }

    removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
    removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

    if (options.responsive) {
      removeListener(window, EVENT_RESIZE, this.onResize);
    }
  }
};

var handlers = {
  resize: function resize() {
    var options = this.options,
        container = this.container,
        containerData = this.containerData;

    var minContainerWidth = Number(options.minContainerWidth) || 200;
    var minContainerHeight = Number(options.minContainerHeight) || 100;

    if (this.disabled || containerData.width <= minContainerWidth || containerData.height <= minContainerHeight) {
      return;
    }

    var ratio = container.offsetWidth / containerData.width;

    // Resize when width changed or height changed
    if (ratio !== 1 || container.offsetHeight !== containerData.height) {
      var canvasData = void 0;
      var cropBoxData = void 0;

      if (options.restore) {
        canvasData = this.getCanvasData();
        cropBoxData = this.getCropBoxData();
      }

      this.render();

      if (options.restore) {
        this.setCanvasData(forEach(canvasData, function (n, i) {
          canvasData[i] = n * ratio;
        }));
        this.setCropBoxData(forEach(cropBoxData, function (n, i) {
          cropBoxData[i] = n * ratio;
        }));
      }
    }
  },
  dblclick: function dblclick() {
    if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
      return;
    }

    this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
  },
  wheel: function wheel(e) {
    var _this = this;

    var ratio = Number(this.options.wheelZoomRatio) || 0.1;
    var delta = 1;

    if (this.disabled) {
      return;
    }

    e.preventDefault();

    // Limit wheel speed to prevent zoom too fast (#21)
    if (this.wheeling) {
      return;
    }

    this.wheeling = true;

    setTimeout(function () {
      _this.wheeling = false;
    }, 50);

    if (e.deltaY) {
      delta = e.deltaY > 0 ? 1 : -1;
    } else if (e.wheelDelta) {
      delta = -e.wheelDelta / 120;
    } else if (e.detail) {
      delta = e.detail > 0 ? 1 : -1;
    }

    this.zoom(-delta * ratio, e);
  },
  cropStart: function cropStart(e) {
    if (this.disabled) {
      return;
    }

    var options = this.options,
        pointers = this.pointers;

    var action = void 0;

    if (e.changedTouches) {
      // Handle touch event
      forEach(e.changedTouches, function (touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      // Handle mouse event and pointer event
      pointers[e.pointerId || 0] = getPointer(e);
    }

    if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
      action = ACTION_ZOOM;
    } else {
      action = getData(e.target, DATA_ACTION);
    }

    if (!REGEXP_ACTIONS.test(action)) {
      return;
    }

    if (dispatchEvent(this.element, EVENT_CROP_START, {
      originalEvent: e,
      action: action
    }) === false) {
      return;
    }

    // This line is required for preventing page zooming in iOS browsers
    e.preventDefault();

    this.action = action;
    this.cropping = false;

    if (action === ACTION_CROP) {
      this.cropping = true;
      addClass(this.dragBox, CLASS_MODAL);
    }
  },
  cropMove: function cropMove(e) {
    var action = this.action;


    if (this.disabled || !action) {
      return;
    }

    var pointers = this.pointers;


    e.preventDefault();

    if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
      originalEvent: e,
      action: action
    }) === false) {
      return;
    }

    if (e.changedTouches) {
      forEach(e.changedTouches, function (touch) {
        assign(pointers[touch.identifier], getPointer(touch, true));
      });
    } else {
      assign(pointers[e.pointerId || 0], getPointer(e, true));
    }

    this.change(e);
  },
  cropEnd: function cropEnd(e) {
    if (this.disabled) {
      return;
    }

    var action = this.action,
        pointers = this.pointers;


    if (e.changedTouches) {
      forEach(e.changedTouches, function (touch) {
        delete pointers[touch.identifier];
      });
    } else {
      delete pointers[e.pointerId || 0];
    }

    if (!action) {
      return;
    }

    e.preventDefault();

    if (!Object.keys(pointers).length) {
      this.action = '';
    }

    if (this.cropping) {
      this.cropping = false;
      toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
    }

    dispatchEvent(this.element, EVENT_CROP_END, {
      originalEvent: e,
      action: action
    });
  }
};

var change = {
  change: function change(e) {
    var options = this.options,
        canvasData = this.canvasData,
        containerData = this.containerData,
        cropBoxData = this.cropBoxData,
        pointers = this.pointers;
    var action = this.action;
    var aspectRatio = options.aspectRatio;
    var left = cropBoxData.left,
        top = cropBoxData.top,
        width = cropBoxData.width,
        height = cropBoxData.height;

    var right = left + width;
    var bottom = top + height;
    var minLeft = 0;
    var minTop = 0;
    var maxWidth = containerData.width;
    var maxHeight = containerData.height;
    var renderable = true;
    var offset = void 0;

    // Locking aspect ratio in "free mode" by holding shift key
    if (!aspectRatio && e.shiftKey) {
      aspectRatio = width && height ? width / height : 1;
    }

    if (this.limited) {
      minLeft = cropBoxData.minLeft;
      minTop = cropBoxData.minTop;

      maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
      maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
    }

    var pointer = pointers[Object.keys(pointers)[0]];
    var range = {
      x: pointer.endX - pointer.startX,
      y: pointer.endY - pointer.startY
    };
    var check = function check(side) {
      switch (side) {
        case ACTION_EAST:
          if (right + range.x > maxWidth) {
            range.x = maxWidth - right;
          }

          break;

        case ACTION_WEST:
          if (left + range.x < minLeft) {
            range.x = minLeft - left;
          }

          break;

        case ACTION_NORTH:
          if (top + range.y < minTop) {
            range.y = minTop - top;
          }

          break;

        case ACTION_SOUTH:
          if (bottom + range.y > maxHeight) {
            range.y = maxHeight - bottom;
          }

          break;

        default:
      }
    };

    switch (action) {
      // Move crop box
      case ACTION_ALL:
        left += range.x;
        top += range.y;
        break;

      // Resize crop box
      case ACTION_EAST:
        if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }

        check(ACTION_EAST);
        width += range.x;

        if (width < 0) {
          action = ACTION_WEST;
          width = -width;
          left -= width;
        }

        if (aspectRatio) {
          height = width / aspectRatio;
          top += (cropBoxData.height - height) / 2;
        }

        break;

      case ACTION_NORTH:
        if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }

        check(ACTION_NORTH);
        height -= range.y;
        top += range.y;

        if (height < 0) {
          action = ACTION_SOUTH;
          height = -height;
          top -= height;
        }

        if (aspectRatio) {
          width = height * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }

        break;

      case ACTION_WEST:
        if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }

        check(ACTION_WEST);
        width -= range.x;
        left += range.x;

        if (width < 0) {
          action = ACTION_EAST;
          width = -width;
          left -= width;
        }

        if (aspectRatio) {
          height = width / aspectRatio;
          top += (cropBoxData.height - height) / 2;
        }

        break;

      case ACTION_SOUTH:
        if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }

        check(ACTION_SOUTH);
        height += range.y;

        if (height < 0) {
          action = ACTION_NORTH;
          height = -height;
          top -= height;
        }

        if (aspectRatio) {
          width = height * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }

        break;

      case ACTION_NORTH_EAST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;
          width = height * aspectRatio;
        } else {
          check(ACTION_NORTH);
          check(ACTION_EAST);

          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width += range.x;
          }

          if (range.y <= 0) {
            if (top > minTop) {
              height -= range.y;
              top += range.y;
            }
          } else {
            height -= range.y;
            top += range.y;
          }
        }

        if (width < 0 && height < 0) {
          action = ACTION_SOUTH_WEST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_WEST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_SOUTH_EAST;
          height = -height;
          top -= height;
        }

        break;

      case ACTION_NORTH_WEST:
        if (aspectRatio) {
          if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;
          width = height * aspectRatio;
          left += cropBoxData.width - width;
        } else {
          check(ACTION_NORTH);
          check(ACTION_WEST);

          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }

          if (range.y <= 0) {
            if (top > minTop) {
              height -= range.y;
              top += range.y;
            }
          } else {
            height -= range.y;
            top += range.y;
          }
        }

        if (width < 0 && height < 0) {
          action = ACTION_SOUTH_EAST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_EAST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_SOUTH_WEST;
          height = -height;
          top -= height;
        }

        break;

      case ACTION_SOUTH_WEST:
        if (aspectRatio) {
          if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;
          height = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_WEST);

          if (range.x <= 0) {
            if (left > minLeft) {
              width -= range.x;
              left += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width -= range.x;
            left += range.x;
          }

          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height += range.y;
            }
          } else {
            height += range.y;
          }
        }

        if (width < 0 && height < 0) {
          action = ACTION_NORTH_EAST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_EAST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_NORTH_WEST;
          height = -height;
          top -= height;
        }

        break;

      case ACTION_SOUTH_EAST:
        if (aspectRatio) {
          if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;
          height = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_EAST);

          if (range.x >= 0) {
            if (right < maxWidth) {
              width += range.x;
            } else if (range.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width += range.x;
          }

          if (range.y >= 0) {
            if (bottom < maxHeight) {
              height += range.y;
            }
          } else {
            height += range.y;
          }
        }

        if (width < 0 && height < 0) {
          action = ACTION_NORTH_WEST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_WEST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_NORTH_EAST;
          height = -height;
          top -= height;
        }

        break;

      // Move canvas
      case ACTION_MOVE:
        this.move(range.x, range.y);
        renderable = false;
        break;

      // Zoom canvas
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), e);
        renderable = false;
        break;

      // Create crop box
      case ACTION_CROP:
        if (!range.x || !range.y) {
          renderable = false;
          break;
        }

        offset = getOffset(this.cropper);
        left = pointer.startX - offset.left;
        top = pointer.startY - offset.top;
        width = cropBoxData.minWidth;
        height = cropBoxData.minHeight;

        if (range.x > 0) {
          action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
        } else if (range.x < 0) {
          left -= width;
          action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
        }

        if (range.y < 0) {
          top -= height;
        }

        // Show the crop box if is hidden
        if (!this.cropped) {
          removeClass(this.cropBox, CLASS_HIDDEN);
          this.cropped = true;

          if (this.limited) {
            this.limitCropBox(true, true);
          }
        }

        break;

      default:
    }

    if (renderable) {
      cropBoxData.width = width;
      cropBoxData.height = height;
      cropBoxData.left = left;
      cropBoxData.top = top;
      this.action = action;
      this.renderCropBox();
    }

    // Override
    forEach(pointers, function (p) {
      p.startX = p.endX;
      p.startY = p.endY;
    });
  }
};

var methods = {
  // Show the crop box manually
  crop: function crop() {
    if (this.ready && !this.cropped && !this.disabled) {
      this.cropped = true;
      this.limitCropBox(true, true);

      if (this.options.modal) {
        addClass(this.dragBox, CLASS_MODAL);
      }

      removeClass(this.cropBox, CLASS_HIDDEN);
      this.setCropBoxData(this.initialCropBoxData);
    }

    return this;
  },


  // Reset the image and crop box to their initial states
  reset: function reset() {
    if (this.ready && !this.disabled) {
      this.imageData = assign({}, this.initialImageData);
      this.canvasData = assign({}, this.initialCanvasData);
      this.cropBoxData = assign({}, this.initialCropBoxData);
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    }

    return this;
  },


  // Clear the crop box
  clear: function clear() {
    if (this.cropped && !this.disabled) {
      assign(this.cropBoxData, {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      });

      this.cropped = false;
      this.renderCropBox();
      this.limitCanvas(true, true);

      // Render canvas after crop box rendered
      this.renderCanvas();
      removeClass(this.dragBox, CLASS_MODAL);
      addClass(this.cropBox, CLASS_HIDDEN);
    }

    return this;
  },


  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function replace(url) {
    var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!this.disabled && url) {
      if (this.isImg) {
        this.element.src = url;
      }

      if (hasSameSize) {
        this.url = url;
        this.image.src = url;

        if (this.ready) {
          this.viewBoxImage.src = url;

          forEach(this.previews, function (element) {
            element.getElementsByTagName('img')[0].src = url;
          });
        }
      } else {
        if (this.isImg) {
          this.replaced = true;
        }

        this.options.data = null;
        this.uncreate();
        this.load(url);
      }
    }

    return this;
  },


  // Enable (unfreeze) the cropper
  enable: function enable() {
    if (this.ready && this.disabled) {
      this.disabled = false;
      removeClass(this.cropper, CLASS_DISABLED);
    }

    return this;
  },


  // Disable (freeze) the cropper
  disable: function disable() {
    if (this.ready && !this.disabled) {
      this.disabled = true;
      addClass(this.cropper, CLASS_DISABLED);
    }

    return this;
  },


  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function destroy() {
    var element = this.element;


    if (!getData(element, NAMESPACE)) {
      return this;
    }

    if (this.isImg && this.replaced) {
      element.src = this.originalUrl;
    }

    this.uncreate();
    removeData(element, NAMESPACE);

    return this;
  },


  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function move(offsetX) {
    var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
    var _canvasData = this.canvasData,
        left = _canvasData.left,
        top = _canvasData.top;


    return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
  },


  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function moveTo(x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    var canvasData = this.canvasData;

    var changed = false;

    x = Number(x);
    y = Number(y);

    if (this.ready && !this.disabled && this.options.movable) {
      if (isNumber(x)) {
        canvasData.left = x;
        changed = true;
      }

      if (isNumber(y)) {
        canvasData.top = y;
        changed = true;
      }

      if (changed) {
        this.renderCanvas(true);
      }
    }

    return this;
  },


  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function zoom(ratio, _originalEvent) {
    var canvasData = this.canvasData;


    ratio = Number(ratio);

    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }

    return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
  },


  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
    var options = this.options,
        canvasData = this.canvasData;
    var width = canvasData.width,
        height = canvasData.height,
        naturalWidth = canvasData.naturalWidth,
        naturalHeight = canvasData.naturalHeight;


    ratio = Number(ratio);

    if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
      var newWidth = naturalWidth * ratio;
      var newHeight = naturalHeight * ratio;

      if (dispatchEvent(this.element, EVENT_ZOOM, {
        ratio: ratio,
        oldRatio: width / naturalWidth,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }

      if (_originalEvent) {
        var pointers = this.pointers;

        var offset = getOffset(this.cropper);
        var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };

        // Zoom from the triggering point of the event
        canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
        canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
      } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
        canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
        canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
      } else {
        // Zoom from the center of the canvas
        canvasData.left -= (newWidth - width) / 2;
        canvasData.top -= (newHeight - height) / 2;
      }

      canvasData.width = newWidth;
      canvasData.height = newHeight;
      this.renderCanvas(true);
    }

    return this;
  },


  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function rotate(degree) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
  },


  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function rotateTo(degree) {
    degree = Number(degree);

    if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
      this.imageData.rotate = degree % 360;
      this.renderCanvas(true, true);
    }

    return this;
  },


  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function scaleX(_scaleX) {
    var scaleY = this.imageData.scaleY;


    return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
  },


  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function scaleY(_scaleY) {
    var scaleX = this.imageData.scaleX;


    return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
  },


  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function scale(scaleX) {
    var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
    var imageData = this.imageData;

    var transformed = false;

    scaleX = Number(scaleX);
    scaleY = Number(scaleY);

    if (this.ready && !this.disabled && this.options.scalable) {
      if (isNumber(scaleX)) {
        imageData.scaleX = scaleX;
        transformed = true;
      }

      if (isNumber(scaleY)) {
        imageData.scaleY = scaleY;
        transformed = true;
      }

      if (transformed) {
        this.renderCanvas(true, true);
      }
    }

    return this;
  },


  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function getData$$1() {
    var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var options = this.options,
        imageData = this.imageData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData;

    var data = void 0;

    if (this.ready && this.cropped) {
      data = {
        x: cropBoxData.left - canvasData.left,
        y: cropBoxData.top - canvasData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };

      var ratio = imageData.width / imageData.naturalWidth;

      forEach(data, function (n, i) {
        data[i] = n / ratio;
      });

      if (rounded) {
        // In case rounding off leads to extra 1px in right or bottom border
        // we should round the top-left corner and the dimension (#343).
        var bottom = Math.round(data.y + data.height);
        var right = Math.round(data.x + data.width);

        data.x = Math.round(data.x);
        data.y = Math.round(data.y);
        data.width = right - data.x;
        data.height = bottom - data.y;
      }
    } else {
      data = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }

    if (options.rotatable) {
      data.rotate = imageData.rotate || 0;
    }

    if (options.scalable) {
      data.scaleX = imageData.scaleX || 1;
      data.scaleY = imageData.scaleY || 1;
    }

    return data;
  },


  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function setData$$1(data) {
    var options = this.options,
        imageData = this.imageData,
        canvasData = this.canvasData;

    var cropBoxData = {};

    if (this.ready && !this.disabled && isPlainObject(data)) {
      var transformed = false;

      if (options.rotatable) {
        if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
          imageData.rotate = data.rotate;
          transformed = true;
        }
      }

      if (options.scalable) {
        if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
          imageData.scaleX = data.scaleX;
          transformed = true;
        }

        if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
          imageData.scaleY = data.scaleY;
          transformed = true;
        }
      }

      if (transformed) {
        this.renderCanvas(true, true);
      }

      var ratio = imageData.width / imageData.naturalWidth;

      if (isNumber(data.x)) {
        cropBoxData.left = data.x * ratio + canvasData.left;
      }

      if (isNumber(data.y)) {
        cropBoxData.top = data.y * ratio + canvasData.top;
      }

      if (isNumber(data.width)) {
        cropBoxData.width = data.width * ratio;
      }

      if (isNumber(data.height)) {
        cropBoxData.height = data.height * ratio;
      }

      this.setCropBoxData(cropBoxData);
    }

    return this;
  },


  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function getContainerData() {
    return this.ready ? assign({}, this.containerData) : {};
  },


  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function getImageData() {
    return this.sized ? assign({}, this.imageData) : {};
  },


  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function getCanvasData() {
    var canvasData = this.canvasData;

    var data = {};

    if (this.ready) {
      forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
        data[n] = canvasData[n];
      });
    }

    return data;
  },


  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function setCanvasData(data) {
    var canvasData = this.canvasData;
    var aspectRatio = canvasData.aspectRatio;


    if (this.ready && !this.disabled && isPlainObject(data)) {
      if (isNumber(data.left)) {
        canvasData.left = data.left;
      }

      if (isNumber(data.top)) {
        canvasData.top = data.top;
      }

      if (isNumber(data.width)) {
        canvasData.width = data.width;
        canvasData.height = data.width / aspectRatio;
      } else if (isNumber(data.height)) {
        canvasData.height = data.height;
        canvasData.width = data.height * aspectRatio;
      }

      this.renderCanvas(true);
    }

    return this;
  },


  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function getCropBoxData() {
    var cropBoxData = this.cropBoxData;

    var data = void 0;

    if (this.ready && this.cropped) {
      data = {
        left: cropBoxData.left,
        top: cropBoxData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };
    }

    return data || {};
  },


  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function setCropBoxData(data) {
    var cropBoxData = this.cropBoxData;
    var aspectRatio = this.options.aspectRatio;

    var widthChanged = void 0;
    var heightChanged = void 0;

    if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
      if (isNumber(data.left)) {
        cropBoxData.left = data.left;
      }

      if (isNumber(data.top)) {
        cropBoxData.top = data.top;
      }

      if (isNumber(data.width) && data.width !== cropBoxData.width) {
        widthChanged = true;
        cropBoxData.width = data.width;
      }

      if (isNumber(data.height) && data.height !== cropBoxData.height) {
        heightChanged = true;
        cropBoxData.height = data.height;
      }

      if (aspectRatio) {
        if (widthChanged) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else if (heightChanged) {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.renderCropBox();
    }

    return this;
  },


  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function getCroppedCanvas() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!this.ready || !window.HTMLCanvasElement) {
      return null;
    }

    var canvasData = this.canvasData;

    var source = getSourceCanvas(this.image, this.imageData, canvasData, options);

    // Returns the source canvas if it is not cropped.
    if (!this.cropped) {
      return source;
    }

    var _getData = this.getData(),
        initialX = _getData.x,
        initialY = _getData.y,
        initialWidth = _getData.width,
        initialHeight = _getData.height;

    var ratio = source.width / Math.floor(canvasData.naturalWidth);

    if (ratio !== 1) {
      initialX *= ratio;
      initialY *= ratio;
      initialWidth *= ratio;
      initialHeight *= ratio;
    }

    var aspectRatio = initialWidth / initialHeight;
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: options.maxWidth || Infinity,
      height: options.maxHeight || Infinity
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: options.minWidth || 0,
      height: options.minHeight || 0
    }, 'cover');

    var _getAdjustedSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: options.width || (ratio !== 1 ? source.width : initialWidth),
      height: options.height || (ratio !== 1 ? source.height : initialHeight)
    }),
        width = _getAdjustedSizes.width,
        height = _getAdjustedSizes.height;

    width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
    height = Math.min(maxSizes.height, Math.max(minSizes.height, height));

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);

    context.fillStyle = options.fillColor || 'transparent';
    context.fillRect(0, 0, width, height);

    var _options$imageSmoothi = options.imageSmoothingEnabled,
        imageSmoothingEnabled = _options$imageSmoothi === undefined ? true : _options$imageSmoothi,
        imageSmoothingQuality = options.imageSmoothingQuality;


    context.imageSmoothingEnabled = imageSmoothingEnabled;

    if (imageSmoothingQuality) {
      context.imageSmoothingQuality = imageSmoothingQuality;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
    var sourceWidth = source.width;
    var sourceHeight = source.height;

    // Source canvas parameters
    var srcX = initialX;
    var srcY = initialY;
    var srcWidth = void 0;
    var srcHeight = void 0;

    // Destination canvas parameters
    var dstX = void 0;
    var dstY = void 0;
    var dstWidth = void 0;
    var dstHeight = void 0;

    if (srcX <= -initialWidth || srcX > sourceWidth) {
      srcX = 0;
      srcWidth = 0;
      dstX = 0;
      dstWidth = 0;
    } else if (srcX <= 0) {
      dstX = -srcX;
      srcX = 0;
      srcWidth = Math.min(sourceWidth, initialWidth + srcX);
      dstWidth = srcWidth;
    } else if (srcX <= sourceWidth) {
      dstX = 0;
      srcWidth = Math.min(initialWidth, sourceWidth - srcX);
      dstWidth = srcWidth;
    }

    if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
      srcY = 0;
      srcHeight = 0;
      dstY = 0;
      dstHeight = 0;
    } else if (srcY <= 0) {
      dstY = -srcY;
      srcY = 0;
      srcHeight = Math.min(sourceHeight, initialHeight + srcY);
      dstHeight = srcHeight;
    } else if (srcY <= sourceHeight) {
      dstY = 0;
      srcHeight = Math.min(initialHeight, sourceHeight - srcY);
      dstHeight = srcHeight;
    }

    var params = [srcX, srcY, srcWidth, srcHeight];

    // Avoid "IndexSizeError"
    if (dstWidth > 0 && dstHeight > 0) {
      var scale = width / initialWidth;

      params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
    }

    // All the numerical parameters should be integer for `drawImage`
    // https://github.com/fengyuanchen/cropper/issues/476
    context.drawImage.apply(context, [source].concat(toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));

    return canvas;
  },


  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function setAspectRatio(aspectRatio) {
    var options = this.options;


    if (!this.disabled && !isUndefined(aspectRatio)) {
      // 0 -> NaN
      options.aspectRatio = Math.max(0, aspectRatio) || NaN;

      if (this.ready) {
        this.initCropBox();

        if (this.cropped) {
          this.renderCropBox();
        }
      }
    }

    return this;
  },


  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function setDragMode(mode) {
    var options = this.options,
        dragBox = this.dragBox,
        face = this.face;


    if (this.ready && !this.disabled) {
      var croppable = mode === DRAG_MODE_CROP;
      var movable = options.movable && mode === DRAG_MODE_MOVE;

      mode = croppable || movable ? mode : DRAG_MODE_NONE;

      options.dragMode = mode;
      setData(dragBox, DATA_ACTION, mode);
      toggleClass(dragBox, CLASS_CROP, croppable);
      toggleClass(dragBox, CLASS_MOVE, movable);

      if (!options.cropBoxMovable) {
        // Sync drag mode to crop box when it is not movable
        setData(face, DATA_ACTION, mode);
        toggleClass(face, CLASS_CROP, croppable);
        toggleClass(face, CLASS_MOVE, movable);
      }
    }

    return this;
  }
};

var AnotherCropper = WINDOW.Cropper;

var Cropper = function () {
  /**
   * Create a new Cropper.
   * @param {Element} element - The target element for cropping.
   * @param {Object} [options={}] - The configuration options.
   */
  function Cropper(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, Cropper);

    if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
      throw new Error('The first argument is required and must be an <img> or <canvas> element.');
    }

    this.element = element;
    this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
    this.cropped = false;
    this.disabled = false;
    this.pointers = {};
    this.ready = false;
    this.reloading = false;
    this.replaced = false;
    this.sized = false;
    this.sizing = false;
    this.init();
  }

  createClass(Cropper, [{
    key: 'init',
    value: function init() {
      var element = this.element;

      var tagName = element.tagName.toLowerCase();
      var url = void 0;

      if (getData(element, NAMESPACE)) {
        return;
      }

      setData(element, NAMESPACE, this);

      if (tagName === 'img') {
        this.isImg = true;

        // e.g.: "img/picture.jpg"
        url = element.getAttribute('src') || '';
        this.originalUrl = url;

        // Stop when it's a blank image
        if (!url) {
          return;
        }

        // e.g.: "http://example.com/img/picture.jpg"
        url = element.src;
      } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
        url = element.toDataURL();
      }

      this.load(url);
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this = this;

      if (!url) {
        return;
      }

      this.url = url;
      this.imageData = {};

      var element = this.element,
          options = this.options;


      if (!options.rotatable && !options.scalable) {
        options.checkOrientation = false;
      }

      if (!options.checkOrientation || !window.ArrayBuffer) {
        this.clone();
        return;
      }

      // XMLHttpRequest disallows to open a Data URL in some browsers like IE11 and Safari
      if (REGEXP_DATA_URL.test(url)) {
        if (REGEXP_DATA_URL_JPEG.test(url)) {
          this.read(dataURLToArrayBuffer(url));
        } else {
          this.clone();
        }

        return;
      }

      var xhr = new XMLHttpRequest();

      this.reloading = true;
      this.xhr = xhr;

      var done = function done() {
        _this.reloading = false;
        _this.xhr = null;
      };

      xhr.ontimeout = done;
      xhr.onabort = done;
      xhr.onerror = function () {
        done();
        _this.clone();
      };

      xhr.onload = function () {
        done();
        _this.read(xhr.response);
      };

      // Bust cache when there is a "crossOrigin" property
      if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
        url = addTimestamp(url);
      }

      xhr.open('get', url);
      xhr.responseType = 'arraybuffer';
      xhr.withCredentials = element.crossOrigin === 'use-credentials';
      xhr.send();
    }
  }, {
    key: 'read',
    value: function read(arrayBuffer) {
      var options = this.options,
          imageData = this.imageData;

      var orientation = getOrientation(arrayBuffer);
      var rotate = 0;
      var scaleX = 1;
      var scaleY = 1;

      if (orientation > 1) {
        this.url = arrayBufferToDataURL(arrayBuffer, 'image/jpeg');

        var _parseOrientation = parseOrientation(orientation);

        rotate = _parseOrientation.rotate;
        scaleX = _parseOrientation.scaleX;
        scaleY = _parseOrientation.scaleY;
      }

      if (options.rotatable) {
        imageData.rotate = rotate;
      }

      if (options.scalable) {
        imageData.scaleX = scaleX;
        imageData.scaleY = scaleY;
      }

      this.clone();
    }
  }, {
    key: 'clone',
    value: function clone() {
      var element = this.element,
          url = this.url;

      var crossOrigin = void 0;
      var crossOriginUrl = void 0;

      if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
        crossOrigin = element.crossOrigin;


        if (crossOrigin) {
          crossOriginUrl = url;
        } else {
          crossOrigin = 'anonymous';

          // Bust cache when there is not a "crossOrigin" property
          crossOriginUrl = addTimestamp(url);
        }
      }

      this.crossOrigin = crossOrigin;
      this.crossOriginUrl = crossOriginUrl;

      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = crossOriginUrl || url;
      this.image = image;
      image.onload = this.start.bind(this);
      image.onerror = this.stop.bind(this);
      addClass(image, CLASS_HIDE);
      element.parentNode.insertBefore(image, element.nextSibling);
    }
  }, {
    key: 'start',
    value: function start() {
      var _this2 = this;

      var image = this.isImg ? this.element : this.image;

      image.onload = null;
      image.onerror = null;
      this.sizing = true;

      var IS_SAFARI = WINDOW.navigator && /(Macintosh|iPhone|iPod|iPad).*AppleWebKit/i.test(WINDOW.navigator.userAgent);
      var done = function done(naturalWidth, naturalHeight) {
        assign(_this2.imageData, {
          naturalWidth: naturalWidth,
          naturalHeight: naturalHeight,
          aspectRatio: naturalWidth / naturalHeight
        });
        _this2.sizing = false;
        _this2.sized = true;
        _this2.build();
      };

      // Modern browsers (except Safari)
      if (image.naturalWidth && !IS_SAFARI) {
        done(image.naturalWidth, image.naturalHeight);
        return;
      }

      var sizingImage = document.createElement('img');
      var body = document.body || document.documentElement;

      this.sizingImage = sizingImage;

      sizingImage.onload = function () {
        done(sizingImage.width, sizingImage.height);

        if (!IS_SAFARI) {
          body.removeChild(sizingImage);
        }
      };

      sizingImage.src = image.src;

      // iOS Safari will convert the image automatically
      // with its orientation once append it into DOM (#279)
      if (!IS_SAFARI) {
        sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
        body.appendChild(sizingImage);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var image = this.image;


      image.onload = null;
      image.onerror = null;
      image.parentNode.removeChild(image);
      this.image = null;
    }
  }, {
    key: 'build',
    value: function build() {
      if (!this.sized || this.ready) {
        return;
      }

      var element = this.element,
          options = this.options,
          image = this.image;

      // Create cropper elements

      var container = element.parentNode;
      var template = document.createElement('div');

      template.innerHTML = TEMPLATE;

      var cropper = template.querySelector('.' + NAMESPACE + '-container');
      var canvas = cropper.querySelector('.' + NAMESPACE + '-canvas');
      var dragBox = cropper.querySelector('.' + NAMESPACE + '-drag-box');
      var cropBox = cropper.querySelector('.' + NAMESPACE + '-crop-box');
      var face = cropBox.querySelector('.' + NAMESPACE + '-face');

      this.container = container;
      this.cropper = cropper;
      this.canvas = canvas;
      this.dragBox = dragBox;
      this.cropBox = cropBox;
      this.viewBox = cropper.querySelector('.' + NAMESPACE + '-view-box');
      this.face = face;

      canvas.appendChild(image);

      // Hide the original image
      addClass(element, CLASS_HIDDEN);

      // Inserts the cropper after to the current image
      container.insertBefore(cropper, element.nextSibling);

      // Show the image if is hidden
      if (!this.isImg) {
        removeClass(image, CLASS_HIDE);
      }

      this.initPreview();
      this.bind();

      options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
      options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
      options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;

      addClass(cropBox, CLASS_HIDDEN);

      if (!options.guides) {
        addClass(cropBox.getElementsByClassName(NAMESPACE + '-dashed'), CLASS_HIDDEN);
      }

      if (!options.center) {
        addClass(cropBox.getElementsByClassName(NAMESPACE + '-center'), CLASS_HIDDEN);
      }

      if (options.background) {
        addClass(cropper, NAMESPACE + '-bg');
      }

      if (!options.highlight) {
        addClass(face, CLASS_INVISIBLE);
      }

      if (options.cropBoxMovable) {
        addClass(face, CLASS_MOVE);
        setData(face, DATA_ACTION, ACTION_ALL);
      }

      if (!options.cropBoxResizable) {
        addClass(cropBox.getElementsByClassName(NAMESPACE + '-line'), CLASS_HIDDEN);
        addClass(cropBox.getElementsByClassName(NAMESPACE + '-point'), CLASS_HIDDEN);
      }

      this.render();
      this.ready = true;
      this.setDragMode(options.dragMode);

      if (options.autoCrop) {
        this.crop();
      }

      this.setData(options.data);

      if (isFunction(options.ready)) {
        addListener(element, EVENT_READY, options.ready, {
          once: true
        });
      }

      dispatchEvent(element, EVENT_READY);
    }
  }, {
    key: 'unbuild',
    value: function unbuild() {
      if (!this.ready) {
        return;
      }

      this.ready = false;
      this.unbind();
      this.resetPreview();
      this.cropper.parentNode.removeChild(this.cropper);
      removeClass(this.element, CLASS_HIDDEN);
    }
  }, {
    key: 'uncreate',
    value: function uncreate() {
      if (this.ready) {
        this.unbuild();
        this.ready = false;
        this.cropped = false;
      } else if (this.sizing) {
        this.sizingImage.onload = null;
        this.sizing = false;
        this.sized = false;
      } else if (this.reloading) {
        this.xhr.abort();
      } else if (this.image) {
        this.stop();
      }
    }

    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */

  }], [{
    key: 'noConflict',
    value: function noConflict() {
      window.Cropper = AnotherCropper;
      return Cropper;
    }

    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */

  }, {
    key: 'setDefaults',
    value: function setDefaults(options) {
      assign(DEFAULTS, isPlainObject(options) && options);
    }
  }]);
  return Cropper;
}();

assign(Cropper.prototype, render, preview, events, handlers, change, methods);

/* harmony default export */ __webpack_exports__["default"] = (Cropper);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(171);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(71)("376d3159", content, true, {});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, "/*!\n * Cropper.js v1.4.0\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2018-06-01T15:18:09.891Z\n */.cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cropper-container img{display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-canvas,.cropper-wrap-box{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:.5}.cropper-view-box{display:block;height:100%;outline-color:rgba(51,153,255,.75);outline:1px solid #39f;overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}.cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}.cropper-center:after,.cropper-center:before{background-color:#eee;content:\" \";display:block;position:absolute}.cropper-center:before{height:1px;left:-3px;top:0;width:7px}.cropper-center:after{height:7px;left:0;top:-3px;width:1px}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){.cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){.cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){.cropper-point.point-se{height:5px;opacity:.75;width:5px}}.cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:\" \";display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}.cropper-invisible{opacity:0}.cropper-bg{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC\")}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}", ""]);

// exports


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_vm._l((_vm.report),function(data){return [_c('div',{staticClass:"col-xs-12 col-m-6 d-f"},[_c('div',{staticClass:"profile"},[(_vm.type == 0)?[_c('div',{staticClass:"row main-end"},[_c('div',{staticClass:"col-xs"},[_c('button',{staticClass:"btn--edit",on:{"click":function($event){_vm.edit(data)}}},[_c('i',{staticClass:"icon-edit"})])])])]:_vm._e(),_c('div',{staticClass:"profile__wrapper-image"},[_c('img',{staticClass:"profile__user-image parent",attrs:{"src":data.url_imagen,"id":'avatar' + data.idperson},on:{"error":function($event){_vm.detectedImages(data)}}}),(_vm.type == 0)?[_c('div',{staticClass:"profile__user-option"},[_c('label',{staticClass:"btn--edit",attrs:{"for":'upload-image' + data.idperson}},[_c('input',{staticClass:"u-hidden",attrs:{"type":"file","id":'upload-image' + data.idperson,"accept":"image/*"},on:{"click":function($event){_vm.setImage(data.idperson)}}}),_c('i',{staticClass:"icon-edit"})])])]:_vm._e()],2),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(data.nombre)+" "+_vm._s(data.apellidos))])]),_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("("+_vm._s(data.descripcion)+")")])]),_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"font-size-small"},[_vm._v("DNI: "+_vm._s(data.dni))])])]),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-4"},[_c('small',[_vm._v("Teléfono")]),_c('p',[_vm._v(_vm._s(data.telefono))])]),_c('div',{staticClass:"col-xs-12"},[_c('small',[_vm._v("Email")]),_c('p',{domProps:{"textContent":_vm._s(data.email == '' ? '-' : data.email )}})]),_c('div',{staticClass:"col-xs-12"},[_c('small',[_vm._v("Dirección")]),_c('p',[_vm._v(_vm._s(data.direccion.toUpperCase()))])])])],2)])]})],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)],_c('modal',{attrs:{"active":_vm.dataEdit},on:{"update:active":function($event){_vm.dataEdit=$event}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v("Editar información")])])])]),_c('template',{slot:"body"},[(_vm.isEditing)?[_c('form',{staticClass:"row p-5",on:{"submit":function($event){$event.preventDefault();_vm.save()}}},[_c('div',{staticClass:"input-field col-xs-12 col-xm-6"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Nombres")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEditing.nombre),expression:"isEditing.nombre"}],staticClass:"input-field__input",attrs:{"type":"text"},domProps:{"value":(_vm.isEditing.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.isEditing, "nombre", $event.target.value)}}})]),_c('div',{staticClass:"input-field col-xs-12 col-xm-6"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Apellidos")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEditing.apellidos),expression:"isEditing.apellidos"}],staticClass:"input-field__input",attrs:{"type":"text"},domProps:{"value":(_vm.isEditing.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.isEditing, "apellidos", $event.target.value)}}})]),_c('div',{staticClass:"input-field col-xs-12 col-xm-6 col-l-4"},[_c('label',{staticClass:"input-field__label"},[_vm._v("DNI")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEditing.dni),expression:"isEditing.dni"}],staticClass:"input-field__input",attrs:{"type":"text"},domProps:{"value":(_vm.isEditing.dni)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.isEditing, "dni", $event.target.value)}}})]),_c('div',{staticClass:"input-field col-xs-12 col-xm-6 col-l-4"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Teléfono")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEditing.telefono),expression:"isEditing.telefono"}],staticClass:"input-field__input",attrs:{"type":"text"},domProps:{"value":(_vm.isEditing.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.isEditing, "telefono", $event.target.value)}}})]),_c('div',{staticClass:"input-field col-xs-12 col-xm-6 col-l-4"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Email")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEditing.email),expression:"isEditing.email"}],staticClass:"input-field__input",attrs:{"type":"email"},domProps:{"value":(_vm.isEditing.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.isEditing, "email", $event.target.value)}}})]),_c('div',{staticClass:"input-field col-xs-12 col-xm-6 col-l-12"},[_c('label',{staticClass:"input-field__label"},[_vm._v("Dirección")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEditing.direccion),expression:"isEditing.direccion"}],staticClass:"input-field__input",attrs:{"type":"text"},domProps:{"value":(_vm.isEditing.direccion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.isEditing, "direccion", $event.target.value)}}})]),_c('div',{staticClass:"col-xs m-b"},[_c('button',{staticClass:"btn--primary",attrs:{"type":"submit"}},[_vm._v("Guardar")])])])]:_vm._e()],2)],2),_c('modal',{attrs:{"active":_vm.photoEdit},on:{"update:active":function($event){_vm.photoEdit=$event}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v("Editar Foto")])])])]),_c('template',{slot:"body"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12 col-m-6"},[_c('vue-cropper',{ref:"cropper",attrs:{"alt":"Source Image","cropmove":_vm.cropImage,"aspectRatio":2.4/3.1,"autoCropArea":0.9,"cropBoxResizable":false,"minContainerHeight":280,"minContainerWidth":250}})],1)]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs m-t"},[_c('button',{staticClass:"btn--default",attrs:{"type":"button"},on:{"click":_vm.saveImage}},[_vm._v("Guardar")])]),_c('div',{staticClass:"col-xs m-t"},[_c('button',{staticClass:"btn--default",attrs:{"type":"button"},on:{"click":_vm.cropReset}},[_vm._v("Restablecer")])]),_c('div',{staticClass:"col-xs m-t"},[_c('button',{staticClass:"btn--default",attrs:{"type":"button"},on:{"click":_vm.cropDestroy}},[_vm._v("Cancelar")])])]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-x-large m-t"},[_vm._v("Dentro de 24 hrs se actualizara la nueva foto.")])])])])],2)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Información de apoderados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Regulation_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3dfb4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Regulation_vue__ = __webpack_require__(175);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Regulation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3dfb4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Regulation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Documentos Internos")])])]),_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-xm-6 col-l-4"},[_c('div',{staticClass:"card"},[_c('h1',{staticClass:"font-size-large"},[_vm._v("Reglamento interno")]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs"},[_c('a',{staticClass:"btn--warning is-active",attrs:{"href":"https://intranet.cima.com.pe/intranetcima/documentos/REGLAMENTOINTERNO2018.pdf","target":"_blank"}},[_c('span',{staticClass:"icon-file-text"}),_c('span',[_vm._v("Ver")])])])])])]),_c('div',{staticClass:"col-xs-12 col-xm-6 col-l-4"},[_c('div',{staticClass:"card"},[_c('h1',{staticClass:"font-size-large"},[_vm._v("Plan curricular")]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs"},[_c('a',{staticClass:"btn--warning is-active",attrs:{"href":"https://intranet.cima.com.pe/intranetcima/documentos/PLANCURRICULAR2018.pdf","target":"_blank"}},[_c('span',{staticClass:"icon-file-text"}),_c('span',[_vm._v("Ver")])])])])])]),_c('div',{staticClass:"col-xs-12 col-xm-6 col-l-4"},[_c('div',{staticClass:"card"},[_c('h1',{staticClass:"font-size-large"},[_vm._v("Plan de convivencia")]),_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs"},[_c('a',{staticClass:"btn--warning is-active",attrs:{"href":"https://intranet.cima.com.pe/intranetcima/documentos/PLANTRABAJO2018.pdf","target":"_blank"}},[_c('span',{staticClass:"icon-file-text"}),_c('span',[_vm._v("Ver")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f8ea64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__ = __webpack_require__(177);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f8ea64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row cross-center"},[_vm._m(0),_c('div',{staticClass:"col-xs u-mla"},[_c('div',{staticClass:"row m-b"},[(_vm.report!=1)?_c('div',{staticClass:"col-xs"},[_c('button',{staticClass:"btn--warning is-active",on:{"click":function($event){_vm.print('print')}}},[_c('span',{staticClass:"icon-printer"}),_c('span',[_vm._v("Imprimir")])])]):_vm._e()])])])])]),(_vm.report != null && !_vm.report.err)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row main-center"},[(_vm.report == 1)?[_vm._m(1)]:[_c('div',{attrs:{"id":"print"}},[_c('p',{staticClass:"print__title"},[_vm._v(_vm._s(_vm.alumno.nombre)+" "+_vm._s(_vm.alumno.apellido)+" "+_vm._s(_vm.alumno.grado)+" "+_vm._s(_vm.alumno.seccion))]),_c('div',{staticClass:"horary"},[_c('div',{staticClass:"horary__header"},[_c('div',{staticClass:"horary__cell",style:('width:'+_vm.width_dias+'%')},[_c('strong',{staticClass:"horary__cell-title"},[_vm._v("Hora")])]),_vm._l((_vm.report),function(dia){return _c('div',{staticClass:"horary__cell",style:('width:'+_vm.width_dias+'%')},[_c('strong',{staticClass:"horary__cell-title"},[_vm._v(_vm._s(dia.dia))])])})],2),_c('div',{staticClass:"horary__body"},[_c('div',{staticClass:"column-w"},_vm._l((_vm.report.horas),function(hora,i){return _c('div',{staticClass:"horary__hours",style:('height:'+_vm.heigth_horas+'%')},[_c('span',[_vm._v(_vm._s(hora.inicio))])])})),_vm._l((_vm.report),function(dia){return _c('div',{staticClass:"horary__column"},[_c('article',{staticClass:"day"},[_c('div',{staticClass:"day__title",attrs:{"id":'dia-hr'+dia.numero_dia}},[_c('h1',{staticClass:"title2"},[_vm._v(_vm._s(dia.dia))])]),_c('div',{staticClass:"horary__column--desktop"},_vm._l((dia.cursos),function(curso){return _c('div',{staticClass:"course--desktop",style:('height:'+_vm.heigth_horas * curso.cantidad_horas+'%')},[_c('div',{staticClass:"texto-curso"},[_c('span',{staticClass:"horary__data--desktop font-size-regular"},[_vm._v(_vm._s(curso.asignatura))]),_c('span',{staticClass:"horary__data--desktop font-size-small"},[_vm._v(_vm._s(curso.docente))]),_c('div',{staticClass:"horary--movile"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"course-horary row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"title2"},[_vm._v(_vm._s(curso.asignatura))])]),_c('div',{staticClass:"col-xs-12 col-xm-6"},[_c('strong',{staticClass:"normal"},[_vm._v("Hora Inicio: ")]),_c('strong',{staticClass:"normal"},[_vm._v(_vm._s(curso.horas[0].inicio))])]),_c('div',{staticClass:"col-xs-12 col-xm-6"},[_c('strong',{staticClass:"normal"},[_vm._v("Hora Fin: ")]),_c('strong',{staticClass:"normal"},[_vm._v(_vm._s(curso.horas[curso.horas.length-1].fin))])])])])])])])}))])])})],2)])])]],2)])]:(_vm.report && _vm.report.err)?[_vm._m(2)]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-s"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("En esta sección encontrarás tu horario")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-xm-6 m-a"},[_c('article',{staticClass:"message-not-available row main-center cross-center"},[_c('h1',{staticClass:"title2"},[_vm._v("Horario aún no disponible.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container target"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-xxx-large text--center"},[_vm._v("El horario no se encuentra.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Familyguy_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b567ee00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Familyguy_vue__ = __webpack_require__(179);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Familyguy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b567ee00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Familyguy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"band large"},[_c('div',{staticClass:"container"},[(_vm.profile)?_c('div',{staticClass:"row main-center cross-center"},[_c('div',{staticClass:"col-xs-6 col-s"},[_c('div',{staticClass:"profile__wrapper-image small"},[_c('img',{staticClass:"profile__user-image parent",attrs:{"src":_vm.image},on:{"error":function($event){_vm.detectedImages()}}})])]),_c('div',{staticClass:"col-xs-6 col-s"},[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(_vm.profile.nombre)+" "+_vm._s(_vm.profile.apellidos))]),_c('strong',{staticClass:"font-size-small"},[_vm._v("DNI: "+_vm._s(_vm.profile.dni))])]),_c('div',{staticClass:"col-xs-12 col-s"},[_c('div',{staticClass:"d-f main-center"},[_c('button',{staticClass:"btn--danger is-active",on:{"click":function($event){_vm.logout()}}},[_vm._v("Cerrar Sesión")])])])]):_vm._e()])]),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._l((_vm.report),function(data,index){return [_c('div',{staticClass:"col-xs-12 col-s-6 col-m-4 d-f"},[_c('div',{staticClass:"profile m-b"},[_c('div',{staticClass:"profile__wrapper-image"},[_c('img',{staticClass:"profile__user-image",attrs:{"src":data.url_imagen,"alt":""}})]),_c('div',{staticClass:"profile__description row main-center"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(data.nombre)+" "+_vm._s(data.apellido))])]),_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"font-size-small"},[_vm._v(_vm._s(data.grado)+" "+_vm._s(data.seccion)+" "+_vm._s(data.nivel))])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('button',{staticClass:"btn--default",on:{"click":function($event){_vm.setChild(index)}}},[_vm._v("Ver más")])])])])])])]})],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)],_c('modal',{staticClass:"mx-90",attrs:{"active":_vm.showModal,"alert":true},on:{"update:active":function($event){_vm.showModal=$event}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12 col-s"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v("Alerta!")])])])]),_c('template',{slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-large text-center"},[_vm._v("¿Desea cerrar sesión?")])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row m-b"},[_c('div',{staticClass:"col-xs m-auto"},[_c('button',{staticClass:"btn--default",on:{"click":function($event){_vm.cancelLogout()}}},[_vm._v("CANCELAR")])]),_c('div',{staticClass:"col-xs m-auto"},[_c('button',{staticClass:"btn--danger",on:{"click":function($event){_vm.sendLogout()}}},[_vm._v("ACEPTAR")])])])])])])],2)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-x-large text--center m-t"},[_vm._v("Lista de alumnos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoursesExams_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375d2d4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CoursesExams_vue__ = __webpack_require__(183);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoursesExams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375d2d4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CoursesExams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Course_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e68341e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Course_vue__ = __webpack_require__(182);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Course_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e68341e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Course_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"card"},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col-xs-12 course__header"},[_c('h1',{staticClass:"font-size-large text--center"},[_vm._v(_vm._s(_vm.data.curso))])]),_c('div',{staticClass:"col-xs-12"},[_c('strong',{staticClass:"sticker m-b",class:_vm.data.promedio >= _vm.data.notaminima? 'green':'red'},[_vm._v("PROM. ACUM: "+_vm._s(_vm.data.promedio))])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"profile__wrapper-image small"},[_c('img',{staticClass:"profile__user-image",attrs:{"src":'https://intranet.cima.com.pe/v4cima/vista/fotos/prf'+_vm.data.iddocente+'.jpg',"alt":_vm.data.docente}})]),_c('div',{staticClass:"profile__description"},[_c('small',[_vm._v("Docente:")]),_c('p',[_vm._v(_vm._s(_vm.data.docente))]),_c('small',[_vm._v("Teléfono:")]),_c('p',[_vm._v(_vm._s(_vm.data.telefono))])])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs"},[_c('button',{staticClass:"btn--default is-active",on:{"click":function($event){_vm.viewDetailExam(_vm.data)}}},[_vm._v("Ver detalles")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Bimestres:")]),(_vm.report && _vm.report[0].deudas == 1000)?[_c('div',{staticClass:"col-xs"},[_c('div',{staticClass:"row m-b"},[_c('div',{staticClass:"col-xs"},[_c('button',{staticClass:"btn--warning is-active",on:{"click":function($event){_vm.viewReport()}}},[_c('span',{staticClass:"icon-file-text"}),_c('span',[_vm._v("Reporte")])])])])])]:_vm._e()],2)])])]),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[(_vm.report[0].deudas >= 2)?[_vm._m(0)]:[_c('div',{staticClass:"col-xs-12"},[_c('tabs',{staticClass:"row"},[_vm._l((_vm.report[0].examenes),function(data,index){return [_c('tab',{attrs:{"name":_vm.rename(data.bimestre),"selected":_vm.isTrue(index)}},[_c('div',{staticClass:"col-xs-12 m-t"},[_c('div',{staticClass:"row"},[_vm._l((data.cursos),function(courses){return [_c('div',{staticClass:"col-xs-12 col-s-6 col-m-4 col-l-3 d-f"},[_c('course',{attrs:{"data":courses}})],1)]})],2)])])]})],2)],1)]],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)],_c('modal',{attrs:{"active":_vm.showModal},on:{"update:active":function($event){_vm.showModal=$event}}},[(_vm.detailExam)?[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12 col-s"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v(_vm._s(_vm.detailExam.course))])]),_c('div',{staticClass:"col-xs"},[_c('strong',{staticClass:"sticker m-b-0",class:_vm.detailExam.mean >= _vm.detailExam.minimumNote? 'green':'red'},[_vm._v("PROMEDIO: "+_vm._s(_vm.detailExam.mean))])])])]),_c('template',{slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('tabs',{attrs:{"fixed":true}},[_vm._l((_vm.detailExam.groups),function(data,index){return [_c('tab',{attrs:{"name":data.grupo,"selected":_vm.isTrue(index)}},[(data.isCalc)?[_c('div',{staticClass:"col-xs-12 m-t"},[_c('div',{staticClass:"table__wrapper"},[_c('div',{staticClass:"table shadow-1"},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item u-Flex-grow3"},[_vm._v("Descripción")]),_c('div',{staticClass:"table-row-item u-Flex-grow3"},[_vm._v("Porcentaje")]),_c('div',{staticClass:"table-row-item u-Flex-grow3"},[_vm._v("Nota")]),_c('div',{staticClass:"table-row-item u-Flex-grow3"},[_vm._v("Puntos")])])]),_c('div',{staticClass:"table-body"},[_vm._l((_vm.weightCourse),function(peso){return [_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item u-Flex-grow3 font-size-small"},[_vm._v(_vm._s(peso.grupo_evaluacion))]),_c('div',{staticClass:"table-row-item u-Flex-grow3 font-size-small"},[_vm._v(_vm._s(peso.peso))]),_c('div',{staticClass:"table-row-item u-Flex-grow3 font-size-small",domProps:{"textContent":_vm._s(peso.nota != -1? peso.nota : '-')}}),_c('div',{staticClass:"table-row-item u-Flex-grow3 font-size-small",domProps:{"textContent":_vm._s(peso.puntos != -1? peso.puntos : '-')}})])]})],2),_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item center u-Flex-grow9"},[_vm._v("PROMEDIO ACUMULADO")]),_c('div',{staticClass:"table-row-item u-Flex-grow3"},[_vm._v(_vm._s(data.total))])])])])])])]:[_c('div',{staticClass:"col-xs-12 m-t"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 m-b"},[_c('div',{staticClass:"card--ligth"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs-12 col-s"},[_c('strong',{staticClass:"font-size-large"},[_vm._v(_vm._s(data.grupo))])]),_c('div',{staticClass:"col-xs col-s"},[_c('strong',{staticClass:"tag font-size-regular"},[_vm._v("PESO: "+_vm._s(data.peso)+"%")])]),_c('div',{staticClass:"col-xs-12 col-s m-t m-b"},[_c('strong',{staticClass:"sticker font-size-regular",class:data.promedio >= 11? 'green':'red'},[_vm._v("PROMEDIO: "+_vm._s(data.promedio))])])])])]),_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-regular"},[_vm._v("EVALUACIONES")])]),_vm._l((data.examenes),function(exam){return [_c('div',{staticClass:"col-xs-12 col-s-6 col-m-4 d-f"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('small',[_vm._v("Evaluación:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(exam.evaluacion))])]),_c('div',{staticClass:"col-xs-12"},[_c('small',[_vm._v("Fecha:")]),_c('h1',{staticClass:"font-size-regular",domProps:{"textContent":_vm._s(_vm.format(exam.fecha))}})]),_c('div',{staticClass:"col-xs-12"},[_c('small',[_vm._v("Instrumento:")]),_c('h1',{staticClass:"font-size-regular"},[_vm._v(_vm._s(exam.instrumento))])])]),_c('div',{staticClass:"card__footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('strong',{staticClass:"sticker",class:exam.nota >= 11? 'green':'red'},[_vm._v("Nota: "+_vm._s(exam.nota))])])])])])])]})],2)])]],2)]})],2)],1)])])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2),_c('report',[_c('template',{slot:"title"},[_vm._v("Reporte")]),_c('template',{slot:"body"},[_c('div',{staticClass:"row",attrs:{"id":"print"}},[_c('div',{staticClass:"print__header col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"p-r"},[_c('img',{staticClass:"print__img",attrs:{"src":__webpack_require__(19)}})])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-12"},[(_vm.dataStudent)?[_c('h1',{staticClass:"font-size-x-large"},[_vm._v(_vm._s(_vm.dataStudent.nombre)+" "+_vm._s(_vm.dataStudent.apellido))]),_c('h2',{staticClass:"font-size-regular"},[_vm._v(_vm._s(_vm.dataStudent.nivel)+" - "+_vm._s(_vm.dataStudent.grado)+" "+_vm._s(_vm.dataStudent.seccion))])]:[_c('spinner')]],2)])])])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"table header-fixed"},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item u-Flex-grow5"},[_vm._v("ÁREA CURRICULAR")]),_c('div',{staticClass:"table-row-item sub-row u-Flex-grow4 center"},[_vm._v("BIMESTRE"),_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item center"},[_vm._v("I")]),_c('div',{staticClass:"table-row-item center"},[_vm._v("II")]),_c('div',{staticClass:"table-row-item center"},[_vm._v("III")]),_c('div',{staticClass:"table-row-item center"},[_vm._v("IV")])])]),_c('div',{staticClass:"table-row-item u-Flex-grow3 center"},[_vm._v("PROM. ACUM.")])])]),_c('div',{staticClass:"table-body"},[_vm._l((_vm.reportPrint),function(data){return [_c('div',{staticClass:"table-row"},[(_vm.reportPrint)?_c('div',{staticClass:"table-row-item u-gray"},[_vm._v(_vm._s(data.area))]):_vm._e()]),_vm._l((data.cursos),function(c){return [_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item u-Flex-grow5"},[_vm._v(_vm._s(c.curso))]),_vm._l((c.notas),function(nota){return [_c('div',{staticClass:"table-row-item center",class:nota.nota<data.minima? 'text-danger': ''},[_vm._v(_vm._s(nota.nota))])]}),_vm._l(((4- c.notas.length)),function(n){return [_c('div',{staticClass:"table-row-item center"},[_vm._v("-")])]}),_c('div',{staticClass:"table-row-item u-Flex-grow3 center",class:c.promedio<data.minima? 'text-danger':''},[_vm._v(_vm._s(c.promedio))])],2)]}),_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item u-Flex-grow9 center"},[_vm._v("PROMEDIO")]),(_vm.reportPrint)?_c('div',{staticClass:"table-row-item u-Flex-grow3 center",class:data.promedio<data.minima? 'text-danger':''},[_vm._v(_vm._s(data.promedio))]):_vm._e()])]})],2)])])])])],2)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-xxx-large text--center"},[_vm._v("Tiene deudas pendientes.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalityExams_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a58afb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalityExams_vue__ = __webpack_require__(188);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalityExams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a58afb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalityExams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exams_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f161752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Exams_vue__ = __webpack_require__(186);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f161752_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Exams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_vm._l((_vm.data),function(exams,index){return [_c('div',{staticClass:"col-xs-12 col-xm-6 col-m-4 col-l-3 d-f"},[_c('article',{staticClass:"card course"},[_c('div',{staticClass:"row main-center h-100"},[_c('div',{staticClass:"col-xs-12 course__header"},[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(exams.descripcion))])]),_c('div',{staticClass:"col-xs-12 m-b"},[_c('strong',{staticClass:"font-size-regular"},[_vm._v(_vm._s(exams.fecha))])]),_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Mérito general:")]),_c('h2',[_vm._v(_vm._s(exams.merito_general))])]),_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Mérito grado:")]),_c('h2',[_vm._v(_vm._s(exams.merito_grado))])]),(_vm.idMod == 10)?[_c('div',{staticClass:"col-xs-12 d-f m-b"},[_c('strong',{staticClass:"sticker font-size-regular"},[_vm._v("NOTA BASE 20: "+_vm._s(exams.nota_20))])])]:[_c('div',{staticClass:"col-xs-12 d-f m-b"},[_c('strong',{staticClass:"sticker font-size-regular"},[_vm._v("PUNTAJE "+_vm._s(exams.puntaje))])])],_c('div',{staticClass:"col-xs-12 m-b"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label red"},[_c('small',[_vm._v("Malas:")]),_c('h2',[_vm._v(_vm._s(exams.malas_contestadas))])])]),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label blue"},[_c('small',[_vm._v("Buenas:")]),_c('h2',[_vm._v(_vm._s(exams.buenas_contestadas))])])]),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label blue-ligth"},[_c('small',[_vm._v("Blanco:")]),_c('h2',[_vm._v(_vm._s(exams.no_contestadas))])])])])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs"},[_c('router-link',{staticClass:"btn--default is-active",attrs:{"to":_vm.link(_vm.id,index),"tag":"button"}},[_vm._v("Ver examen")])],1)])])],2),(exams.nota_20 == 0)?[_c('div',{staticClass:"course__message"},[_c('strong',{staticClass:"font-size-xx-large text--uppercase text--center"},[_vm._v(_vm._s(exams.motivo))]),_c('strong',{staticClass:"font-size-xx-large text--uppercase text--center"},[_vm._v(_vm._s(exams.fecha))])])]:_vm._e()],2)])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.report)?[_c('div',{staticClass:"band"}),_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn--back shadow-2",on:{"click":function($event){_vm.$router.go(-1)}}},[_c('span',{staticClass:"icon-arrow"})])]),_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('article',{staticClass:"card"},[_c('div',{staticClass:"row main-center cross-center"},[_c('div',{staticClass:"col-xs-12 col-xm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v(_vm._s(_vm.report.descripcion))])]),_c('div',{staticClass:"col-xs-12"},[_c('strong',{staticClass:"font-size-large"},[_vm._v(_vm._s(_vm.report.fecha))])])])]),_c('div',{staticClass:"col-xs-12 col-xm-3"},[_c('div',{staticClass:"row main-center cross-center"},[_c('div',{staticClass:"col-xs-12 col-xm-6 d-f"},[_c('strong',{staticClass:"sticker font-size-regular m-b"},[_vm._v("PUNTAJE "+_vm._s(_vm.report.merito_general))])]),_c('div',{staticClass:"col-xs-12 col-xm-6 d-f"},[_c('strong',{staticClass:"sticker font-size-regular m-b"},[_vm._v("PUNTAJE BASE 20: "+_vm._s(_vm.report.nota_20))])])])]),_c('div',{staticClass:"col-xs-12 col-xm-3"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Mérito general:")]),_c('h2',[_vm._v(_vm._s(_vm.report.merito_general))])]),_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Mérito grado:")]),_c('h2',[_vm._v(_vm._s(_vm.report.merito_grado))])])])]),_c('div',{staticClass:"col-xs-12 col-xm-3"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label red"},[_c('small',[_vm._v("Malas:")]),_c('h2',[_vm._v(_vm._s(_vm.report.malas_contestadas))])])]),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label blue"},[_c('small',[_vm._v("Buenas:")]),_c('h2',[_vm._v(_vm._s(_vm.report.buenas_contestadas))])])]),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label blue-ligth"},[_c('small',[_vm._v("Blanco:")]),_c('h2',[_vm._v(_vm._s(_vm.report.no_contestadas))])])])])])])])])]),_c('article',{staticClass:"row"},[_vm._m(0),_vm._l((_vm.report.asignaturas),function(data){return [_c('div',{staticClass:"col-xs-12 col-xm-6 col-m-4 col-l-3 d-f"},[_c('div',{staticClass:"course card"},[_c('div',{staticClass:"row main-center h-100"},[_c('div',{staticClass:"col-xs-12 course__header"},[_c('h1',{staticClass:"font-size-large"},[_vm._v(_vm._s(data.asignatura))])]),_c('div',{staticClass:"col-xs-12 m-b"},[_c('strong',{staticClass:"sticker font-size-regular"},[_vm._v("PUNTAJE "+_vm._s(data.puntaje))])]),_c('div',{staticClass:"col-xs-12 m-b"},[_c('strong',{staticClass:"sticker font-size-regular"},[_vm._v("NOTA BASE 20: "+_vm._s(data.nota))])]),_c('div',{staticClass:"col-xs-12 m-b"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label red"},[_c('small',[_vm._v("Malas:")]),_c('h2',[_vm._v(_vm._s(data.malas_contestadas))])])]),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label blue"},[_c('small',[_vm._v("Buenas:")]),_c('h2',[_vm._v(_vm._s(data.buenas_contestadas))])])]),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"tag--label blue-ligth"},[_c('small',[_vm._v("Blanco:")]),_c('h2',[_vm._v(_vm._s(data.no_contestadas))])])])])]),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row main-center"},[_c('div',{staticClass:"col-xs"},[_c('button',{staticClass:"btn--default is-active",on:{"click":function($event){_vm.viewKey(data.preguntas)}}},[_vm._v("Claves")])])])])])])])]})],2)])]:[_c('spinner')],_c('modal',{attrs:{"active":_vm.showModal},on:{"update:active":function($event){_vm.showModal=$event}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"row cross-center"},[_c('div',{staticClass:"col-xs"},[_c('strong',{staticClass:"font-size-x-large"},[_vm._v("Claves")])])])]),_c('template',{slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"table__wrapper"},[_c('div',{staticClass:"table header-fixed shadow-1"},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item"},[_vm._v("N° de Preg.")]),_c('div',{staticClass:"table-row-item"},[_vm._v("Rpta. Exam.")]),_c('div',{staticClass:"table-row-item"},[_vm._v("Rpta. Alum.")])])]),_c('div',{staticClass:"table-body"},[(_vm.keyExam)?[_vm._l((_vm.keyExam),function(key){return [_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item",attrs:{"data-header":"N° de Preg."}},[_vm._v(_vm._s(key.numero_pregunta))]),_c('div',{staticClass:"table-row-item",attrs:{"data-header":"Rpta. Exam."}},[_vm._v(_vm._s(key.clave))]),_c('div',{staticClass:"table-row-item font-weight-bold",class:_vm.colorKey(key.clave,key.respuesta),attrs:{"data-header":"Rpta. Alum."},domProps:{"textContent":_vm._s(_vm.correctKey(key.respuesta))}})])]})]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)])])])])])],2)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-x-large text--center"},[_vm._v("Cursos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report==1)?[_vm._m(1)]:(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('tabs',{staticClass:"row"},[_vm._l((_vm.report),function(modality,index){return [_c('tab',{attrs:{"name":modality.modalidad,"selected":_vm.isTrue(index)}},[_c('div',{staticClass:"col-xs-12 m-t"},[_c('exams',{attrs:{"data":modality.examenes,"id":index,"idMod":modality.idmodalidad}})],1)])]})],2)],1)])])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Tus exámenes")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card"},[_c('h1',{staticClass:"font-size-large"},[_vm._v("Este alumno no tiene simulacros")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965beb14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(190);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965beb14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('tabs',{staticClass:"row"},[_vm._l((_vm.report),function(data,index){return [_c('tab',{attrs:{"name":data.tipo,"selected":_vm.isTrue(index)}},[_c('div',{staticClass:"col-xs-12 m-t"},[_c('div',{staticClass:"table__wrapper"},[_c('div',{staticClass:"table shadow-1",staticStyle:{"min-width":"750px"}},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item"},[_vm._v("Descripción")]),_c('div',{staticClass:"table-row-item"},[_vm._v("Fecha Vencimiento")]),_c('div',{staticClass:"table-row-item"},[_vm._v("Monto")]),_c('div',{staticClass:"table-row-item"},[_vm._v("Monto Pagado")]),_c('div',{staticClass:"table-row-item center"},[_vm._v("Estado")])])]),_c('div',{staticClass:"table-body"},[_vm._l((data.pagos),function(payment){return [_c('div',{staticClass:"table-row"},[_c('div',{staticClass:"table-row-item font-size-small",attrs:{"data-header":"Descripción"}},[_vm._v(_vm._s(payment.descripcion))]),_c('div',{staticClass:"table-row-item font-size-small",attrs:{"data-header":"Fecha Vencimiento"}},[_vm._v(_vm._s(_vm.format(payment.fechavencimiento)))]),_c('div',{staticClass:"table-row-item font-size-small",attrs:{"data-header":"Monto"}},[_vm._v("S/ "+_vm._s(payment.monto))]),_c('div',{staticClass:"table-row-item font-size-small",attrs:{"data-header":"Monto Pagado"}},[(payment.montopagado)?_c('span',[_vm._v("S/ "+_vm._s(payment.montopagado))]):_vm._e()]),_c('div',{staticClass:"table-row-item font-size-small sticker",class:_vm.colorState(payment.estado),attrs:{"data-header":"Estado"}},[_vm._v(_vm._s(payment.estado))])])]})],2)])])])])]})],2)],1)])])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Historial de pagos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e01587_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e01587_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountDown_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64335002_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CountDown_vue__ = __webpack_require__(193);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64335002_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_CountDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[(_vm.days)?[_c('div',{staticClass:"col-xs-12"},[(_vm.finalMessage && _vm.status > 0)?[_c('strong',{class:_vm.getClassStatus()},[_vm._v(_vm._s(_vm.finalMessage))])]:[_c('strong',{staticClass:"yellow"},[_vm._v("Quedan ")]),_c('strong',{staticClass:"yellow",domProps:{"textContent":_vm._s(_vm.days)}}),_c('strong',{staticClass:"yellow"},[_vm._v("d:")]),_c('strong',{staticClass:"yellow",domProps:{"textContent":_vm._s(_vm.hours)}}),_c('strong',{staticClass:"yellow"},[_vm._v("h:")]),_c('strong',{staticClass:"yellow",domProps:{"textContent":_vm._s(_vm.minutes)}}),_c('strong',{staticClass:"yellow"},[_vm._v("m:")]),_c('strong',{staticClass:"yellow",domProps:{"textContent":_vm._s(_vm.seconds)}}),_c('strong',{staticClass:"yellow"},[_vm._v("s")])]],2)]:[_c('div',{staticClass:"col-xs-12"},[_c('spinner',{attrs:{"size":"small"}})],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_vm._l((_vm.report),function(data){return [_c('div',{staticClass:"col-xs-12 col-m-6 col-xl-4 d-f"},[_c('article',{staticClass:"card--event",class:_vm.getClassStatus(data.estado)},[_c('div',{staticClass:"card--event__date"},[_c('strong',{staticClass:"font-size-large text--uppercase",domProps:{"textContent":_vm._s(_vm.format(data.fecha))}})]),_c('div',{staticClass:"card--event__description"},[_c('div',{staticClass:"card--event__name"},[_c('h2',{staticClass:"text--uppercase"},[_vm._v(_vm._s(data.titulo))]),_c('p',{staticClass:"font-size-regular"},[_vm._v(_vm._s(data.descripcion))])]),_c('div',{staticClass:"card--event__hour"},[_c('small',[_vm._v("A LAS ")]),_c('strong',[_vm._v(_vm._s(data.hora)+" ")]),_c('small',[_vm._v("HORAS.")]),_c('CountDown',{attrs:{"date":data.fecha,"hour":data.hora}})],1)])])])]})],2)])]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("Eventos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolExams_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e796ca00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_RolExams_vue__ = __webpack_require__(196);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolExams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e796ca00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_RolExams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"band"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"font-size-x-large"},[_vm._v("ROL DE EXÁMENES "+_vm._s(_vm.bimestre)+" BIMESTRE")])])]),(_vm.report)?[_c('div',{staticClass:"container target"},[_c('div',{staticClass:"row"},[_vm._l((_vm.report),function(data){return [_c('div',{staticClass:"col-xs-12 col-m-6 col-xl-4 d-f"},[_c('article',{staticClass:"card--event",class:_vm.getClassStatus(data.estado)},[_c('div',{staticClass:"card--event__date"},[_c('strong',{staticClass:"font-size-large text--uppercase"},[_vm._v(_vm._s(data.dia)+" "+_vm._s(_vm.format(data.fecha)))])]),_c('div',{staticClass:"card--event__description"},_vm._l((data.cursos),function(curso){return _c('div',{staticClass:"card--event__name"},[_c('h2',{staticClass:"text--uppercase"},[_vm._v(_vm._s(curso.curso))]),_c('p',{staticClass:"font-size-small"},[_vm._v("("+_vm._s(curso.tipo)+")")]),_c('p',{staticClass:"font-size-regular"},[_vm._v(_vm._s(curso.docente))])])}))])])]})],2)])]:(_vm.report===undefined)?[_vm._m(0)]:[_c('div',{staticClass:"m-t-s"},[_c('spinner')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container target"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"font-size-xxx-large text--center"},[_vm._v("No tienes rol de exámenes.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294e8902_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294e8902_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(199);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(71)("7e64be5e", content, true, {});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(200);
exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, "*,:after,:before{box-sizing:border-box}body{font-family:Lato Regular;color:#333}a{text-decoration:none}a:hover{text-decoration:underline}p{margin:0 0 1rem}ul{margin:0;padding:0;list-style:none}b{display:none}input{border:0}input:focus{outline:none}\n\n/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}@font-face{font-family:cima-preu;src:url(" + escape(__webpack_require__(85)) + ");src:url(" + escape(__webpack_require__(85)) + ") format(\"embedded-opentype\"),url(" + escape(__webpack_require__(201)) + ") format(\"woff\"),url(" + escape(__webpack_require__(202)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(203)) + ") format(\"svg\");font-weight:400;font-style:normal}[data-icon]:before{content:attr(data-icon)}[class*=\" icon-\"]:before,[class^=icon-]:before,[data-icon]:before{font-family:cima-preu!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-home:before{content:\"c\"}.icon-calendar-1:before{content:\"d\"}.icon-horary:before{content:\"e\"}.icon-file:before{content:\"f\"}.icon-team:before{content:\"g\"}.icon-book:before{content:\"h\"}.icon-notes:before{content:\"i\"}.icon-printer:before{content:\"b\"}.icon-close:before{content:\"j\"}.icon-file-text:before{content:\"a\"}.icon-arrow:before{content:\"k\"}.icon-event:before{content:\"l\"}.icon-payment:before{content:\"m\"}.icon-edit:before{content:\"n\"}.icon-refresh:before{content:\"o\"}@font-face{font-family:Lato Bold;src:url(" + escape(__webpack_require__(204)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(205)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Lato Regular;src:url(" + escape(__webpack_require__(206)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(207)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Roboto Mono;src:url(" + escape(__webpack_require__(208)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(209)) + ") format(\"woff\");font-weight:400;font-style:normal}.m-b-0{margin-bottom:0}.m-b{margin-bottom:.85rem}.m-t{margin-top:.85rem}.m-b-2{margin-bottom:.425rem}.m-t-s{margin-top:5.1rem}.container{margin:0 auto;width:90%}@media only screen and (min-width:900px){.container{width:95%}}.column,.row{display:-ms-flexbox;display:flex;-ms-flex:0 1 auto;flex:0 1 auto;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-left:-.425rem;margin-right:-.425rem}.column{-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.row-reverse{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.column-reverse{-ms-flex-direction:column-reverse;flex-direction:column-reverse}.main-start{-ms-flex-pack:start;justify-content:flex-start;text-align:start}.main-center{-ms-flex-pack:center;justify-content:center;text-align:center}.main-end{-ms-flex-pack:end;justify-content:flex-end;text-align:end}.cross-start{-ms-flex-align:start;align-items:flex-start}.cross-center{-ms-flex-align:center;align-items:center}.cross-end{-ms-flex-align:end;align-items:flex-end}.around{-ms-flex-pack:distribute;justify-content:space-around}.between{-ms-flex-pack:justify;justify-content:space-between}.no-wrap{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.col-xs,.col-xs-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem}.col-xs-1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-xs-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-xs-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xs-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-xs-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-xs-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xs-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-xs-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-xs-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xs-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-xs-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-xs-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}@media only screen and (min-width:480px){.col-s,.col-s-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem}.col-s-1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-s-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-s-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-s-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-s-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-s-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-s-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-s-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-s-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-s-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-s-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-s-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}@media only screen and (min-width:750px){.col-xm,.col-xm-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem}.col-xm-1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-xm-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-xm-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xm-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-xm-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-xm-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xm-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-xm-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-xm-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xm-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-xm-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-xm-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}@media only screen and (min-width:900px){.col-m,.col-m-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem}.col-m-1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-m-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-m-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-m-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-m-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-m-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-m-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-m-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-m-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-m-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-m-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-m-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}@media only screen and (min-width:1170px){.col-l,.col-l-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem}.col-l-1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-l-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-l-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-l-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-l-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-l-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-l-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-l-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-l-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-l-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-l-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-l-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}@media only screen and (min-width:1500px){.col-xl,.col-xl-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem}.col-xl-1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-xl-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-xl-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xl-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-xl-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-xl-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xl-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-xl-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-xl-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xl-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-xl-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-xl-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}@media print{.col-s{-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-s,.col-s-1{padding:0 .425rem}.col-s-1{-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-s-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-s-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-s-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-s-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-s-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-s-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-s-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-s-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-s-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-s-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}}@media print{.col-s-12,.col-xm{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-xm-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-xm-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-xm-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xm-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-xm-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-xm-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xm-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-xm-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-xm-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xm-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-xm-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}}@media print{.col-m,.col-xm-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-m-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-m-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-m-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-m-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-m-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-m-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-m-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-m-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-m-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-m-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-m-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}}@media print{.col-l,.col-m-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-l-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-l-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-l-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-l-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-l-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-l-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-l-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-l-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-l-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-l-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-l-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}}@media print{.col-l-12,.col-xl{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-xl-1{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-xl-2{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-xl-3{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xl-4{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-xl-5{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-xl-6{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xl-7{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-xl-8{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-xl-9{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xl-10{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-xl-11{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-xl-12{-ms-flex:0 0 auto;flex:0 0 auto;padding:0 .425rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}}.d-f{display:-ms-flexbox;display:flex}.f-w-w{-ms-flex-wrap:wrap;flex-wrap:wrap}.p-r{position:relative}.p-a{position:absolute}.h-100{height:100%}.t-0{top:0}::-webkit-scrollbar{width:8px;height:8px}::-webkit-scrollbar-track{background:#f2f8ff}::-webkit-scrollbar-thumb{background:#f2f8ff;background:rgba(0,0,0,.5)}.loader{position:relative;z-index:700;margin:auto;width:50px;background:#fff;border-radius:50%}.loader:before{content:\"\";display:block;padding-top:100%}.loader.small{width:30px}.circular{animation:rotate 2s linear infinite;height:100%;transform-origin:center center;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;padding:.2em}.path{stroke-dasharray:1,200;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,color 6s ease-in-out infinite;stroke-linecap:round}@keyframes rotate{to{transform:rotate(1turn)}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px}to{stroke-dasharray:89,200;stroke-dashoffset:-124px}}@keyframes color{0%,to{stroke:#d62d20}40%{stroke:#0057e7}66%{stroke:#008744}80%,90%{stroke:#ffa700}}.band{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;position:relative;padding-top:.85rem;z-index:500}.band:before{content:\"\";display:block;position:absolute;top:0;left:0;width:100%;height:140px;z-index:-100;background-color:#2d3a4b;background-color:#f7f7f7}.band.large:before{height:200px}@media only screen and (min-width:480px){.band.large:before{height:140px}}.icon-burger{position:relative}.icon-burger,.icon-burger:after,.icon-burger:before{width:25px;height:2px;border-radius:.5px;background-color:#000}.icon-burger:after,.icon-burger:before{content:\"\";display:block;position:absolute;top:-6px}.icon-burger:after{top:6px}.calendar,.calendar__day-number.justify:hover,.card,.card--event,.day,.loader,.login,.menu,.profile,.profile__wrapper-image,.shadow-1,.table{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.shadow-2{box-shadow:0 8px 17px 0 rgba(0,0,0,.5)}.btn--back:hover,.btn--burger:hover,.btn--danger:hover,.btn--default--small:hover,.btn--default.is-active,.btn--default:hover,.btn--edit:hover,.btn--floating:hover,.btn--primary:hover,.btn--warning:hover,.btn:hover,.is-active.btn--danger,.is-active.btn--default--small,.is-active.btn--primary,.is-active.btn--warning,.shadow--hover,.tab.is-active{box-shadow:0 3px 8px 0 rgba(0,0,0,.17)}.btn,.btn--back,.btn--burger,.btn--danger,.btn--default,.btn--default--small,.btn--edit,.btn--floating,.btn--primary,.btn--warning{cursor:pointer;border:none;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#263238;background-color:transparent;transition:all .3s ease-in;outline:none}.btn--back:active,.btn--burger:active,.btn--danger:active,.btn--default--small:active,.btn--default:active,.btn--edit:active,.btn--floating:active,.btn--primary:active,.btn--warning:active,.btn:active{transform:scale(.92)}[class^=btn]{margin-right:.3em}.btn--back,.btn--burger,.btn--floating{width:48px;height:48px;border-radius:50%;padding:0}.btn--back,.btn--floating{position:fixed;bottom:0;right:0;width:60px;height:60px;margin-bottom:.85rem;margin-right:1.7rem;background-color:#00357b;color:#fff;z-index:800}@media only screen and (min-width:1170px){.btn--burger{display:none}}.btn--edit{width:2em;height:2em;border-radius:.3em;background-color:#ccc}.btn--danger,.btn--default,.btn--default--small,.btn--primary,.btn--warning{width:10em;border-radius:2em;padding:.7em .5em;border:1px solid #263238}.btn--danger:hover,.btn--default--small:hover,.btn--default.is-active,.btn--default:hover,.btn--primary:hover,.btn--warning:hover,.is-active.btn--danger,.is-active.btn--default--small,.is-active.btn--primary,.is-active.btn--warning{color:#fff;background-color:#263238}.btn--danger>span[class^=icon-],.btn--default--small>span[class^=icon-],.btn--default>span[class^=icon-],.btn--primary>span[class^=icon-],.btn--warning>span[class^=icon-]{margin-right:.56667rem}.btn--default--small{width:6.5em}.btn--primary{color:#fff;background-color:#034995;border-color:#034995}.btn--primary:hover{background-color:#023d7c}.btn--danger{color:#fff;border-color:#d62d20}.btn--danger,.btn--danger.is-active,.btn--danger:hover{background-color:#d62d20}.btn--warning{border-color:#fab649;color:#fab649}.btn--warning.is-active,.btn--warning:hover{background-color:#f09607}.btn--back{right:auto;border:none;background-color:#d62d20;border-radius:2em}.btn--back>span[class^=icon-]{margin:0;font-size:1.3em}.tag{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;max-width:200px;margin-top:.425rem;padding:.5em .4em;border:1px solid #263238;border-radius:2em;color:#263238}@media only screen and (min-width:480px){.tag{margin-top:0;padding:.4em}}.tag--label{border-radius:.5em;background-color:#f4f6f9}.tag--label.red{color:#d62d20}.tag--label.blue{color:#2e7d32}.sticker{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;padding:.56667rem;border-radius:.5em;background-color:#fddeac}.sticker.green{background-color:#9cdb9f;color:#050d05}.sticker.red{background-color:#ff8585;color:#5c0000}.table{display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:.85rem;font-size:1rem}.table.small{min-width:400px}.table.regular{min-width:750px}.table__wrapper{overflow-x:auto}.table.header-fixed .table-header{box-shadow:0 0 20px 0 rgba(0,0,0,.09);position:relative}.table.header-fixed .table-body{max-height:270px;overflow:auto}.table-header{display:block;visibility:visible;width:100%;height:70px;font-weight:700}.table-header .table-row{height:100%}.table-header .table-row-item{background-color:#fff;-ms-flex-align:center;align-items:center}.table-row{width:100%;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.table-row:nth-of-type(2n),.table-row:nth-of-type(odd){background-color:#fff}.table-row-item{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;border-top:1px solid rgba(0,0,0,.04);border-bottom:1px solid rgba(0,0,0,.04);border-left:1px solid rgba(0,0,0,.04);padding:.56667rem .85rem}.table-row-item.center{-ms-flex-pack:center;justify-content:center}.table-row-item.sub-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.table-row-item.sub-row .table-row-main-item{min-width:100%}.table-row-item.sub-row .table-row-item{padding:0 .85rem;border-top:none;border-bottom:none}.table-row-item.sub-row .table-row{display:-ms-flexbox;display:flex;height:50%;width:calc(100% + 1.7rem);margin-left:-.85rem;margin-right:-.85rem}.u-Flex-grow1{-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.u-Flex-grow2{-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.u-Flex-grow3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.u-Flex-grow4{-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.u-Flex-grow5{-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.u-Flex-grow6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.u-Flex-grow7{-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.u-Flex-grow8{-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.u-Flex-grow9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.u-Flex-grow10{-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.u-Flex-grow11{-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.u-Flex-grow12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.tabs{position:relative;overflow-y:hidden;overflow-x:auto;height:48px;box-shadow:0 0 20px 0 rgba(0,0,0,.09);z-index:500}.tabs,.tabs__list{display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}.tabs__list{-ms-flex-align:center;align-items:center;height:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}@media only screen and (min-width:750px){.tabs__wrapper.fixed .tab__detail{max-height:350px;overflow:auto}}.tab{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;height:100%;padding:0 .56667rem;font-size:15px;border-left:.5px solid #ccc;border-bottom:2px solid transparent;transition:all .3s ease-in}.tab:last-child{border-right:.5px solid #ccc}.tab:hover{background-color:#cdd7dd}.tab.is-active{color:#2365ad;background-color:#e2e8eb;border-bottom:2px solid #2365ad}.tab:active{transform:scale(.92)}.tab__detail{width:100%}.calendar,.card,.card--event,.day,.login,.menu,.profile{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;position:relative;width:100%;padding:1rem;margin-bottom:.85rem;background-color:#fff}.card__title{margin-top:0;margin-bottom:.56667rem}.card__body,.card__footer,.card__header{width:100%}.card__body{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.card__footer{margin-top:auto}.card--ligth{padding:1rem;background-color:#f4f6f9}.card--event{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center}.card--event:before{content:\"\";display:block;position:absolute;top:0;left:0;height:100%;width:7px;background-color:#f09607}.card--event.onload:before{background-color:#2365ad}.card--event.complete:before{background-color:#d62d20}.card--event__date{max-width:30%;padding-right:.85rem}.card--event__description{position:relative;max-width:70%}.card--event__description:before{content:\"\";display:block;position:absolute;height:100%;width:2px;background-color:#ccc}.card--event__hour,.card--event__name{padding-left:.85rem}.menu{position:absolute;width:230px;right:0;margin-top:.28333rem}.menu__wrapper{position:relative}.legend__label{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;margin-right:.3em;margin-bottom:.3em;height:2.5em;padding:0 1em;border-radius:1.2em;border:1px solid #ccc}.circle,.circle--absence,.circle--arrive,.circle--delay,.circle--justify{display:inline-block;width:2em;height:2em;border-radius:50%;margin-right:.56667rem;background-color:teal}.circle--absence{background-color:#ffebee;border:1px solid #f44336}.circle--delay{background-color:#ffe0b2;border:1px solid #ff9800}.circle--arrive{background-color:#f1f8e9;border:1px solid #8bc34a}.circle--justify{background-color:#e3f2fd;border:1px solid #2196f3}.overlay__modal{position:fixed;top:0;left:0;width:100%;height:100vh;z-index:900;background-color:rgba(0,0,0,.4)}.modal{position:fixed;top:0;left:0;z-index:1000;width:95%;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);background-color:#fff}@media only screen and (min-width:750px){.modal{width:70%}}.modal__header{position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:1.7rem 1.7rem .56667rem;box-shadow:0 0 20px 0 rgba(0,0,0,.09)}.modal__body{height:65vh;overflow-y:auto;overflow-x:hidden}.modal__content{margin:.85rem 0}.modal__close{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:2rem;height:2rem;margin-right:0;margin-top:0;border-radius:50%;color:#263238;transition:all .3s ease-in-out;background-color:#f7f7f7}@media only screen and (min-width:750px){.modal__close{position:absolute;top:-2.4rem;right:0}}.modal__close:hover{color:#fff;background-color:#d62d20}.modal.alert{width:400px}.modal.alert .modal__body{min-height:10vh;height:auto;max-height:80%}.calendar{margin-bottom:.85rem}.calendar__header{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.calendar__header-days{display:-ms-flexbox;display:flex;width:100%;background-color:#2365ad}.calendar__header-day{padding-top:.425rem;text-align:center;width:14.28571%;color:#fff}.calendar__body{-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;background-color:#fefefe}.calendar__body,.calendar__tag{display:-ms-flexbox;display:flex}.calendar__tag{-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:2.5em;padding:0 1em;border-radius:1.2em;border:1px solid #ccc;margin-right:.56667rem;margin-bottom:.56667rem}@media only screen and (min-width:480px){.calendar__tag{margin-bottom:0}}.calendar__tag-title{color:#333}.calendar__day{-ms-flex-direction:column;flex-direction:column;-ms-flex-positive:0;flex-grow:0;position:relative;width:14.28571%;height:4.7em;margin:.425rem 0;border-bottom:1px solid #eee}.calendar__day,.calendar__day-number{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.calendar__day-number{text-align:center;width:1.9em;height:1.9em;margin-bottom:.2em;border-radius:50%;transition:all .3s ease-in-out}.calendar__day-number.justify{cursor:pointer}.calendar__day-number.justify.is-not-bottom{cursor:auto}.calendar__day-number.justify.is-not-bottom:hover{box-shadow:none}.calendar__day-number.absence{background-color:#ffebee;border:1px solid #f44336}.calendar__day-number.delay{background-color:#ffe0b2;border:1px solid #ff9800}.calendar__day-number.justify{background-color:#e3f2fd;border:1px solid #2196f3}.calendar__day-number.arrive{background-color:#f1f8e9;border:1px solid #8bc34a}@media only screen and (min-width:480px){.calendar__day-number{width:2.5em;height:2.5em}}@media only screen and (min-width:750px){.calendar__day-number{width:3em;height:3em}}@media only screen and (min-width:900px){.calendar__day-number{width:3.2em;height:3.2em}}@media print{.calendar__day{height:auto}.calendar__day-number{font-size:12px}}.input-field{margin-bottom:.85rem}.input-field__label{display:block;text-align:left;margin-bottom:.2125rem}.input-field__input{display:block;width:100%;padding:.6em .5em;border-radius:2em;border:2px solid #ccc}.message-error{width:340px;padding:.3rem;margin-top:.85rem;margin-bottom:.85rem;text-align:center;background-color:#ff5252;color:#fff}.notification{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:1.30769rem;height:1.30769rem;position:absolute;right:0;top:2px;border:2px solid #fff;border-radius:50%;background-color:#d62d20}.notification>span[class^=icon-]{color:#fff;font-size:12px}.u-hidden{display:none}.u-bold{font-weight:700}.u-hover{cursor:pointer}.u-hover:hover{opacity:.6}.u-mla{margin-left:auto}.u-gray{background-color:#ccc}.u-center{text-align:center}.u-fixed{position:fixed}.text-danger{color:red}.text-center{text-align:center}.m-auto{margin:auto}.mx-90{max-width:90%}.p-5{padding:1.5em}.main-header{position:fixed;top:0;left:0;z-index:900;width:100%;height:55px;box-shadow:0 0 20px 0 rgba(0,0,0,.09);background-color:#fff}.main-header__content{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;position:relative;height:100%}.main-header__logo{height:40px;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}@media only screen and (min-width:1170px){.main-header{-ms-flex-pack:end;justify-content:flex-end;margin-left:220px;width:calc(100% - 220px)}}@media only screen and (min-width:1170px){.btn--change{left:50%;transform:translateX(-100%);position:relative}}.login{width:340px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center}.login__title{padding-bottom:.85rem}.input-field__input{font-family:sans-serif}.navigation{position:fixed;z-index:800;top:0;left:0;width:220px;height:calc(100vh - 55px);margin-top:55px;box-shadow:4px 2px 2px 0 rgba(0,0,0,.1),3px 3px 1px -2px rgba(0,0,0,.1),1px 1px 5px 0 rgba(0,0,0,.12);overflow-y:auto;overflow-x:hidden;background-color:#002854;transition:all .4s ease-in-out;transform:translate(-110%)}.navigation.is-show{transform:translateX(0)}.navigation__user-profile{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;padding:.85rem}.navigation__wrapper-image{position:relative;overflow:hidden;width:6em;height:6em;margin-bottom:.85rem;border-radius:50%}.navigation__user-image{position:absolute;top:-20%;width:100%}.navigation__user-image.t-0{top:0}.navigation__user-name{margin-bottom:.85rem;color:#fff}.navigation__item{height:55px;cursor:pointer;transition:all .4s ease-in-out}.navigation__link{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;width:100%;height:100%;padding:0 .85rem;color:#fff}.navigation__link>span[class^=icon-]{margin-right:.56667rem;font-size:1.2em}.navigation__link:hover{text-decoration:none}.navigation__link.is-active,.navigation__link:hover{background-color:#21548c}@media only screen and (min-width:1170px){.navigation{margin-top:0;height:100vh}}.profile{max-width:400px;margin-left:auto;margin-right:auto}.profile.vertical{display:-ms-flexbox;display:flex}.profile__edit{-ms-flex-item-align:end;align-self:flex-end;background-color:#ccc;width:2em;height:2em}.profile__wrapper-image{position:relative;overflow:hidden;width:9em;height:9em;margin:0 auto;margin-bottom:.85rem;border-radius:50%}.profile__wrapper-image.small{width:7.5em;height:7.5em}.profile__wrapper-image.x-small{width:3.6em;height:3.6em}.profile__user-image{position:absolute;top:-15%;left:50%;transform:translateX(-50%);width:100%}.profile__user-image.parent{position:static;top:auto;left:auto;transform:translateX(0)}.profile__description{margin-top:.85rem}.profile__user-option{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100%;height:100%;background:#000;opacity:0;position:absolute;top:0}.profile__wrapper-image:hover .profile__user-option{opacity:.5}.horary{width:100%;margin-bottom:.85rem}.horary__header,.horary__hours{display:none;background-color:#fff}.horary__data--desktop{display:none;color:#000}.horary__column{width:100%}.compensation{padding:0 .425rem}.course-horary,.day{margin-bottom:.85rem}.course-horary{padding:.425rem}@media only screen and (min-width:1170px){.horary--movile{display:none}.horary{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}.horary__data--desktop,.horary__header,.horary__hours{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.horary__hours{-ms-flex-align:center;align-items:center;border-bottom:1px solid #ccc}.horary__header{height:50px}.horary__body{height:550px;margin-bottom:1.7rem}.horary__body,.horary__cell{display:-ms-flexbox;display:flex}.horary__cell{-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#21548c}.horary__cell-title{color:#fff}.horary__column,.horary__column--desktop{height:100%}.horary__column{border-bottom:1px solid #ccc;width:16.66667%}.day{background-color:transparent;box-shadow:none;padding:0;height:100%;color:#fff}.day__title{display:none}.course--desktop{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:.56667rem;border-left:1px solid #ccc;border-top:1px solid #ccc;background-color:#f7f7f7}.course--desktop:first-child{border-top:0}.texto-curso{text-align:center}.column-w{width:16.66667%}}.course{position:relative}.course__header{height:3em}.course__header,.course__message{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.course__message{background-color:hsla(0,90%,72%,.7);position:absolute;top:0;left:0;-ms-flex-direction:column;flex-direction:column;height:100%;width:100%}.main-content--login{position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;overflow:hidden;min-height:100vh}.main-content--login:before{content:\"\";position:absolute;display:block;width:100%;height:100%;background:linear-gradient(90deg,#fff,#7ac9ef);z-index:-100}.logo{height:82px;margin-bottom:.85rem}@media only screen and (min-width:900px){.logo{height:120px}}.login__bg{position:absolute;bottom:0;width:100%;z-index:-100}.login__bg,.login__bg svg{display:block}.line-curve.blue{fill:#007ec0}.line-curve.light-blue{fill:#d6eefa}.wrapper{margin-top:55px}@media only screen and (min-width:1170px){.wrapper{margin-left:220px}}.target{position:relative;z-index:500;min-height:30vh}.font-size-x-small{font-size:9px}.font-size-small{font-size:12px}.font-size-regular{font-size:15px}.font-size-large{font-size:19px}.font-size-x-large{font-size:24px}.font-size-xx-large{font-size:29px}@media print{.font-size-large,.font-size-regular,.font-size-small,.font-size-x-large,.font-size-x-small,.font-size-xx-large{font-size:10px}}.font-weight-light{font-weight:200}.font-weight-regular{font-weight:400}.font-weight-bold{font-weight:600}.font-family-regular{font-family:Lato Regular}.font-family-bold{font-family:Lato Bold}.font-family-mono{font-family:Roboto Mono}.login__title,.title{margin-top:0;margin-bottom:0}.text--center{text-align:center}.text--left{text-align:left}.text--right{text-align:right}.text--uppercase{text-transform:uppercase}.red{color:#d62d20}.red-100{color:#ff8585}.blue-100{color:#2365ad}.green{color:#3ca241}.yellow{color:#f09607}.print__show{display:none}.print__img{position:relative;left:50%;transform:translateX(-50%);height:40px}@media only screen and (min-width:750px){.print__img{position:absolute;left:0;transform:translateX(0)}}.print__title{display:none}@media print{.print__img{position:absolute;left:0;transform:translateX(0)}.print__show{display:block}.print__header{display:block;top:0;min-height:2cm}.print__section{min-height:10cm}.print__m-t{margin-top:5.5cm}.print__title{display:block;text-align:center;font-size:24px;font-weight:700}.horary--movile{display:none}.horary{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}.horary__data--desktop,.horary__header,.horary__hours{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.horary__hours{-ms-flex-align:center;align-items:center;border-bottom:1px solid #ccc}.horary__header{height:50px}.horary__body{height:550px;margin-bottom:1.7rem}.horary__body,.horary__cell{display:-ms-flexbox;display:flex}.horary__cell{-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#21548c}.horary__cell-title{color:#fff}.horary__column,.horary__column--desktop{height:100%}.horary__column{border-bottom:1px solid #ccc;width:16.66667%}.day{background-color:transparent;box-shadow:none;padding:0;height:100%;color:#fff}.day__title{display:none}.course--desktop{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:.56667rem;border-left:1px solid #ccc;border-bottom:1px solid #ccc;background-color:#f7f7f7}.texto-curso{text-align:center}.column-w{width:16.66667%}.table.header-fixed .table-body{max-height:none;overflow:hidden}.table-row-item{padding:0}}.fade-enter-active{transition:opacity .2s ease}.fade-leave-active{transition:opacity .4s cubic-bezier(1,.5,.8,1)}.fade-enter,.fade-leave-to{opacity:0}.slide-fade-enter-active{transition:all 1s ease}.slide-fade-leave-active{transition:all 1.5s cubic-bezier(1,.5,.8,1)}.slide-fade-enter,.slide-fade-leave-to{transform:translateX(10px);opacity:0}.slide-fade-top-enter-active{transition:all .3s ease}.slide-fade-top-leave-active{transition:all .6s cubic-bezier(1,.5,.8,1)}.slide-fade-top-enter,.slide-fade-top-leave-to{transform:translateY(10px) scale(.7);opacity:0}", ""]);

// exports


/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "data:font/ttf;base64,AAEAAAANAIAAAwBQRkZUTXrGOSoAAA9sAAAAHEdERUYAPwAGAAAPTAAAACBPUy8yT/tctAAAAVgAAABWY21hcB5qLFkAAAHcAAABaGdhc3D//wADAAAPRAAAAAhnbHlm94giRgAAA2wAAAmUaGVhZA+h11cAAADcAAAANmhoZWEEKgIFAAABFAAAACRobXR4Bt8BbQAAAbAAAAAsbG9jYRYOE6QAAANEAAAAJm1heHAAYwCBAAABOAAAACBuYW1lb/VH7QAADQAAAAGVcG9zdBwd0JIAAA6YAAAAqwABAAAAAQAAdGdhIF8PPPUACwIAAAAAANdESy0AAAAA10RLLQAAAAAB+wIAAAAACAACAAAAAAAAAAEAAAIAAAAALgIAAAAAAAH7AAEAAAAAAAAAAAAAAAAAAAAEAAEAAAASAH4ADwAAAAAAAgAAAAEAAQAAAEAAAAAAAAAAAQIAAZAABQAIAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAIABQkAAAAAAAAAAAABAAAAAAAAAAAAAAAAUGZFZABAAGEAbwHg/+AALgIAAAAAAAABAAAAAAAAAgAAAAAAAAACAAAAAgAAQAAAABIAJQAgAFUAQAAgAEAAJQBQAAAABgAgACUAAAADAAAAAwAAABwAAQAAAAAAYgADAAEAAAAcAAQARgAAAAYABAABAAIAAABv//8AAAAAAGH//wAAAAAAAQAAAAQAAAAMAAoAAwAEAAUABgAHAAgACQALAA0ADgAPABAAEQAAAQYAAAEAAAAAAAAAAQIAAAACAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCgMEBQYHCAkLDQ4PEBEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAKoBVAHMAlACagKUAtgDCgOWA8AEBAQuBFIEygAAAAEAQABAAcABwAAKAAAlJwczFTM1MxUzNQHAwMAwYGBg4ODgoICAoAAFAAAAAAHbAgAAGQAdADEARQBtAAAlBwYjIi8BJjU0PwE2MzIfATc2MzIfARYVFAUhESE3NTQnJisBIgcGHQEUFxY7ATI3Njc1NCcmKwEiBwYdARQXFjsBMjc2NxEUBwYjISImNRE0NjsBNTQ3NjsBMhcWHQEzNTQ2OwEyFh0BMzIXFgF0kgQDAgRSAwMNAgQDBD5/BAMCBA0D/q4Bkv5ubQICBRIFAgICBAMSAwQC3AMCBBMFAQMDAgQTAgQDbQoNDf5uDxYWDyQODRMSEw0ObhoTExMaJQ0NCu2TAgJTAQUFAQ4CAj9/AgIOAQUFyQEkN1IDBAICBANSAwQCAgQDUgQDAgIDBFIEAwICAxb+kxAKCxYPAW0PFhsTDg0NDhMbGxQaGhQbCwoAAAAPABIAAAHuAgAAAwAHAAsADwATABcAGwAfACMANwA7AD8AQwBXAH0AADczNSMXMzUjJzM1IxczNSMnMzUjEzM1IyczNSMTMzUjJzM1Iyc1NCcmKwEiBwYdARQXFjsBMjc2FzM1IyczNSMXMzUjNzU0JyYrASIHBh0BFBcWOwEyNzY3ERQGIyEiJjURNDY7ATU0NzY7ATIWHQEzNTQ2OwEyFxYdATMyFjdSUmRcXGRSUmRcXGRSUtJcXG5cXNxSUm5cXGQDAgUSBAIDAwMDEgQDA9JSUm5cXG5SUgkDAgQSBQIDAwMEEgMDA24WD/5uDxYWDyQODRMSFBpuGhQSEw0OJA8WJVJSUhJcXFwSUv7cUoBS/txSElybUgQDAgIDBFIEAgMDAvNcElJSUjdSBAMCAgMEUgQCAwMCFv6TDxYWDwFtDxYbEw4NGhQbGxQaDQ4TGxYABQAlAAAB2wIAAAYAHAAwAEQAVgAAARYXIzUWFwczERQHBiMhIicmNRE0NzY7ARUUFxYXNTQnJisBIgcGHQEUFxY7ATI3Nj0BNCcmKwEiBwYdARQXFjsBMjc2PQE0JisBIgYdARQXFjsBMjc2AcgCBocIAhObCAgL/oALCAgICAvlCAg5AwQCygIEAwMEAsoCBAMDAgTKBAIDAwQCygIEAwYDygMGAwMDygMDAwF4AgiHBgKk/tIMBwgIBwwBygwHCJsNBwjSEgQDAgIDBBIEAwICA00SBAMCAgMEEgQDAgIDTRIEBgYEEgUBAwMBAAAABgAgACAB4AHgABMAIQA0AEIASgBgAAA3NTQ3IyIOAR0BFBYfARUzNSIuATUyNzI1NzY1NCYiBhQWBSMXFRQGDwEVMzUyPgE9ATQuAScXFjMWMzI2NCYiBhUUBjI2NCYiBhQXNC4BKwEiDgEdARQWHwEVMzUyPgE1gAREBAoSEAgIYAQKEgwLAQIWHCgcHAFURAQQCAhgBAoSAhBoAQEBCg0UHBwoHGQoHBwoHJACEA6ABAoSEAgIgAQKEsCgBwkCEA5wDhABAaCAAhDOBgEBDhoUHBwoHBAQoA4QAQGAoAIQDnAEChIYAQEGHCgcHBQaFhwoHBwoTAQKEgIQDnAOEAEBoKACEA4AAQBVAAABqwHsAAsAABMHJxEFESc3FxUzNb5cDQEW0S3OFgHsRAP+lUABazEjKqrRAAAAAAUAQABAAcABwAADAAcACwAPABMAABMRIREDIREhATM1IyUhFSE1IRUhQAGAIP7AAUD+4MDAAQD/AAEA/wABAAHA/oABgP6gAUD/ACBAIGAgAAAAAAcAIAAgAeABwAAXABsAHwAjACcAKwAvAAABIzUhFSMiBh0BFBY7ARUhNTMyNj0BNCYDIzUzNSM1MxcjNTMFMxUjFTMVIxUzFSMBqCj/ACgXISIWKAEAKBYiIU/g4ODgMBER/wDAwMDAwMABgEBAHBt7GyNwcB8Xgxod/rCwoDBwEJAQIBAgEAABAEAAQAHAAcAAHgAAJSc3NjQnJiIPAScmIgYUHwEHBhQXFjI/ARcWMjc2NAG2g4MKCgsdC4ODCh0WC4KCCwsLHAuDgwsdCwp9g4MLHAsLC4KCCxYcC4ODCh4LCgqDgwoKCx0ABgAlAAAB2wIAABgAHwApADsATwBjAAABFhcWFREUBwYjISInJjURNDc2MyEyFxYXBxUzJi8BJhMRIyInJj0BIxE3NDY7ATIWHQEUBwYrASInJjUXMhcWHQEUBwYrASInJj0BNDc2MxcyFxYdARQHBisBIicmPQE0NzYzAcgIBgUICAv+gAsICAgICwEADA0QBiZsAwRZA2V3CwgI3EkGA8oDBgMDA8oDAwPTBAIDAwQCygIEAwMCBMoCBAMDBALKAgQDAwQCAZMIDQsO/rYMBwgIBwwBygwHCAYHBhRrCQJaA/5PASQIBw12/kr2BAYGBBIFAQMDAQUuAgMEEgQDAgIDBBIEAwJJAgMEEgQDAgIDBBIEAwIAAAEAUAB3AbABiQAZAAATBwYVFB8BFjI3Ni8BMzI2NCYrATc2NCcmIr1kCQlkCRoJExMx2Q0SEg3ZMQkJCRoBgGkJDg0JagkJFxcyExoTMgoaCgkAAAYAAAAAAeACAAAGAA0AIQAlACkALQAANxUzNSMHHwEzNzUjFTM3NTQrASIdASM1NCsBIh0BIxEhESczFSMlMxUjASERIYY9LUIMnEVjrWhBEEAQoBBAEEAB4IAgIP8AICABYP5gAaD4qOESMJ+xLzTEMBAQMDAQEDD+QAHAIEBAQP6AAUAAAAABAAYAOAH7AcQAFgAAATYVESEiJj8BNh8BFjcyPwE2HwEWPwEB8wj+EgUEBHYLCSYIAwYDUQgLOQsJdgHECw3+dggFkwwLIgQBBXoPDTULDcIAAAADACAAIAHgAeAAAwANABAAADcnNxc3JyYiDwEXNzY0AQc3o1v7WjswCRoKLVstCv5gIHVIW/paZTAICi1bLQoa/vZ1IAAAAAACACUAJQHbAdsAKgBTAAAlFQYHBiMiJyYnBwYiJyY9ATQ2OwEyFxYUDwEWFxYzMjc2NzY3NjsBMhcWNxUUBisBIicmND8BJiMiBwYHBgcGKwEiJyY9ATY3NjMyFxYXNzYyFxYB1BI7OFAqJyceJQcMBwUKCIAIBQUFJxUZGB0mISAWBAsCBjcFAgIHCgiACAUFBSgqOiYhIBYECwIGOQUCAhI7OVAqJykdJQcMBwXSAksxLw8QHSUFBQUIgAgKBQcMBycTCgoSEiEJGQYCBOKACAoFBwwHJycSEiEJGQYCBAMCSzEvDxEcJQUFBQAAAAAAAAwAlgABAAAAAAABAAkAFAABAAAAAAACAAQAKAABAAAAAAADACUAeQABAAAAAAAEAAkAswABAAAAAAAFAAsA1QABAAAAAAAGAAkA9QADAAEECQABABIAAAADAAEECQACAAgAHgADAAEECQADAEoALQADAAEECQAEABIAnwADAAEECQAFABYAvQADAAEECQAGABIA4QBjAGkAbQBhAC0AcAByAGUAdQAAY2ltYS1wcmV1AABwAHIAZQB1AABwcmV1AABGAG8AbgB0AEYAbwByAGcAZQAgADIALgAwACAAOgAgAGMAaQBtAGEALQBwAHIAZQB1ACAAOgAgADEAMQAtADYALQAyADAAMQA4AABGb250Rm9yZ2UgMi4wIDogY2ltYS1wcmV1IDogMTEtNi0yMDE4AABjAGkAbQBhAC0AcAByAGUAdQAAY2ltYS1wcmV1AABWAGUAcgBzAGkAbwBuACAAMQAuADAAAFZlcnNpb24gMS4wAABjAGkAbQBhAC0AcAByAGUAdQAAY2ltYS1wcmV1AAAAAAACAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAABIAAAABAAIBAgEDAQQBBQEGAQcBCAEJAQoBCwEMAQ0BDgEPARAEaG9tZQpjYWxlbmRhci0xBmhvcmFyeQRmaWxlBHRlYW0EYm9vawVub3RlcwdwcmludGVyBWNsb3NlCWZpbGUtdGV4dAVhcnJvdwVldmVudAdwYXltZW50BGVkaXQHcmVmcmVzaAAAAAAB//8AAgABAAAADgAAABgAAAAAAAIAAQADABEAAQAEAAAAAgAAAAAAAQAAAADMPaLPAAAAANdESy0AAAAA10RLLQ=="

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cima-preu.svg?50bfd4daccaa969cccc82fc47d3bf157";

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;base64,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"

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;base64,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"

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = "data:font/woff2;base64,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"

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js